import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { mailFolderListItems, otherMailFolderListItems } from '../leftnav';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import wait from '../reports/loader/wait.svg';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StockPrescriptionIcon from '@mui/icons-material/Unarchive';
import AssignPrescriptionIcon from '@mui/icons-material/NoteAdd';
import ReviewPrescriptionIcon from '@mui/icons-material/CheckCircle';
import SignOutIcon from '@mui/icons-material/PowerSettingsNew';
import BellIcon from '@mui/icons-material/Notifications';
// import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Badge from '@mui/material/Badge';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { navigate } from '@reach/router';
import Amplify from 'aws-amplify';
import { Auth } from 'aws-amplify';
import ReportLink from '../leftnav/reportlink';
import ManagemenuLink from '../leftnav/Managemenulink';
import UserPopUpNotification from '../userPopUpNotification';
import { playNotificationSound, stopNotificationSound, playLightBeepSound, stopLightBeepSound, testAudioPlayAllowed } from '../../config/notification-handler';
/*
  Added By : Belani Jaimin
  Added Date :01/08/2018
*/
/*********************** Start *************************** */
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
/*********************** End *************************** */
import packageJson from '../../../package.json';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import TextareaAutosize from 'react-autosize-textarea';
import { toast } from 'react-toastify';
import ilocalboxAvatarlogo from './images/ilocalboxlogo.png';
/**
 * Added By : Mahesh Soni
 * Added Date :02/20/2021
 * Description: importing crypter for enccrupting password for creating secure badge
 * */
import defaultLoader from './images/loader.gif';
import {
  deleteFirebaseToken,
  getFirebaseToken,
  onMessageListenerFCM,
} from '../../config/firebase';
import io from 'socket.io-client';
import { Box, Grid, InputLabel, ListItemIcon, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AttachEmail } from '@mui/icons-material';
import { Link } from '@reach/router';
import { NotificationWrapperComponent } from '../common/NotificationWrapperComponent';
import { withTranslation } from 'react-i18next';
import connectionType from '../common/connection-type';
import updateLiveConsult from '../common/apis';
import TwilioVideo from '../TwilioProgrammableVideo/TwilioVideo';
import IncomingCallNotification from './IncomingCallNotification';
import HeldCallsPanel from './HeldCallsPanel';
import Select from '@mui/material/Select';
import SearchableSelect from '../common/SearchableSelect';
import localtionImage from './images/lb.png';
import secureBadgeImg from './images/secureBadgeImg.png';

import MaskedInput from 'react-text-mask';
import * as serviceWorker from "../../serviceWorker";
import {
  Radio, RadioGroup, FormControl,
  // FormLabel 
} from '@mui/material';
import PrintTemplate from 'react-print';
import { writeAuditLog } from '../common/apis';
import { restoreTokenExpiryTimer, clearTokenExpiryTimeout, setupTokenExpiryHandler, writeAuditLogWithTokenCheck } from '../../utils/tokenExpiryHandler';
import {
  logConsultAccepted,
  logConsultDeclined,
  logConsultStarted,
  logConsultEndedByPharmacist,
  logConsultEndedByPatient,
  logConsultTimeout,
  logConsultResumed,
  logConsultAcceptedByAnother,
  logIncomingCallReceived,
  logIncomingCallDeclined,
  logIncomingCallSilenced,
  logIncomingCallEndAndAccepted,
  logIncomingCallHoldAndAccepted,
  logCallPutOnHold,
  logHeldCallResumed,
  logHeldCallDeclined,
  logConsultAcceptFailed,
  logConsultHoldFailed,
  logConsultResumeFailed,
  logConsultEndFailed,
  logConsultSilenceFailed,
  logWebSocketStatusOnIncomingCall,
  logMainSocketInitialConnectionFailed,
  logMainSocketConnectionRecovered,
  logPresenceSocketInitialConnectionFailed,
  logPresenceSocketConnectionRecovered,
} from '../../utils/consultationAuditLogger';
import moment from 'moment';
import ConsultSettingsPopup from '../common/ConsultSettingsPopup';
import LOCATION_TYPE from '../enum/location_type';
import TestConsultationPopup from '../common/TestConsultationPopup';
import DeviceStatusAlertDialog from '../common/DeviceStatusAlertDialog';
import debounce from 'lodash/debounce';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { MultiTabContext } from '../../context/MultiTabContext';
import TourGuide from '../tour/TourGuide';
import AudioVisualizer from '../common/AudioVisualizer';

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

// Helper function to safely get service worker (handles Chrome on iOS/iPad where it may be undefined at module load)
const getServiceWorker = () => {
  if (typeof navigator === 'undefined') return null;
  return 'serviceWorker' in navigator ? navigator.serviceWorker : null;
};

// Device issue titles mapping - used for warning icon dialog
const DEVICE_ISSUE_TITLES = {
  'PERMISSION_DENIED': 'Camera Permission Denied',
  'DEVICE_NOT_FOUND': 'Camera Not Found',
  'CAMERA_IN_USE': 'Camera In Use',
  'HTTPS_REQUIRED': 'Secure Connection Required',
  'UNSUPPORTED_BROWSER': 'Browser Not Supported',
  'MEDIA_ACCESS_ERROR': 'Media Access Error'
};

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_CG_REGION,
    userPoolId: process.env.REACT_APP_CG_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_CG_WEBCLIENTID,
  },
});

const drawerWidth = localStorage.getItem('i18nextLng') === 'en' ? 276 : 420;
//create date prototype for date format for duration calculation
const padLeft = (chr) => {
  console.log(`⚙️ [Function] Home.padLeft: Processing character`, { chr });
  const base = 10;
  const len = String(base || 10).length - String(chr).length + 1;
  return len > 0 ? new Array(len).join('0') + chr : chr;
};
window.state = false;
const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
  },
  appBar: {
    position: 'fixed',
    height: '55px',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: '#00a7e1 !important',
    color: '#fff !important',
    marginTop: '1%'
  },
  appBarShift: {
    position: 'fixed',
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: '14px !important',
    marginRight: '12px !important',
    color: 'white',
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    maxWidth: '72px',
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '72px',
    [theme.breakpoints.up('sm')]: {
      width: '72px',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  contentWithMiniLeftNav: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 72,
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: 56,
    },
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    flexGrow: 1,
    // backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  content: {
    // [theme.breakpoints.up('sm')]: {
    marginLeft: localStorage.getItem('i18nextLng') === 'en' ? 276 : 420,
    // },
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    flexGrow: 1,
    // backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  contentFullWidth: {
    marginLeft: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },
  flex: {
    //paddingLeft: '1rem',
    flex: 1,
    fontSize: '1.3125rem',
    fontWeight: '500',
  },
  rightIcon: {
    paddingRight: 12,
    padding: 11,
  },
  avatar: {
    // margin: 10,
  },
  userName: {
    float: 'right',
    lineHeight: '49px',
    paddingLeft: '6px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    cursor: 'pointer',
    marginTop: '11px',
  },
  signOutButton: {
    '&.MuiButtonBase-root': {
      float: 'right',
      marginRight: '10px !important',
      color: '#fafafa',
    },
  },
  bellButton: {
    color: '#fafafa',
    //paddingLeft: '10px',
    marginRight: '10px',
  },
  bellBadge: {
    color: '#d32f2f',
  },
  badgeColor: {
    color: 'white',
  },
  bottomNav: {
    width: '100vw',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 10000,
    backgroundColor: '#EFEFEF',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  errorText: {
    paddingTop: '10px',
    color: 'red',
  },
  /* Added By :Belani Jaimin */
  /******************* START ******************/
  iOSSwitchBase: {
    '&$iOSChecked': {
      color: '#ef8d22',
      '& + $iOSBar': {
        backgroundColor: '#fff !important',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  iOSChecked: {
    transform: 'translateX(20px)',
    '& + $iOSBar': {
      opacity: 1,
      border: 'none',
    },
  },
  iOSBar: {
    borderRadius: '10px',
    width: 70,
    height: 31,
    marginTop: -15,
    marginLeft: -32,
    border: 'solid 1px',
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  iOSIcon: {
    width: 50,
    height: 28,
    //background:'#efefef',
    border: '1px solid #e3e3e3',
    borderRadius: '10px !important',
  },
  iOSIconChecked: {
    boxShadow: theme.shadows[1],
  },
  DialogText: {
    color: 'black',
  },
  DialogContentWrap: {
    width: '500px',
  },
  ButtonAlign: {
    justifyContent: 'space-around',
    paddingBottom: '20px',
  },
  loader: {
    justifyContent: 'center',
    textAlign: 'center',
    position: 'absolute',
    width: '100%',
    left: 0,
    top: '0%',
    height: '100%',
    zIndex: '999999',
    display: 'flex',
    background: 'rgba(255,255,255,0.3)',
  },
  loaderImage: {
    width: '80px',
    zIndex: ' 999999999',
    position: 'absolute',
    top: '25%',
  },
  buttonFace: {
    color: '#387371',
  },
  footer: {
    //background: '#0a5d66',
    background: '#00a7e1 !important',
    color: '#fff !important',
    padding: '0px 24px',
    //boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    position: 'fixed',
    width: '100%',
    zIndex: '9999',
    bottom: 0,
    fontSize: '14px',
    fontWeight: '400',
  },
  consultDialogBox: {
    width: '100%',
    border: '4px solid dodgerblue',
    borderRadius: '60px',
  },
  consultDialogTitle: {
    textAlign: 'center',
    color: 'dodgerblue',
    paddingTop: '16px',
  },
  consultLocationName: {
    color: 'dodgerblue',
  },
  consultDialogText: {
    color: 'black',
    marginBottom: '8px',
  },
  consultDialogSecondaryText: {
    color: '#888',
    fontSize: '0.8rem',
  },
  consultDialogDataContainer: {
    textAlign: 'center',
    margin: '0 23% 0',
  },
  consultDialogPatientImage: {
    width: '120px',
    height: '120px',
    marginBottom: '7%',
    borderRadius: '60px',
  },
  consultDialogButtons: {
    marginTop: 0,
    paddingBottom: '5%',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff !important',
    '&:hover': {
      background: '#6cca98',
      color: '#fff !important',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  preferrendLocationTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: "5px",
  },
  preferrendLocationImageParent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  preferrendLocationContentTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    fontWeight: "500",
    textAlign: "center",
    marginBottom: "3%",
    lineHeight: "1.2em",
  },
  preferrendLocationContentSubTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.87rem",
    textAlign: "center",
    lineHeight: "1.2em",
  },
  preferrendLocationContentDropDown: {
    marginTop: "5px",
    width: 390,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  preferrendLocationDialogAction: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: '3% 3%'
  },
  preferrendLocationDialogActionButtonFace: {
    color: "#fff",
    height: '56px',
    width: '120px',
    marginLeft: '16px',
  },
  preferredLocationLoader: {
    background: 'rgba(0,0,0,0.5)',
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: '99999'
  },
  preferredLocationLoaderImage: {
    left: '45%',
    top: '45%',
    position: 'absolute'
  },
  preferredLocationError: {
    color: "red",
    margin: "0px 4%"
  }
  /******************* END ******************/
});

let kioskNotificationInterval = null;

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
    />
  );
}

/**
 * Consultation Test Cases:
 * 1. One-to-one consultation
 *    1.1. Connect user accepts the call, then consult popup should open & audit log with text should be "Call Accepted by User"
 *    1.2. Connect user declines the call, then consult popup should not open & audit log with text should be "Call Declined by User"
 *    1.3. Connect user ends the call, then consult popup which is opened should be closed & audit log with text should be "Call Ended by User"
 *    1.4. Kiosk user ends the call before/after connect user accepts the call, then popup & audit log should show the text "Caller hung up."
 *    1.5. No action is performed on connect side by user, then popup & audit log should show the text "Missed call."
 * 
 * 2. Multiple users consultation
 *    2.1. If one connect user accepts the call, then show "Call has been accepted by another user." to other connect users
 *    2.2. If one connect user declines the call, then it should allow users to either accept or decline the call.
 *    2.3. If no action is performed on connect side by any user, then popup & audit log should show "Missed call." to all users.
 *    2.4. If kiosk user ends the call before/after connect user accepts the call, then popup & audit log should show the text "Caller hung up."
 */
class Home extends React.Component {
  static contextType = MultiTabContext;
  
  constructor(props) {
    console.log(`📱 [Lifecycle] Home.constructor: Initializing component`);
    super(props);
    this.state = {
      open: window.innerWidth > 768,
      openNotification: window.innerWidth > 768, //Added by Naresh | DI-461 | Date:16-04-2019
      anchorEl: null,
      anchorElNotification: null,
      value: 0,
      checkedB: false,
      consultOpen: false,
      showConsultAudioPermissionDialog: false,
      consultToggleLoading: false,
      PatientName: '',
      Notifications: {},
      // Phase 1: Incoming Call Notification During Active Call
      incomingCalls: [], // Queue of incoming calls when active call exists
      silencedCalls: [], // Track silenced incoming calls by pucode (array for state)
      // Phase 2: Hold & Switch - Multi-call management
      heldCalls: [], // Array of calls on hold: { pucode, notificationId, patientName, location, holdStartTime, notificationData }
      activeCallDetails: null, // Details of active call: { pucode, notificationId, patientName, location, startTime }
      isCallOnHold: false, // Flag to indicate if the remote patient should see "on hold" state
      // WebSocket Connection Status Tracking
      mainSocketStatus: 'disconnected', // 'connected' | 'connecting' | 'disconnected' | 'error'
      mainSocketError: null,
      presenceSocketStatus: 'disconnected', // 'connected' | 'connecting' | 'disconnected' | 'error'
      presenceSocketError: null,
      // WebSocket Initial Connection Audit Tracking
      mainSocketInitialFailureLogged: false,
      mainSocketRecoveryPending: false, // True when we need to log recovery on successful connect
      presenceSocketInitialFailureLogged: false,
      presenceSocketRecoveryPending: false,
      //Vidyo part
      microphones: {},
      speakers: {},
      cameras: {},
      /* screen sharing */
      screenShares: {},
      isSharing: false,
      /* toolbar props */
      buttonsAvailable: false,
      participantStatus: '',
      connectionStatus: '',
      clientVersion: '',
      screenShareButtonState: true,
      microphoneButtonState: true,
      joinLeaveButtonState: true,
      cameraButtonState: true,
      /* EntranceForm props */
      hosts: 'prod.vidyo.io',
      resourceId: 'iLocalBoxRoom',
      displayName: 'iLocalBox',
      vidyoConnectors: null,
      startConsult: false,
      isCallActive: false, // Track if there's an active video call (separate from dialog being open)
      consultStartTime: null, // Track when consultation actually started
      SetConsultOn: 0,
      LoggedInUserName: '',
      userConsultMaster: {},
      isUnplugged: false,
      tourWelcomeHidden: false,
      isPaymentRequired: false,
      rolepermission: [],
      isButtonDisabled: false,
      loader: false,
      Pickupcode: '',
      PatietPrescriptionData: '',
      consultationOrdersByPucode: [], // DI-5364: Multi pick-up - orders grouped by pucode for accordion
      PatientEmail: '',
      PatientPhone: '',
      PatientDOB: '',
      consultnotes: '',
      ReleaseOrder: false,
      ReleaseOrderOpen: false,
      isOpen: false,
      isdisable: false,
      notificationDetails: '',
      checked: false,
      consultpermission: false,
      userRole: null,
      ilocalboxAvatarprofile: ilocalboxAvatarlogo,
      isFirebaseNotification: false,
      firebaseNotification: { title: '', body: '' },
      consultRequestFCM: {},
      orderNotReleasedOpen: false,
      openConsultDiagnostics: false,
      checkedBDialog: false,
      isNormalConsult: false,
      consultAcknowledgeDialog: false,
      refreshServiceWorker: false,
      notificationData: {},
      notificationCount: 0,
      showWarning: false,
      showTroubleTitle: false,
      preferredLocation: false,
      selectedBoxId: '',
      boxList: [],
      hasCounterLocations: false,
      selectedLocationTypeId: '',
      hasPreferredLocationSelected: true,
      isInProgress: false,
      selectedReasonId: "",
      selectedReasonText: '',
      id_capture_type: 9,
      firstName: '',
      lastName: '',
      DLNo: '',
      dob: '',
      stateCode: '',
      IdRawData: '',
      IdData: "",
      expDate: '',
      cardType: '',
      relationship: '',
      browserTestDoNotAskMeAgain: false,
      showTestYourBrowserPopup: false,
      secureBadgeUserType: 'normal',
      qrCodeImg: '',
      showSecureBadgeCode: false,
      printSecureBadgeQR: false,
      secureBadgeAction: 'print',
      cameraAndAudioPermissions: null,
      isReleaseOrderProgress: false,
      secureBadgeExpirationDuration: '',
      loggedInUser: JSON.parse(sessionStorage.getItem('user')),
      loggedInUserParentAccountId: sessionStorage.getItem('parentAccountId'),
      loggedInUserBoxId: localStorage.getItem('selectedLocation'),
      prescriptionMasterId: '',
      missedCallAckDialog: false,
      missedCallCount: localStorage.getItem('missedCallCount') || 0,
      missedCallPatientName: '',
      consultSettingsAnchorEl: null,
      consultSettingsIsPopupOpen: false,
      consultError: '',
      showDeviceStatusAlertDialog: false,
      showDeviceStatusAlertDialogMessage: '',
      showDeviceStatusAlertDialogTitle: '',
      showDeviceStatusAlertDialogAudioOnlyButton: false,
      showDeviceStatusAlertDialogReason: '', // Tracks the reason for the alert (e.g., CAMERA_DISCONNECTED)
      wasConsultDisabledDueToCamera: false, // Tracks if consultation was auto-disabled due to camera disconnect
      deviceIssues: [], // Array of { id, title, message, reason, showAudioOnlyButton, timestamp } for device issue warnings
      showDeviceIssuesDialog: false, // Controls visibility of the device issues dialog
      isAudioOnlyConsult: false,
      remoteAudioStreamForVisualizer: null, // Remote (kiosk) audio for AudioVisualizer in main consultation flow
      errorCallAlreadyAcceptedDialog: false,
      errorCallAlreadyAcceptedMessage: '',
      showCallerHungUpModal: false,
      callAcceptedByOtherUser: false,
      failedMessageData: [],
      unReadCount: 0,
      resendingMessageId: null,
      lastMicInput: "",
      lastCallingDevice: "",
      lastMicCount: 0,
      lastSpeakerCount: 0,
      previousAudioInputs: [],
      previousAudioOutputs: [],
      // Session expiry warning dialog
      showSessionExpiryWarning: false,
    };
    this.debouncedHandleDeviceChange = debounce(this.handleDeviceChangeLogic, 500);
    this.handleConsultClose = debounce(this.handleConsultClose.bind(this), 500);

    console.log(`🔄 [State] Home.constructor: Initial state created`);

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeCreateSecureBadgePassword = this.handleChangeCreateSecureBadgePassword.bind(
      this
    );
    this.handleSubmitCreateSecureBadge = this.handleSubmitCreateSecureBadge.bind(
      this
    );
    this.handleSecureBadgeConfirm = this.handleSecureBadgeConfirm.bind(
      this
    );
    this.handleSecureBadgeUserAction = this.handleSecureBadgeUserAction.bind(
      this
    );
    this.twilio = null;
    this.incomingCallBeepInterval = null; // Interval for periodic beep sound
    this.fcmListenerInitialized = false; // Track FCM listener initialization to prevent multiple registrations
    this.oktaAuthClient = window.oktaAuthClient;
    this.maxTokenRefreshAllowance = 1;
    console.log(`📱 [Lifecycle] Home.constructor: Component initialization complete, open=${this.state.open}`);
    this.handleConsultAcknowledgeDialog = this.handleConsultAcknowledgeDialog.bind(
      this
    );
    let User = JSON.parse(sessionStorage.getItem('user'));
    !this.notificationSocket && this.initNotificationSocket({ User });
    setImmediate(async () => {
      !this.socket && (await this.initSocket());
    });
    
    // Tour Guide ref for manual tour trigger - using callback ref pattern
    this.tourGuideRef = { current: null };
    
    // Bind handleStartTour for menu callback
    this.handleStartTour = this.handleStartTour.bind(this);
  }

  // Start tour manually from Help & Tours menu
  handleStartTour() {
    console.log('[Home] handleStartTour called from Help & Tours menu', {
      timestamp: new Date().toISOString(),
      hasRef: !!this.tourGuideRef,
      hasCurrent: !!(this.tourGuideRef && this.tourGuideRef.current),
      refValue: this.tourGuideRef
    });
    
    if (this.tourGuideRef && this.tourGuideRef.current) {
      console.log('[Home] TourGuide ref is available, calling startTourManually');
      try {
        this.tourGuideRef.current.startTourManually();
        console.log('[Home] startTourManually called successfully');
      } catch (error) {
        console.error('[Home] Error calling startTourManually:', error);
      }
    } else {
      console.error('[Home] TourGuide ref not available - cannot start tour', {
        tourGuideRef: this.tourGuideRef,
        current: this.tourGuideRef ? this.tourGuideRef.current : 'N/A'
      });
    }
  }

  showDeviceErrorAlert = (title = 'Alert', message, showAudioOnlyButton = false, reason = '') => {
    this.setState({
      showDeviceStatusAlertDialog: true,
      showDeviceStatusAlertDialogTitle: title,
      showDeviceStatusAlertDialogMessage: message,
      showDeviceStatusAlertDialogAudioOnlyButton: showAudioOnlyButton,
      showDeviceStatusAlertDialogReason: reason,
    });
  };

  handleSwitchToAudioOnlyConsult = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) {
      console.error("No user found in session storage");
      this.setState({ showDeviceStatusAlertDialog: false });
      return;
    }

    const { showDeviceStatusAlertDialogReason, showDeviceStatusAlertDialogTitle } = this.state;

    try {
      // Update audio-only setting in the database
      await fetch(process.env.REACT_APP_BASEURL + 'userconsultupdateaudioonly', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
        },
        body: JSON.stringify({
          user_id: user.username,
          is_audio_only: true
        }),
      });

      console.log("Audio-only consult enabled successfully via camera error dialog.");

      // Audit log for user switching to audio-only mode - fire-and-forget for performance
      writeAuditLogWithTokenCheck(
        'User switched to Audio-Only Consult mode due to camera issue.',
        'Consultation',
        {},
        {
          eventType: 'CONSULT_SWITCHED_TO_AUDIO_ONLY',
          severity: 'INFO',
          metadata: {
            actor: 'USER',
            previousIssue: showDeviceStatusAlertDialogReason || 'UNKNOWN',
            alertTitle: showDeviceStatusAlertDialogTitle,
            timestamp: new Date().toISOString(),
          },
        },
        { deferMs: 0, wait: false }
      );

      // Update local state and remove camera-related issues in single setState
      this.setState(prevState => ({ 
        isAudioOnlyConsult: true,
        showDeviceStatusAlertDialog: false,
        showDeviceStatusAlertDialogReason: '',
        wasConsultDisabledDueToCamera: false, // Clear since user chose audio-only
        deviceIssues: prevState.deviceIssues.filter(i => !i.showAudioOnlyButton), // Remove camera-related issues
      }));

      // Now enable the consult toggle since audio-only doesn't require camera
      await this.handleSwitchChange(true);

    } catch (err) {
      console.error("Failed to switch to audio-only consult:", err);
      toast.error("Failed to switch to Audio-Only mode. Please try again.");
      this.setState({ showDeviceStatusAlertDialog: false });
    }
  };

  handleDismissDeviceStatusAlert = async () => {
    const { showDeviceStatusAlertDialogReason, showDeviceStatusAlertDialogTitle } = this.state;

    // Audit log for user acknowledging the consultation disabled alert
    if (showDeviceStatusAlertDialogReason) {
      await writeAuditLogWithTokenCheck(
        'User acknowledged consultation disabled alert.',
        'Consultation',
        {},
        {
          eventType: 'CONSULT_DISABLED_ACKNOWLEDGED',
          severity: 'INFO',
          metadata: {
            actor: 'USER',
            reason: showDeviceStatusAlertDialogReason,
            alertTitle: showDeviceStatusAlertDialogTitle,
            timestamp: new Date().toISOString(),
          },
        },
        { deferMs: 0, wait: false }
      );
    }

    this.setState({ 
      showDeviceStatusAlertDialog: false, 
      showDeviceStatusAlertDialogAudioOnlyButton: false,
      showDeviceStatusAlertDialogReason: '',
    });
  };

  // Helper method to add a device issue to the array (with deduplication)
  addDeviceIssue = (issue) => {
    this.setState(prevState => {
      // Avoid duplicates by checking id
      const exists = prevState.deviceIssues.some(i => i.id === issue.id);
      if (exists) return prevState;
      return { deviceIssues: [...prevState.deviceIssues, { ...issue, timestamp: new Date().toISOString() }] };
    });
  };

  // Helper method to remove a device issue by id
  removeDeviceIssue = (issueId) => {
    this.setState(prevState => ({
      deviceIssues: prevState.deviceIssues.filter(i => i.id !== issueId)
    }));
  };

  // Handler for clicking the device issue warning icon
  handleDeviceIssueIconClick = () => {
    this.setState({ showDeviceIssuesDialog: true });
  };

  // Handler for closing the device issues dialog
  handleCloseDeviceIssuesDialog = () => {
    this.setState({ showDeviceIssuesDialog: false });
  };

  // Handler for switching to audio-only from the device issues dialog
  handleSwitchToAudioOnlyFromIssuesDialog = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) {
      console.error("No user found in session storage");
      this.setState({ showDeviceIssuesDialog: false });
      return;
    }

    try {
      // Update audio-only setting in the database
      await fetch(process.env.REACT_APP_BASEURL + 'userconsultupdateaudioonly', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
        },
        body: JSON.stringify({
          user_id: user.username,
          is_audio_only: true
        }),
      });

      console.log("Audio-only consult enabled successfully via device issues dialog.");

      // Audit log for user switching to audio-only mode
      writeAuditLogWithTokenCheck(
        'User switched to Audio-Only Consult mode from device issues dialog.',
        'Consultation',
        {},
        {
          eventType: 'CONSULT_SWITCHED_TO_AUDIO_ONLY',
          severity: 'INFO',
          metadata: {
            actor: 'USER',
            source: 'DEVICE_ISSUES_DIALOG',
            issuesAtTime: this.state.deviceIssues.map(i => i.id),
            timestamp: new Date().toISOString(),
          },
        },
        { deferMs: 0, wait: false }
      );

      // Update local state and remove camera-related issues in single setState
      this.setState(prevState => ({ 
        isAudioOnlyConsult: true,
        showDeviceIssuesDialog: false,
        deviceIssues: prevState.deviceIssues.filter(i => !i.showAudioOnlyButton), // Remove camera-related issues
      }));

      // Ensure the consult toggle stays enabled
      if (!this.state.checkedB) {
        await this.handleSwitchChange(true);
      }

    } catch (err) {
      console.error("Failed to switch to audio-only consult:", err);
      toast.error("Failed to switch to Audio-Only mode. Please try again.");
      this.setState({ showDeviceIssuesDialog: false });
    }
  };

  initSocket = async () => {
    console.log(`🌐 [Network] Home.initSocket: Starting socket initialization`);
    
    // === PRESENCE TRACKING TEST (Serverless WebSocket) ===
    this.initPresenceTracking();
    
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */
      console.log(`🌐 [Network] Home.initSocket: User found, creating socket connection`);
      // Track connecting state
      this.setState({ mainSocketStatus: 'connecting', mainSocketError: null });
      this.socket = io(process.env.REACT_APP_VIDEO_SOCKET_BASEURL, {
        transports: ['websocket'],
        auth: {
          token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          isPortal: true,
          userId: this.user.id || this.user.username,
        },
        secure: true,
        reconnectionAttempts: 5,
        closeOnBeforeunload: true,
      });

      window.socket = this.socket;
      console.log(`🌐 [Network] Home.initSocket: Socket created, setting up event listeners`);

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', async () => {
          console.log(`🌐 [Network] Home.initSocket: Socket connection established from PORTAL(ReConnect) from dashboard`);
          this.setState({ mainSocketStatus: 'connected', mainSocketError: null });
          
          // Log recovery if we previously had an initial failure
          if (this.state.mainSocketRecoveryPending) {
            await logMainSocketConnectionRecovered();
            this.setState({ mainSocketRecoveryPending: false });
          }
        });
      this.socket &&
        this.socket.on('connect_error', async (error) => {
          console.log(`❌ [Error] Home.initSocket: Connect Error:`, error);
          this.setState({ mainSocketStatus: 'error', mainSocketError: error.message || 'Connection error' });
          
          // Only log initial failure once
          if (!this.state.mainSocketInitialFailureLogged) {
            await logMainSocketInitialConnectionFailed(error.message || 'Connection error');
            this.setState({ 
              mainSocketInitialFailureLogged: true,
              mainSocketRecoveryPending: true 
            });
          }
          
          // Handle Unauthorized error - likely token expiry related
          if (error.message && error.message.toLowerCase().includes('unauthorized')) {
            console.log('⏰ [TokenExpiry] Socket connection unauthorized, logging out');
            alert('Your session has expired or you are not authorized. Please log in again.');
            this.signOut();
            return;
          }
          
          if (
            this.maxTokenRefreshAllowance &&
            (error.message === 'TokenExpiredError' ||
              error.message === 'JsonWebTokenError' ||
              error.message === 'NoTokenFound')
          ) {
            if (this.maxTokenRefreshAllowance < 5) {
              console.log(`🌐 [Network] Home.initSocket: Token error, attempting refresh (attempt ${this.maxTokenRefreshAllowance})`);
              await this.refreshToken();
              this.socket && (await this.socket.disconnect());
              this.socket = false;
              console.log(`🌐 [Network] Home.initSocket: Initializing Socket with latest token.`);
              this.maxTokenRefreshAllowance += 1;
              await this.initSocket();
            } else {
              console.log(`❌ [Error] Home.initSocket: Max token refresh attempts exceeded.`);
              alert('Something went wrong! Please login again.');
              this.signOut();
            }
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log(`❌ [Error] Home.initSocket: Connect Failed:`, error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log(`❌ [Error] Home.initSocket: Socket error:`, error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(`🌐 [Network] Home.initSocket: Socket Disconnected. Reason:`, reason);
          this.setState({ mainSocketStatus: 'disconnected', mainSocketError: reason });
        });

      /**
       ** Socket Consult Event Starts **
       */
      console.log(`🌐 [Network] Home.initSocket: Setting up consult event handlers`);
      this.socket &&
        this.socket.on('callAccepted', (payload) => {
          // this event is triggered every time the video call gets accepted by one user from multiple users
          console.log(`🌐 [Network] Home.initSocket: Call accepted event received:`, payload);

          if (payload && payload.pucode && payload.pucode.toUpperCase().includes(this.state.Pickupcode.toUpperCase())) {
            this.handleConsultClose();
          }
        });
      this.socket &&
        this.socket.on('endSession', (payload) => {
          console.log(`🌐 [Network] Home.initSocket: End session event received:`, payload);
          
          // Phase 1: Check if this is a queued call that ended
          if (payload && payload.pucode) {
            // Normalize pucode for comparison (trim, lowercase)
            const endedPucode = (payload.pucode || '').toString().trim().toLowerCase();
            const activeCallPucode = ((this.state.Pickupcode || '').toString().trim().toLowerCase());
            
            // Get current incoming calls array (defensive check)
            const currentIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
            
            // Check if this pucode exists in the queue (normalize both for comparison)
            const isQueuedCall = currentIncomingCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              return callPucode === endedPucode;
            });
            
            console.log(`📞 [Phase 1] Home.endSession: Checking if queued call ended`, {
              endedPucode: endedPucode,
              activeCallPucode: activeCallPucode,
              isQueuedCall: isQueuedCall,
              isActiveCall: endedPucode === activeCallPucode,
              queueLength: currentIncomingCalls.length,
              queuePucodes: currentIncomingCalls.map(c => (c.pucode || '').toString().trim().toLowerCase())
            });
            
            // If it's a queued call (not the active call), clean it up
            if (isQueuedCall && endedPucode !== activeCallPucode) {
              console.log(`📞 [Phase 1] Home.endSession: ✅ Queued call ended, removing from queue`, {
                pucode: endedPucode,
                queueLengthBefore: currentIncomingCalls.length
              });
              
              // Remove from incoming calls queue
              this.setState(prevState => {
                const prevIncomingCalls = Array.isArray(prevState.incomingCalls) ? prevState.incomingCalls : [];
                const updatedIncomingCalls = prevIncomingCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                console.log(`📞 [Phase 1] Home.endSession: State update - removing call`, {
                  before: prevIncomingCalls.length,
                  after: updatedIncomingCalls.length,
                  removedPucode: endedPucode
                });
                
                // Stop beep sound if no more unsilenced calls
                const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
                if (!hasUnsilencedCalls) {
                  stopLightBeepSound();
                  console.log(`📞 [Phase 1] Home.endSession: No more unsilenced calls, stopped beep sound`);
                }
                
                return {
                  incomingCalls: updatedIncomingCalls,
                  silencedCalls: Array.isArray(prevState.silencedCalls) 
                    ? prevState.silencedCalls.filter(p => {
                        const silencedPucode = (p || '').toString().trim().toLowerCase();
                        return silencedPucode !== endedPucode;
                      })
                    : []
                };
              }, () => {
                // Callback after state update to verify
                console.log(`📞 [Phase 1] Home.endSession: State updated, new queue length:`, 
                  this.state.incomingCalls ? this.state.incomingCalls.length : 0
                );
              });
              
              return; // Don't process as active call
            }

            // Phase 2: Check if this is a HELD call that ended
            const currentHeldCalls = Array.isArray(this.state.heldCalls) ? this.state.heldCalls : [];
            
            // ✅ FIX ISSUE 2: Enhanced logging to debug pucode matching
            console.log(`📞 [Phase 2] Home.endSession: Checking for held call match`, {
              endedPucode: endedPucode,
              currentHeldCallsCount: currentHeldCalls.length,
              heldCallsPucodes: currentHeldCalls.map(c => ({
                original: c.pucode,
                normalized: (c.pucode || '').toString().trim().toLowerCase()
              })),
              activeCallPucode: activeCallPucode
            });
            
            const isHeldCall = currentHeldCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              const matches = callPucode === endedPucode;
              if (matches) {
                console.log(`📞 [Phase 2] Home.endSession: ✅ Found held call match`, {
                  callPucode: callPucode,
                  endedPucode: endedPucode,
                  patientName: call.patientName
                });
              }
              return matches;
            });

            if (isHeldCall) {
              console.log(`📞 [Phase 2] Home.endSession: ✅ Held call ended, removing from held calls`, {
                pucode: endedPucode,
                heldCallsLengthBefore: currentHeldCalls.length,
                activeCallPucode: activeCallPucode,
                isActiveCall: endedPucode === activeCallPucode,
                payload: payload
              });

              // ✅ FIX ISSUE 2: Ensure we're NOT processing a held call as an active call
              // If the held call's pucode matches the active call's pucode, something is wrong
              // This should never happen, but we check to prevent accidental active call disconnection
              if (endedPucode === activeCallPucode && this.state.startConsult) {
                console.error(`❌ [Phase 2] Home.endSession: ERROR - Held call pucode matches active call! This should not happen.`, {
                  endedPucode: endedPucode,
                  activeCallPucode: activeCallPucode,
                  startConsult: this.state.startConsult
                });
                // Still remove from held calls, but log the error
              }

              // NOTE: We do NOT call leaveRoom() here because:
              // 1. This handler is called when kiosk disconnects, so Twilio will auto-cleanup
              // 2. The twilioRef stored in heldCall may be stale or point to the active call's Twilio instance
              // 3. Calling leaveRoom() on a stale reference could disconnect the active call
              // 4. When pharmacist explicitly ends a held call, they use endHeldCall() which handles Twilio properly

              // ✅ FIX ISSUE 2: Use functional update to ensure we get the latest state and properly remove the held call
              // Also clear any related incoming calls that might be associated with this held call
              this.setState(prevState => {
                const prevHeldCalls = Array.isArray(prevState.heldCalls) ? prevState.heldCalls : [];
                const prevIncomingCalls = Array.isArray(prevState.incomingCalls) ? prevState.incomingCalls : [];
                
                const updatedHeldCalls = prevHeldCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                // Also remove from incoming calls if it exists there (defensive cleanup)
                const updatedIncomingCalls = prevIncomingCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                console.log(`📞 [Phase 2] Home.endSession: Filtering held calls and incoming calls`, {
                  heldCallsBefore: prevHeldCalls.length,
                  heldCallsAfter: updatedHeldCalls.length,
                  incomingCallsBefore: prevIncomingCalls.length,
                  incomingCallsAfter: updatedIncomingCalls.length,
                  removedPucode: endedPucode,
                  remainingHeldPucodes: updatedHeldCalls.map(c => c.pucode),
                  remainingIncomingPucodes: updatedIncomingCalls.map(c => c.pucode)
                });
                
                return {
                  heldCalls: updatedHeldCalls,
                  incomingCalls: updatedIncomingCalls
                };
              }, () => {
                // Callback after state update - use the updated state from the callback
                const updatedHeldCalls = Array.isArray(this.state.heldCalls) ? this.state.heldCalls : [];
                const updatedIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
                
                console.log(`📞 [Phase 2] Home.endSession: ✅ State updated successfully`, {
                  newHeldCallsCount: updatedHeldCalls.length,
                  newIncomingCallsCount: updatedIncomingCalls.length,
                  remainingHeldPucodes: updatedHeldCalls.map(c => c.pucode),
                  remainingIncomingPucodes: updatedIncomingCalls.map(c => c.pucode),
                  activeCallPucode: activeCallPucode,
                  activeCallStillRunning: this.state.startConsult
                });
                
                // ✅ FIX ISSUE 2: Stop beep sound if no more unsilenced calls
                const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
                if (!hasUnsilencedCalls) {
                  stopLightBeepSound();
                  console.log(`📞 [Phase 2] Home.endSession: No more unsilenced calls, stopped beep sound`);
                }
              });

              console.log(`📞 [Phase 2] Home.endSession: ✅ Early return - held call cleaned up (Twilio will auto-cleanup, active call unaffected)`);
              return; // Don't process as active call - CRITICAL: This prevents affecting the active consultation
            }
          }
          
          // ✅ CRITICAL FIX: Only process endSession if this is actually the active/pending call for THIS pharmacist
          // This prevents other pharmacists' call completions from affecting this pharmacist's UI
          const endedPucode = payload && payload.pucode ? (payload.pucode || '').toString().trim().toLowerCase() : '';
          const activeCallPucode = ((this.state.Pickupcode || '').toString().trim().toLowerCase());
          const isActiveOrPendingCall = endedPucode === activeCallPucode && activeCallPucode !== '';
          const hasActiveConsultation = this.state.startConsult;
          const hasPendingDialog = this.state.consultOpen || this.state.isFirebaseNotification;
          
          console.log(`📞 [Phase 1] Home.endSession: Checking if should process endSession event`, {
            endedPucode: endedPucode,
            activeCallPucode: activeCallPucode,
            isActiveOrPendingCall: isActiveOrPendingCall,
            hasActiveConsultation: hasActiveConsultation,
            hasPendingDialog: hasPendingDialog,
            startConsult: this.state.startConsult,
            consultOpen: this.state.consultOpen,
            isFirebaseNotification: this.state.isFirebaseNotification,
            shouldProcess: isActiveOrPendingCall && (hasActiveConsultation || hasPendingDialog)
          });
          
          // Only process if this is the active/pending call for THIS pharmacist
          if (isActiveOrPendingCall && (hasActiveConsultation || hasPendingDialog)) {
            console.log(`📞 [Phase 1] Home.endSession: ✅ Processing endSession for active/pending call`, {
              pucode: endedPucode,
              hasTwilio: !!this.twilio
            });
            
            // Process as active call ending
            // Null-safe check: only call leaveRoom if twilio exists, otherwise close consult dialog
            if (this.twilio) {
              this.twilio.leaveRoom(false); // false = socket event (patient ended call)
            } else {
              this.handleConsultClose();
            }
          } else {
            console.log(`📞 [Phase 1] Home.endSession: ❌ Ignoring endSession - not active/pending call for this pharmacist`, {
              endedPucode: endedPucode,
              activeCallPucode: activeCallPucode,
              reason: !isActiveOrPendingCall ? 'Pucode mismatch' : 'No active consultation or pending dialog',
              note: 'This prevents other pharmacists\' call completions from affecting this pharmacist\'s UI'
            });
          }
        });
      this.socket &&
        this.socket.on('callAlreadyAccepted', (payload) => {
          // this event is triggered every time the video call gets accepted or times out
          console.log(`🌐 [Network] Home.initSocket: Call already accepted event received:`, payload);
          
          if (payload && payload.pucode) {
            const eventPucode = (payload.pucode || '').toString().trim().toLowerCase();
            const activeCallPucode = (this.state.Pickupcode || '').toString().trim().toLowerCase();
            
            // Phase 1: Check if this call is in the incoming queue and remove it
            const currentIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
            const isQueuedCall = currentIncomingCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              return callPucode === eventPucode;
            });
            
            if (isQueuedCall) {
              console.log(`📞 [Phase 1] Home.callAlreadyAccepted: Removing call from queue`, {
                pucode: eventPucode,
                message: payload.message
              });
              
              // Log that call was accepted by another pharmacist
              logConsultAcceptedByAnother(eventPucode.toUpperCase(), {});
              
              this.setState(prevState => {
                const updatedIncomingCalls = prevState.incomingCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== eventPucode;
                });
                
                // Stop beep if no more unsilenced calls
                const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
                if (!hasUnsilencedCalls) {
                  stopLightBeepSound();
                }
                
                return {
                  incomingCalls: updatedIncomingCalls,
                  silencedCalls: prevState.silencedCalls.filter(p => 
                    (p || '').toString().trim().toLowerCase() !== eventPucode
                  )
                };
              });
            }
            
            // Original logic for active/pending call
            if (eventPucode === activeCallPucode || eventPucode.includes(activeCallPucode)) {
            // Check if we have an incoming call dialog open (indicating multiple users scenario)
            if (this.state.consultOpen && payload.message !== "Call pickup timeout from Kiosk!") {
              // Multiple users scenario - show popup
              this.setState({
                callAcceptedByOtherUser: true,
              });
            }

            this.handleConsultClose();
          }
          }
        });
      // Handle timeout scenario (45 seconds, no pharmacist accepted) - show missed call modal
      this.socket && this.socket.on('consultTimeout', async (payload) => {
        const eventReceiveTime = new Date().toISOString();
        console.log(`⏱️ [PORTAL][${eventReceiveTime}] consultTimeout EVENT RECEIVED`, {
          payload: payload,
          socketId: this.socket && this.socket.id,
          socketConnected: this.socket && this.socket.connected
        });
        
        if (payload && payload.pucode) {
          const timeoutPucode = (payload.pucode || '').toString().trim().toLowerCase();
          const activeCallPucode = ((this.state.Pickupcode || '').toString().trim().toLowerCase());
          
          // ✅ CRITICAL FIX: First check if this timeout is for a queued call
          // If so, just remove it from the queue without affecting active consultation
          const currentIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
          const isQueuedCall = currentIncomingCalls.some(call => {
            const callPucode = (call.pucode || '').toString().trim().toLowerCase();
            return callPucode === timeoutPucode;
          });
          
          if (isQueuedCall) {
            console.log(`⏱️ [PORTAL][${eventReceiveTime}] consultTimeout: Removing queued call from queue (timeout)`, {
              timeoutPucode: timeoutPucode,
              activeCallPucode: activeCallPucode,
              hasActiveConsultation: this.state.startConsult,
              queueLength: currentIncomingCalls.length
            });
            
            // Remove from queue - don't affect active consultation
            this.setState(prevState => {
              const updatedIncomingCalls = prevState.incomingCalls.filter(call => {
                const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                return callPucode !== timeoutPucode;
              });
              
              // Stop beep if no more unsilenced calls
              const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
              if (!hasUnsilencedCalls) {
                stopLightBeepSound();
              }
              
              return {
                incomingCalls: updatedIncomingCalls,
                silencedCalls: prevState.silencedCalls.filter(p => 
                  (p || '').toString().trim().toLowerCase() !== timeoutPucode
                )
              };
            });
            
            return; // Don't process further - queued call timeout handled
          }
          
          // ✅ Only process timeout for active/pending call (not queued, not active consultation)
          // Check if this is the active/pending call AND there's no active consultation running
          const consultationCallStatus = localStorage.getItem('IncomingConsultationCallStatus');
          const hasIncompleteStatus = consultationCallStatus === 'incomplete';
          
          // Only process if:
          // 1. Timeout pucode matches active call pucode AND
          // 2. (There's a pending dialog open OR incomplete status) AND
          // 3. There's NO active consultation running (startConsult must be false)
          const isActivePendingCall = timeoutPucode === activeCallPucode && activeCallPucode !== '';
          const hasPendingDialog = this.state.consultOpen || this.state.isFirebaseNotification || hasIncompleteStatus;
          const hasActiveConsultation = this.state.startConsult; // Active consultation means Twilio room is active
          
          const shouldProcess = isActivePendingCall && hasPendingDialog && !hasActiveConsultation;
          
          if (shouldProcess) {
            console.log(`⏱️ [PORTAL][${eventReceiveTime}] consultTimeout: Processing timeout for active/pending call (no active consultation)`, {
              pucode: timeoutPucode,
              activeCallPucode: activeCallPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen,
              isFirebaseNotification: this.state.isFirebaseNotification,
              hasIncompleteStatus: hasIncompleteStatus,
              consultationCallStatus: consultationCallStatus
            });
            
            // Stop notification sound
            stopNotificationSound();
            
            // Log timeout for active/pending call
            logConsultTimeout(timeoutPucode.toUpperCase(), {});

            // ✅ FIX: Don't set consultOpen: false here - let handleConsultClose handle it
            // Otherwise the guard in handleConsultClose will skip execution
            // Set other flags but keep consultOpen true so handleConsultClose can process
            this.setState({
              startConsult: false,
              isCallActive: false,
              isFirebaseNotification: false,
              showCallerHungUpModal: false, // Don't show "Caller Hung Up" modal for timeout
            });
            
            // handleConsultClose will check consultationCallStatus === 'incomplete' and show missed call modal
            // It will set consultOpen: false itself
            this.handleConsultClose();
          } else {
            console.log(`⏱️ [PORTAL][${eventReceiveTime}] consultTimeout: Ignoring - not active/pending call or active consultation running`, {
              timeoutPucode: timeoutPucode,
              activeCallPucode: activeCallPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen,
              isFirebaseNotification: this.state.isFirebaseNotification,
              hasIncompleteStatus: hasIncompleteStatus,
              consultationCallStatus: consultationCallStatus,
              isQueuedCall: isQueuedCall,
              hasActiveConsultation: hasActiveConsultation,
              reason: hasActiveConsultation ? 'Active consultation running - timeout ignored' : 'Not active/pending call'
            });
          }
        }
      });
      
      // receiving this event when patient ends the call (not timeout)
      this.socket &&
        this.socket.on('endSessionCancelConsult', async (payload) => {
          const eventReceiveTime = new Date().toISOString();
          console.log(`🔴 [PORTAL][${eventReceiveTime}] endSessionCancelConsult EVENT RECEIVED`, {
            payload: payload,
            socketId: this.socket && this.socket.id,
            socketConnected: this.socket && this.socket.connected
          });
          // Phase 1: FIRST check if this is a queued call that ended from kiosk (must check BEFORE active call)
          if (payload && payload.pucode) {
            // Normalize pucode for comparison (trim, lowercase) - CRITICAL for matching
            const endedPucode = (payload.pucode || '').toString().trim().toLowerCase();
            const activeCallPucode = ((this.state.Pickupcode || '').toString().trim().toLowerCase());
            
            // Get current incoming calls array (defensive check)
            const currentIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
            const currentSilencedCalls = Array.isArray(this.state.silencedCalls) ? this.state.silencedCalls : [];
            
            // Check if this pucode exists in the queue (normalize both for comparison)
            const isQueuedCall = currentIncomingCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              return callPucode === endedPucode;
            });
            
            // ✅ CRITICAL FIX: Also check if it's in silencedCalls (even if not in incomingCalls anymore)
            // This handles cases where the call was silenced and might have been removed from incomingCalls
            // but is still showing in the UI based on silencedCalls
            const isSilencedCall = currentSilencedCalls.some(silencedPucode => {
              const silencedPucodeLower = (silencedPucode || '').toString().trim().toLowerCase();
              return silencedPucodeLower === endedPucode;
            });
            
            console.log(`🔴 [PORTAL][${eventReceiveTime}] endSessionCancelConsult ANALYSIS`, {
              endedPucode: endedPucode,
              activeCallPucode: activeCallPucode,
              isQueuedCall: isQueuedCall,
              isSilencedCall: isSilencedCall,
              isActiveCall: endedPucode === activeCallPucode,
              queueLength: currentIncomingCalls.length,
              silencedCallsLength: currentSilencedCalls.length,
              hasActiveCall: this.state.startConsult,
              queuePucodes: currentIncomingCalls.map(c => (c.pucode || '').toString().trim().toLowerCase()),
              silencedPucodes: currentSilencedCalls.map(p => (p || '').toString().trim().toLowerCase()),
              rawIncomingCalls: currentIncomingCalls.map(c => ({ pucode: c.pucode, patientName: c.patientName }))
            });
            
            // ✅ FIX: If it's a queued call OR a silenced call (not the active call), clean it up and RETURN EARLY
            // This ensures silenced calls are removed even if they're not in incomingCalls anymore
            if ((isQueuedCall || isSilencedCall) && endedPucode !== activeCallPucode) {
              console.log(`📞 [Phase 1] Home.endSessionCancelConsult: ✅ Queued/silenced call ended from kiosk, removing from queue and silenced list`, {
                pucode: endedPucode,
                queueLengthBefore: currentIncomingCalls.length,
                silencedCallsLengthBefore: currentSilencedCalls.length,
                wasInQueue: isQueuedCall,
                wasSilenced: isSilencedCall
              });
              
              // Remove from incoming calls queue AND silenced calls
              this.setState(prevState => {
                const prevIncomingCalls = Array.isArray(prevState.incomingCalls) ? prevState.incomingCalls : [];
                const prevSilencedCalls = Array.isArray(prevState.silencedCalls) ? prevState.silencedCalls : [];
                
                const updatedIncomingCalls = prevIncomingCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                const updatedSilencedCalls = prevSilencedCalls.filter(p => {
                  const silencedPucode = (p || '').toString().trim().toLowerCase();
                  return silencedPucode !== endedPucode;
                });
                
                console.log(`📞 [Phase 1] Home.endSessionCancelConsult: State update - removing call`, {
                  incomingCallsBefore: prevIncomingCalls.length,
                  incomingCallsAfter: updatedIncomingCalls.length,
                  silencedCallsBefore: prevSilencedCalls.length,
                  silencedCallsAfter: updatedSilencedCalls.length,
                  removedPucode: endedPucode
                });
                
                // Stop beep sound if no more unsilenced calls
                const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
                if (!hasUnsilencedCalls) {
                  stopLightBeepSound();
                  console.log(`📞 [Phase 1] Home.endSessionCancelConsult: No more unsilenced calls, stopped beep sound`);
                }
                
                return {
                  incomingCalls: updatedIncomingCalls,
                  silencedCalls: updatedSilencedCalls
                };
              }, () => {
                // Callback after state update to verify
                console.log(`📞 [Phase 1] Home.endSessionCancelConsult: State updated`, {
                  newQueueLength: this.state.incomingCalls ? this.state.incomingCalls.length : 0,
                  newSilencedCallsLength: this.state.silencedCalls ? this.state.silencedCalls.length : 0
                });
              });
              
              console.log(`📞 [Phase 1] Home.endSessionCancelConsult: ✅ Early return - queued/silenced call cleaned up, NOT processing as active call`);
              return; // CRITICAL: Don't process as active call - return immediately
            }

            // Phase 2: Check if this is a HELD call that ended from kiosk
            const currentHeldCalls = Array.isArray(this.state.heldCalls) ? this.state.heldCalls : [];
            const isHeldCall = currentHeldCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              return callPucode === endedPucode;
            });

            if (isHeldCall) {
              console.log(`📞 [Phase 2] Home.endSessionCancelConsult: ✅ Held call ended from kiosk, removing from held calls`, {
                pucode: endedPucode,
                heldCallsLengthBefore: currentHeldCalls.length,
                activeCallPucode: activeCallPucode,
                isActiveCall: endedPucode === activeCallPucode
              });

              // ✅ CRITICAL: Ensure we're NOT processing a held call as an active call
              // If the held call's pucode matches the active call's pucode, something is wrong
              // This should never happen, but we check to prevent accidental active call disconnection
              if (endedPucode === activeCallPucode && this.state.startConsult) {
                console.error(`❌ [Phase 2] Home.endSessionCancelConsult: ERROR - Held call pucode matches active call! This should not happen.`, {
                  endedPucode: endedPucode,
                  activeCallPucode: activeCallPucode,
                  startConsult: this.state.startConsult
                });
                // Still remove from held calls, but log the error
              }

              // NOTE: We do NOT call leaveRoom() here because:
              // 1. The kiosk has already disconnected, so Twilio will clean up automatically
              // 2. The twilioRef stored in heldCall may be stale or point to the active call's Twilio instance
              // 3. Calling leaveRoom() on a stale reference could disconnect the active call
              // 4. When a call is on hold, we only mute tracks - we don't disconnect from Twilio
              //    The Twilio connection is managed by the active call's Twilio instance
              // 5. The TwilioVideo component has logic to ignore participant disconnects from inactive/held rooms

              // Remove from held calls - use functional update to ensure we get the latest state
              this.setState(prevState => {
                const prevHeldCalls = Array.isArray(prevState.heldCalls) ? prevState.heldCalls : [];
                const updatedHeldCalls = prevHeldCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                console.log(`📞 [Phase 2] Home.endSessionCancelConsult: Filtering held calls`, {
                  beforeCount: prevHeldCalls.length,
                  afterCount: updatedHeldCalls.length,
                  removedPucode: endedPucode,
                  remainingPucodes: updatedHeldCalls.map(c => c.pucode)
                });
                
                return {
                  heldCalls: updatedHeldCalls
                };
              }, () => {
                // Callback after state update - use the updated state from the callback
                const updatedHeldCalls = Array.isArray(this.state.heldCalls) ? this.state.heldCalls : [];
                console.log(`📞 [Phase 2] Home.endSessionCancelConsult: ✅ State updated successfully`, {
                  newHeldCallsCount: updatedHeldCalls.length,
                  remainingPucodes: updatedHeldCalls.map(c => c.pucode),
                  activeCallPucode: activeCallPucode,
                  activeCallStillRunning: this.state.startConsult
                });
              });

              console.log(`📞 [Phase 2] Home.endSessionCancelConsult: ✅ Early return - held call cleaned up (Twilio will auto-cleanup, active call unaffected)`);
              return; // Don't process as active call - CRITICAL: This prevents affecting the active consultation
            }
          }
          
          // Phase 1: Only process as active call if pucode EXACTLY matches active call (not queued calls)
          // This code only runs if it's NOT a queued call
          const activeCallPucode = (this.state.Pickupcode || '').toUpperCase();
          const endedPucode = payload && payload.pucode ? payload.pucode.toUpperCase() : '';
          
          console.log(`📞 [Phase 1] Home.endSessionCancelConsult: Checking if active call ended`, {
            endedPucode: endedPucode,
            activeCallPucode: activeCallPucode,
            isExactMatch: endedPucode === activeCallPucode,
            startConsult: this.state.startConsult,
            consultOpen: this.state.consultOpen,
            isFirebaseNotification: this.state.isFirebaseNotification
          });
          
          // Exact match check - only process if this is the active call, not a queued call
          // Also process if consultOpen is true (dialog showing but not yet accepted)
          // Also process if isFirebaseNotification is true (notification received but dialog not yet shown due to async timing)
          if (
            payload &&
            payload.pucode &&
            endedPucode === activeCallPucode &&
            activeCallPucode !== '' && // Ensure we have a pending/active call
            (this.state.startConsult || this.state.consultOpen || this.state.isFirebaseNotification) // Process if active call OR dialog open OR notification pending
          ) {
            console.log(`📞 [Phase 1] Home.endSessionCancelConsult: ✅ Active call ended from kiosk`, {
              activeCallPucode: activeCallPucode,
              endedPucode: endedPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen
            });
            
            if (!this.state.consultOpen && !this.state.startConsult && !this.state.isFirebaseNotification) {
            console.log('Consult already closed, skipping audit log.');
            return;
          }

          // Stop the notification sound when patient ends the call
          stopNotificationSound();
          console.log(`⚙️ [Function] Home.endSessionCancelConsult: Notification sound stopped due to patient ending call`);

          // Issue B Fix: If call was accepted, keep modal open for notes. If pending, show "Caller Hung Up" modal.
          const wasCallAccepted = this.state.startConsult;
          const shouldShowCallerHungUpModal = !wasCallAccepted && (this.state.consultOpen || this.state.isFirebaseNotification);
          
          console.log(`📞 [Phase 1] Home.endSessionCancelConsult: Determining action based on call status`, {
            startConsult: this.state.startConsult,
            consultOpen: this.state.consultOpen,
            isFirebaseNotification: this.state.isFirebaseNotification,
            wasCallAccepted: wasCallAccepted,
            shouldShowCallerHungUpModal: shouldShowCallerHungUpModal,
            action: wasCallAccepted ? 'Keep modal open for notes (call was accepted)' : 'Show Caller Hung Up modal (call was pending)'
          });

            const { first_name, last_name, patientName, prescriptionMasterId } = this.state;
            const auditPatientName = patientName || (this.state.Notifications && this.state.Notifications.User_name) || ((first_name && last_name) ? (first_name + ' ' + last_name) : 'patient');

            const auditMsg = `Consultation session with user was ended by '${auditPatientName}'.`;

            try {
              // Standardized audit log
              const patientEndedPucode = (activeCallPucode || '').toString().trim().toUpperCase();
              await logConsultEndedByPatient(patientEndedPucode, wasCallAccepted, { prescriptionMasterId });
              
              // Legacy audit log (keeping for backward compatibility)
              await writeAuditLog(auditMsg, 'Consultation', { prescriptionMasterId });
              console.log("📝 Audit trail recorded for patient ending the call from Kiosk");
            } catch (error) {
              console.error("❌ Failed to write audit log for patient-ended call", error);
            }

          // Leave Twilio room when kiosk ends the call
            if (this.twilio) {
              this.twilio.leaveRoom(false); // false = patient ended call, not pharmacist initiated
            }

          // If call was accepted, keep modal open so pharmacist can take notes
          // Only close modal and show "Caller Hung Up" if call was pending (not yet accepted)
          if (wasCallAccepted) {
            console.log(`📞 [Phase 1] Home.endSessionCancelConsult: Call was accepted - keeping modal open for notes`);
            // Just stop notification sound and reset notification flag, but keep startConsult: true
            stopNotificationSound();
            this.setState({
              isFirebaseNotification: false, // Reset notification flag
              showCallerHungUpModal: false, // Don't show modal
              // Keep startConsult: true so modal stays open
              // Keep consultOpen: false (it's already false for accepted calls)
            });
            // Don't call handleConsultClose() - let pharmacist manually close when done with notes
          } else {
            console.log(`📞 [Phase 1] Home.endSessionCancelConsult: Call was pending - closing dialog and showing Caller Hung Up modal`);
            // Call was pending (not accepted) - close dialog and show "Caller Hung Up" modal
            this.setState({
              startConsult: false,
              isCallActive: false,
              consultOpen: false,
              isFirebaseNotification: false, // Reset notification flag
              showCallerHungUpModal: shouldShowCallerHungUpModal,
            });
            stopNotificationSound();
            this.handleConsultClose();
          }
          } else {
            // Not a queued call and not the active call - ignore this event
            console.log(`📞 [Phase 1] Home.endSessionCancelConsult: Ignoring event - not queued call and not active call`, {
              endedPucode: endedPucode,
              activeCallPucode: activeCallPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen,
              isFirebaseNotification: this.state.isFirebaseNotification
            });
          }
        });
      this.socket &&
        this.socket.on('endSessionDisconnectedConsult', (payload) => {
          console.log(`🌐 [Network] Home.initSocket: End session disconnected consult event received:`, payload);
          
          // Phase 1: Check if this is a queued call that disconnected
          if (payload && payload.pucode) {
            // Normalize pucode for comparison (trim, lowercase)
            const endedPucode = (payload.pucode || '').toString().trim().toLowerCase();
            const activeCallPucode = ((this.state.Pickupcode || '').toString().trim().toLowerCase());
            
            // Get current incoming calls array (defensive check)
            const currentIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
            
            // Check if this pucode exists in the queue (normalize both for comparison)
            const isQueuedCall = currentIncomingCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              return callPucode === endedPucode;
            });
            
            console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: Checking if queued call disconnected`, {
              endedPucode: endedPucode,
              activeCallPucode: activeCallPucode,
              isQueuedCall: isQueuedCall,
              isActiveCall: endedPucode === activeCallPucode,
              queueLength: currentIncomingCalls.length,
              queuePucodes: currentIncomingCalls.map(c => (c.pucode || '').toString().trim().toLowerCase())
            });
            
            // If it's a queued call (not the active call), clean it up
            if (isQueuedCall && endedPucode !== activeCallPucode) {
              console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: ✅ Queued call disconnected, removing from queue`, {
                pucode: endedPucode,
                queueLengthBefore: currentIncomingCalls.length
              });
              
              // Remove from incoming calls queue
              this.setState(prevState => {
                const prevIncomingCalls = Array.isArray(prevState.incomingCalls) ? prevState.incomingCalls : [];
                const updatedIncomingCalls = prevIncomingCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: State update - removing call`, {
                  before: prevIncomingCalls.length,
                  after: updatedIncomingCalls.length,
                  removedPucode: endedPucode
                });
                
                // Stop beep sound if no more unsilenced calls
                const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
                if (!hasUnsilencedCalls) {
                  stopLightBeepSound();
                  console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: No more unsilenced calls, stopped beep sound`);
                }
                
                return {
                  incomingCalls: updatedIncomingCalls,
                  silencedCalls: Array.isArray(prevState.silencedCalls) 
                    ? prevState.silencedCalls.filter(p => {
                        const silencedPucode = (p || '').toString().trim().toLowerCase();
                        return silencedPucode !== endedPucode;
                      })
                    : []
                };
              }, () => {
                // Callback after state update to verify
                console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: State updated, new queue length:`, 
                  this.state.incomingCalls ? this.state.incomingCalls.length : 0
                );
              });
              
              console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: ✅ Early return - queued call cleaned up, NOT processing as active call`);
              return; // CRITICAL: Don't process as active call - return immediately
            }

            // Phase 2: Check if this is a HELD call that disconnected from kiosk
            const currentHeldCalls = Array.isArray(this.state.heldCalls) ? this.state.heldCalls : [];
            const isHeldCall = currentHeldCalls.some(call => {
              const callPucode = (call.pucode || '').toString().trim().toLowerCase();
              return callPucode === endedPucode;
            });

            if (isHeldCall) {
              const activeCallPucodeForHeld = ((this.state.Pickupcode || '').toString().trim().toLowerCase());
              
              console.log(`📞 [Phase 2] Home.endSessionDisconnectedConsult: ✅ Held call disconnected from kiosk, removing from held calls`, {
                pucode: endedPucode,
                heldCallsLengthBefore: currentHeldCalls.length,
                activeCallPucode: activeCallPucodeForHeld,
                isActiveCall: endedPucode === activeCallPucodeForHeld
              });

              // ✅ CRITICAL: Ensure we're NOT processing a held call as an active call
              // If the held call's pucode matches the active call's pucode, something is wrong
              // This should never happen, but we check to prevent accidental active call disconnection
              if (endedPucode === activeCallPucodeForHeld && this.state.startConsult) {
                console.error(`❌ [Phase 2] Home.endSessionDisconnectedConsult: ERROR - Held call pucode matches active call! This should not happen.`, {
                  endedPucode: endedPucode,
                  activeCallPucode: activeCallPucodeForHeld,
                  startConsult: this.state.startConsult
                });
                // Still remove from held calls, but log the error
              }

              // NOTE: We do NOT call leaveRoom() here because:
              // 1. The kiosk has already disconnected, so Twilio will clean up automatically
              // 2. The twilioRef stored in heldCall may be stale or point to the active call's Twilio instance
              // 3. Calling leaveRoom() on a stale reference could disconnect the active call
              // 4. The TwilioVideo component has logic to ignore participant disconnects from inactive/held rooms

              // Remove from held calls - use functional update to ensure we get the latest state
              this.setState(prevState => {
                const prevHeldCalls = Array.isArray(prevState.heldCalls) ? prevState.heldCalls : [];
                const updatedHeldCalls = prevHeldCalls.filter(call => {
                  const callPucode = (call.pucode || '').toString().trim().toLowerCase();
                  return callPucode !== endedPucode;
                });
                
                console.log(`📞 [Phase 2] Home.endSessionDisconnectedConsult: Filtering held calls`, {
                  beforeCount: prevHeldCalls.length,
                  afterCount: updatedHeldCalls.length,
                  removedPucode: endedPucode,
                  remainingPucodes: updatedHeldCalls.map(c => c.pucode)
                });
                
                return {
                  heldCalls: updatedHeldCalls
                };
              }, () => {
                // Callback after state update - use the updated state from the callback
                const updatedHeldCalls = Array.isArray(this.state.heldCalls) ? this.state.heldCalls : [];
                console.log(`📞 [Phase 2] Home.endSessionDisconnectedConsult: ✅ State updated successfully`, {
                  newHeldCallsCount: updatedHeldCalls.length,
                  remainingPucodes: updatedHeldCalls.map(c => c.pucode),
                  activeCallPucode: activeCallPucodeForHeld,
                  activeCallStillRunning: this.state.startConsult
                });
              });

              console.log(`📞 [Phase 2] Home.endSessionDisconnectedConsult: ✅ Early return - held call cleaned up (Twilio will auto-cleanup, active call unaffected)`);
              return; // Don't process as active call - CRITICAL: This prevents affecting the active consultation
            }
          }
          
          // Phase 1: Only process as active call if pucode EXACTLY matches active call (not queued calls)
          // This code only runs if it's NOT a queued call
          const activeCallPucode = (this.state.Pickupcode || '').toUpperCase();
          const disconnectedPucode = payload && payload.pucode ? payload.pucode.toUpperCase() : '';
          
          console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: Checking if active call disconnected`, {
            disconnectedPucode: disconnectedPucode,
            activeCallPucode: activeCallPucode,
            isExactMatch: disconnectedPucode === activeCallPucode,
            startConsult: this.state.startConsult,
            consultOpen: this.state.consultOpen,
            isFirebaseNotification: this.state.isFirebaseNotification
          });
          
          // Exact match check - only process if this is the active call, not a queued call
          // Also process if consultOpen is true (dialog showing but not yet accepted)
          // Also process if isFirebaseNotification is true (notification received but dialog not yet shown due to async timing)
          if (
          payload &&
            payload.pucode &&
            disconnectedPucode === activeCallPucode &&
            activeCallPucode !== '' && // Ensure we have a pending/active call
            (this.state.startConsult || this.state.consultOpen || this.state.isFirebaseNotification) // Process if active call OR dialog open OR notification pending
          ) {
            console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: ✅ Active call disconnected`, {
              activeCallPucode: activeCallPucode,
              disconnectedPucode: disconnectedPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen
            });
            
            // Issue B Fix: If call was accepted, keep modal open for notes. If pending, close dialog.
            const wasCallAccepted = this.state.startConsult;
            
            if (wasCallAccepted) {
              console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: Call was accepted - keeping modal open for notes`);
              // Leave Twilio room but keep modal open
              if (this.twilio) {
                this.twilio.leaveRoom(false); // false = patient ended call, not pharmacist initiated
              }
              // Don't call handleConsultClose() - let pharmacist manually close when done with notes
              // Don't set startConsult: false - keep modal open
            } else {
              console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: Call was pending - closing consultation`);
              // Call was pending (not accepted) - close dialog
              if (this.twilio) {
                this.twilio.leaveRoom(false); // false = patient ended call, not pharmacist initiated
              } else {
                this.handleConsultClose();
              }
            }
          } else {
            // Not a queued call and not the active call - ignore this event
            console.log(`📞 [Phase 1] Home.endSessionDisconnectedConsult: Ignoring event - not queued call and not active call`, {
              disconnectedPucode: disconnectedPucode,
              activeCallPucode: activeCallPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen,
              isFirebaseNotification: this.state.isFirebaseNotification
            });
          }
        });

      /**
       * Socket Manual Override Events
       */
      console.log(`🌐 [Network] Home.initSocket: Setting up manual override event handlers`);
      this.socket &&
        this.socket.on('openBinSuccess', (payload) => {
          console.log(`🌐 [Network] Home.initSocket: Open bin success event received:`, payload);
          toast.success(
            `${this.props.t('Toast.OpenBin')} ${payload.bin} ${this.props.t(
              'Toast.Success'
            )}`
          );
        });
      this.socket &&
        this.socket.on('BoxIdConfigured', (payload) => {
          console.log(`🌐 [Network] Home.initSocket: Box ID configured event received:`, payload);
        });
    } else {
      console.log(`🌐 [Network] Home.initSocket: Socket already exists or user not found`, { socketExists: !!this.socket, userExists: !!this.user });
    }
    console.log(`🌐 [Network] Home.initSocket: Socket initialization complete`);
  };

  initNotificationSocket = async ({ User }) => {
    console.log(`🌐 [Network] Home.initNotificationSocket: Starting notification socket initialization`);
    if (!this.notificationSocket && User) {
      console.log(`🌐 [Network] Home.initNotificationSocket: User found, creating notification socket`);
      this.notificationSocket = io(
        process.env.REACT_APP_VIDEO_SOCKET_BASEURL + '/notification',
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${User.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      window.notificationSocket = this.notificationSocket;
      console.log(`🌐 [Network] Home.initNotificationSocket: Setting up notification socket event listeners`);

      this.notificationSocket &&
        this.notificationSocket.on('connect', () => {
          console.log(`🌐 [Network] Home.initNotificationSocket: Notification socket connection established`);
        });

      this.notificationSocket &&
        this.notificationSocket.on('error', (error) => {
          console.log(`❌ [Error] Home.initNotificationSocket: Error:`, error);
        });
      this.notificationSocket &&
        this.notificationSocket.on('disconnect', (reason) => {
          console.log(`🌐 [Network] Home.initNotificationSocket: Socket disconnected, reason:`, reason);
        });

      console.log(`🌐 [Network] Home.initNotificationSocket: Subscribing user to notification events`, { userId: User.username });
      this.notificationSocket &&
        this.notificationSocket.emit('UserSubscribeNotificationEvent', {
          UserID: User.username,
          Message: `User: ${User.username} subscribe notification from connect!`,
        });

      this.notificationSocket &&
        this.notificationSocket.on(
          'UserReceiveNotificationEvent',
          (payload) => {
            console.log(`🌐 [Network] Home.initNotificationSocket: Received notification event:`, payload);
            this.gettingTaskNotification(true);
          }
        );
    } else {
      console.log(`🌐 [Network] Home.initNotificationSocket: Socket already exists or user not found`, { socketExists: !!this.notificationSocket, userExists: !!User });
    }
    console.log(`🌐 [Network] Home.initNotificationSocket: Notification socket initialization complete`);
  };

  initFirebaseFCM = async (forceTokenRefresh) => {
    console.log(`🌐 [Network] Home.initFirebaseFCM: Starting FCM token initialization`, { forceTokenRefresh });
    const userFromSession = sessionStorage.getItem('user');
    let usernameFromSession = null;
    let loginTimestamp = null;
    let shouldGetFirebaseToken = false;
    if (userFromSession) {
      const user = JSON.parse(userFromSession);
      if (user && user.username) {
        usernameFromSession = user.username;
        if (user.signInUserSession && user.signInUserSession.accessToken) {
          loginTimestamp = user.signInUserSession.accessToken.payload.auth_time; // unix epoch
          if (loginTimestamp) {
            // check if user logged in within last 1 minute
            const currentTime = new Date().getTime();
            const timeDiff = currentTime - loginTimestamp * 1000;
            if (timeDiff <= 60000 || forceTokenRefresh) {
              shouldGetFirebaseToken = true;
              console.log(`🌐 [Network] Home.initFirebaseFCM: Token refresh required`, { timeDiff, forceTokenRefresh });
            }
          }
        }
      }
    }
    const selectedLocation = localStorage.getItem('selectedLocation');
    const fcmTokenKey = `fcmToken${usernameFromSession}${selectedLocation}`;
    const fcmToken = localStorage.getItem(fcmTokenKey);

    // Check forceTokenRefresh directly to ensure we always get a new token when requested
    if (fcmToken && !shouldGetFirebaseToken && !forceTokenRefresh) {
      this.firebaseToken = fcmToken;
      console.log(`🌐 [Network] Home.initFirebaseFCM: Using existing FCM token`, { token: this.firebaseToken });
      return this.firebaseToken;
    }

    if (!this.firebaseToken || forceTokenRefresh) {
      console.log(`🌐 [Network] Home.initFirebaseFCM: Requesting new Firebase token`, { forceRefresh: !!forceTokenRefresh });
      try {
        this.firebaseToken = await getFirebaseToken(
          !this.state.refreshServiceWorker &&
          (() =>
            this.setState({
              refreshServiceWorker: true,
            }))
        );

        const previousToken = localStorage.getItem(fcmTokenKey);
        if (previousToken && previousToken !== this.firebaseToken) {
          console.log(`🔄 [State] Home.initFirebaseFCM: FCM token changed`, {
            previousToken,
            newToken: this.firebaseToken
          });
        }

        localStorage.setItem(fcmTokenKey, this.firebaseToken);
        console.log(`🌐 [Network] Home.initFirebaseFCM: New FCM token stored in localStorage`, { key: fcmTokenKey });

        // getting FCM Token to store in user table
        if (this.firebaseToken) {
          console.log(`🌐 [Network] Home.initFirebaseFCM: Registering FCM token with server`);
          try {
            await fetch(
              process.env.REACT_APP_BASEURL + `fcm/user/set/${this.firebaseToken}`,
              {
                method: 'PUT',
                headers: {
                  Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).signInUserSession
                    .idToken.jwtToken
                    }`,
                  'Content-Type': 'application/json',
                },
              }
            );
            console.log(`🌐 [Network] Home.initFirebaseFCM: FCM token successfully registered with server`);
            /* audit trail entry for new fcm token */
            await writeAuditLog(`FCM token refreshed.`, 'Consultation');
            // await writeAuditLog(
            //   `FCM token refreshed.`,
            //   'Consultation',
            //   {},
            //   {
            //     eventType: 'CONSULT_NOTIFICATION_TOKEN_EXPIRED',
            //     source: 'PORTAL',
            //     severity: 'INFO',
            //     metadata: {
            //       hadPreviousToken: !!previousToken,
            //     },
            //   }
            // );
            /* audit trail entry for new fcm token */
          } catch (error) {
            console.log(`❌ [Error] Home.initFirebaseFCM: Failed to register FCM token with server`, error);
          }
        } else {
          console.log(`❌ [Error] Home.initFirebaseFCM: Failed to get FCM token from Firebase`);
        }
      } catch (error) {
        console.log(`❌ [Error] Home.initFirebaseFCM: Error initializing Firebase token`, error);
      }
    }

    console.log(`🌐 [Network] Home.initFirebaseFCM: FCM token initialization complete`, {
      tokenExists: !!this.firebaseToken
    });
    return this.firebaseToken;
  };

  handleBack = () => {
    console.log(`⚙️ [Function] Home.handleBack: Navigating back by resetting view value`);
    this.setState({ value: 0 });
    console.log(`🔄 [State] Home.handleBack: View state reset to home`, { value: 0 });
  };

  handleConsultClose = async () => {
    if (!this.state.consultOpen) {
      console.log('Consult already closed, skipping handleConsultClose.');
      return;
    }

    console.log(`⚙️ [Function] Home.handleConsultClose: Starting consultation close process`, {
      timestamp: new Date().toISOString(),
      consultOpen: this.state.consultOpen,
      isButtonDisabled: this.state.isButtonDisabled
    });

    const closeStartTime = Date.now();

    try {
      // ✅ CRITICAL FIX: Early return if consult dialog is already closed
      // This prevents processing stale events from other pharmacists' call completions
      if (!this.state.consultOpen && !this.state.isFirebaseNotification) {
        console.log(`⚙️ [Function] Home.handleConsultClose: Consult already closed, skipping process`, {
          consultOpen: this.state.consultOpen,
          isFirebaseNotification: this.state.isFirebaseNotification,
          note: 'This prevents processing stale events from other pharmacists\' call completions'
        });
        return;
      }

      // Stop the notification sound
      stopNotificationSound();
      console.log(`⚙️ [Function] Home.handleConsultClose: Notification sound stopped`);

      // Remove audio element references since it's handled by notification-handler
      this.setState({
        consultOpen: false,
        loader: false,
        isButtonDisabled: false,
        orderNotReleasedOpen: false,
        isFirebaseNotification: false, // Reset notification flag
        remoteAudioStreamForVisualizer: null,
      });
      console.log(`🔄 [State] Home.handleConsultClose: Reset consultation UI states`, {
        elapsed: `${Date.now() - closeStartTime}ms`
      });

      let consultationCallStatus = localStorage.getItem(
        'IncomingConsultationCallStatus',
      );
      console.log('[OKOK] consultationCallStatus', consultationCallStatus);
      console.log(`⚙️ [Function] Home.handleConsultClose: Retrieved call status from localStorage`, {
        status: consultationCallStatus,
        elapsed: `${Date.now() - closeStartTime}ms`
      });

      // ✅ CRITICAL FIX: Verify that the localStorage status matches the current Pickupcode
      // This prevents showing missed call modal for a different call when another pharmacist completes their call
      const currentPucode = (this.state.Pickupcode || '').toString().trim().toUpperCase();
      const localStoragePucode = localStorage.getItem('IncomingConsultationCallPucode');
      // Only show missed call modal if:
      // 1. Status is 'incomplete' AND
      // 2. Either no pucode stored (backward compatibility) OR pucode matches current call OR current pucode is empty (call was cleared)
      const pucodeMatches = !localStoragePucode || 
                           (currentPucode && localStoragePucode.toUpperCase() === currentPucode) ||
                           currentPucode === ''; // Allow if current pucode is empty (call was cleared)
      
      console.log(`⚙️ [Function] Home.handleConsultClose: Verifying pucode match before missed call handling`, {
        currentPucode: currentPucode,
        localStoragePucode: localStoragePucode,
        pucodeMatches: pucodeMatches,
        consultationCallStatus: consultationCallStatus,
        consultOpen: this.state.consultOpen,
        isFirebaseNotification: this.state.isFirebaseNotification
      });

      if (![null, undefined, ''].includes(consultationCallStatus) && 
          consultationCallStatus === 'incomplete' && 
          pucodeMatches) {
        // Only show missed call dialog if call was not accepted by another user
        if (this.state.callAcceptedByOtherUser) {
          return;
        }
        console.log(`⚙️ [Function] Home.handleConsultClose: Handling missed call scenario`);
        const { first_name, last_name, patientName, prescriptionMasterId } = this.state;
        let auditMsg = "";
        /* audit trail entry missed call from patient */
        const auditPatientName = patientName || (this.state.Notifications && this.state.Notifications.User_name) || ((first_name && last_name) ? (first_name + ' ' + last_name) : 'patient');
        auditMsg = `User missed consultation call from '${auditPatientName}'`;
        console.log(`⚙️ [Function] Home.handleConsultClose: Creating audit log for missed call`, {
          patientName: auditPatientName,
          prescriptionMasterId: prescriptionMasterId
        });

        try {
          await writeAuditLog(auditMsg, 'Consultation', { prescriptionMasterId: prescriptionMasterId });
          // await writeAuditLog(
          //   auditMsg,
          //   'Consultation',
          //   { prescriptionMasterId: prescriptionMasterId },
          //   {
          //     eventType: 'CONSULT_MISSED_RECORDED',
          //     source: 'PORTAL',
          //     severity: 'WARNING',
          //     metadata: {
          //       pickupCode: this.state.Pickupcode,
          //     },
          //   }
          // );
          console.log(`⚙️ [Function] Home.handleConsultClose: Audit log written successfully`, {
            elapsed: `${Date.now() - closeStartTime}ms`
          });
        } catch (error) {
          console.log(`❌ [Error] Home.handleConsultClose: Failed to write audit log`, {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            elapsed: `${Date.now() - closeStartTime}ms`
          });
        }

        localStorage.setItem('IncomingConsultationCallPrescriptionId', prescriptionMasterId);
        console.log(`⚙️ [Function] Home.handleConsultClose: Saved prescription ID to localStorage for missed call handling`, {
          elapsed: `${Date.now() - closeStartTime}ms`
        });

        /* put entry in task manager table for missed call notification */
        console.log(`⚙️ [Function] Home.handleConsultClose: Creating task manager entry for missed call`);
        let notificationObj = {
          taskTitle: 'Missed Consultation Call',
          action: 'Missed Consultation Call',
          reminderDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          dueDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          taskTypeID: 'bc3571b8-9b76-4239-a949-a1c57b54e14f',
          userID: JSON.parse(sessionStorage.getItem('user')).username,
          parentAccountID: sessionStorage.getItem('parentAccountId'),
          status: 'Open',
          priority: 'High',
          taskDetails: auditMsg,
          taskDescription: auditMsg,
          type: 'CALL',
        };
        try {
          await this.writeTaskManagerMissedCallEntry(notificationObj);
          console.log(`⚙️ [Function] Home.handleConsultClose: Task manager entry created successfully`, {
            elapsed: `${Date.now() - closeStartTime}ms`
          });
        } catch (error) {
          console.log(`❌ [Error] Home.handleConsultClose: Failed to create task manager entry`, {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            elapsed: `${Date.now() - closeStartTime}ms`
          });
        }

        this.setState({
          missedCallAckDialog: true,
          prescriptionMasterId: prescriptionMasterId
        });
        console.log(`🔄 [State] Home.handleConsultClose: Showing missed call acknowledgment dialog`, {
          prescriptionMasterId: prescriptionMasterId,
          elapsed: `${Date.now() - closeStartTime}ms`
        });
      } else {
        console.log(`⚙️ [Function] Home.handleConsultClose: No missed call handling needed`, {
          status: consultationCallStatus,
          elapsed: `${Date.now() - closeStartTime}ms`
        });
        localStorage.removeItem('IncomingConsultationCallStatus');
        localStorage.removeItem('IncomingConsultationCallPucode');
        this.setState({
          consultOpen: false,
          loader: false,
          isButtonDisabled: false,
          orderNotReleasedOpen: false,
          missedCallAckDialog: false,
          prescriptionMasterId: '',
          consultationOrdersByPucode: [],
          remoteAudioStreamForVisualizer: null,
        });
        console.log(`🔄 [State] Home.handleConsultClose: Reset all consultation states`, {
          elapsed: `${Date.now() - closeStartTime}ms`
        });
      }

      console.log(`⚙️ [Function] Home.handleConsultClose: Consultation close process completed`, {
        completionTime: new Date().toISOString(),
        totalDuration: `${Date.now() - closeStartTime}ms`
      });
    } catch (error) {
      console.log(`❌ [Error] Home.handleConsultClose: Error during consultation close process`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        elapsed: `${Date.now() - closeStartTime}ms`
      });

      // Ensure we reset UI state even if there's an error
      this.setState({
        consultOpen: false,
        loader: false,
        isButtonDisabled: false,
        orderNotReleasedOpen: false,
        remoteAudioStreamForVisualizer: null,
      });
    }
  };

  handleBottomNavChange = (event, value) => {
    console.log(`🖱️ [Event] Home.handleBottomNavChange: Bottom navigation changed`, { newValue: value });
    this.setState({ value });
    console.log(`🔄 [State] Home.handleBottomNavChange: Updated navigation value`, { value });
  };

  handleChange = (event, checked) => {
    console.log(`🖱️ [Event] Home.handleChange: Auth state toggle changed`, { checked });
    this.setState({ auth: checked });
    console.log(`🔄 [State] Home.handleChange: Updated auth state`, { auth: checked });
  };

  handleMenu = (event) => {
    console.log(`🖱️ [Event] Home.handleMenu: User menu clicked`);
    this.setState({ anchorEl: event.currentTarget });
    console.log(`🔄 [State] Home.handleMenu: Menu anchor element set`, { elementId: event.currentTarget.id });
  };

  handleClose_menu = () => {
    console.log(`🖱️ [Event] Home.handleClose_menu: Closing user menu`);
    this.setState({ anchorEl: null });
    console.log(`🔄 [State] Home.handleClose_menu: Menu anchor element cleared`);
  };

  //Added By Naresh | DI-461 | Date:16-04-2019 |Kiosk Offline Notification
  handleOpenNotificationMenu = (event) => {
    console.log(`🖱️ [Event] Home.handleOpenNotificationMenu: Opening notification menu`);
    this.setState({ anchorElNotification: event.currentTarget });
    console.log(`🔄 [State] Home.handleOpenNotificationMenu: Notification menu anchor element set`);

    const { notificationData, replica } = this.state;
    if (
      typeof notificationData === 'object' &&
      Object.keys(notificationData)['length'] === 0
    ) {
      console.log(`⚙️ [Function] Home.handleOpenNotificationMenu: No notification data available`);
      return true;
    }

    console.log(`⚙️ [Function] Home.handleOpenNotificationMenu: Setting timeout to update notifications`, { replicaExists: !!replica });
    setTimeout(() => {
      if (replica) {
        console.log(`⚙️ [Function] Home.handleOpenNotificationMenu: Updating task notifications`, { replicaCount: replica.length });
        this.updateTaskNotification(replica);
        this.setState((prevState) => ({
          notificationCount: prevState['notificationCount'] - replica['length'],
          replica: null,
        }));
        console.log(`🔄 [State] Home.handleOpenNotificationMenu: Updated notification count and cleared replica`);
      }
    }, 200);
  };

  handleCloseNotificationMenu = () => {
    console.log(`🖱️ [Event] Home.handleCloseNotificationMenu: Closing notification menu`);
    this.setState({ anchorElNotification: null });
    console.log(`🔄 [State] Home.handleCloseNotificationMenu: Notification menu anchor element cleared`);
  };
  //End Naresh | Kiosk Offline Notification

  handleClose = (event) => {
    console.log(`🖱️ [Event] Home.handleClose: Closing dialog/popup`);
    this.setState({
      errorMessage: '',
      isOpen: false,
      showSecureBadgeCode: false,
      showChangePasswordDialog: false,
      current_password: '',
      new_password: '',
      confirm_new_password: '',
      confirm_new_password_error: null,
    });
    console.log(`🔄 [State] Home.handleClose: Reset error message and dialog states`);
  };

  removeFirebaseFCM = async () => {
    console.log(`🌐 [Network] Home.removeFirebaseFCM: Starting Firebase FCM token removal`);
    let user = sessionStorage.getItem('user');
    let token =
      user && JSON.parse(user || '{}').signInUserSession.idToken.jwtToken;

    try {
      console.log(`🌐 [Network] Home.removeFirebaseFCM: Calling deleteFirebaseToken helper function`);
      await deleteFirebaseToken();
      console.log(`🌐 [Network] Home.removeFirebaseFCM: Firebase token deletion successful`);

      console.log(`🌐 [Network] Home.removeFirebaseFCM: Notifying server about token removal`);
      return fetch(`${process.env.REACT_APP_BASEURL}fcm/removeToken`, {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      })
        .then((response) => {
          console.log(`🌐 [Network] Home.removeFirebaseFCM: Server response received`);
          try {
            return response.json();
          } catch (error) {
            console.log(`❌ [Error] Home.removeFirebaseFCM: Failed to parse server response`, error);
            return null;
          }
        })
        .then((res) => {
          this.firebaseToken = false;
          console.log(`🔄 [State] Home.removeFirebaseFCM: Cleared Firebase token reference`, { success: res.success });
          return res.success;
        })
        .catch(error => {
          console.log(`❌ [Error] Home.removeFirebaseFCM: Server request failed`, error);
          return false;
        });
    } catch (error) {
      console.log(`❌ [Error] Home.removeFirebaseFCM: Error in Firebase token removal process`, error);
      return false;
    }
  };

  signOut = () => {
    console.log(`⚙️ [Function] Home.signOut: Starting user sign out process`);
    setTimeout(async () => {
      try {
        console.log(`⚙️ [Function] Home.signOut: Gathering audit information for logout`);
        /* audit trail */
        const { loggedInUser, loggedInUserParentAccountId, loggedInUserBoxId, checkedB } = this.state;
        let parentAccountId = (![null, undefined, ''].includes(loggedInUserParentAccountId) ? loggedInUserParentAccountId : sessionStorage.getItem('parentAccountId'));
        let boxId = (![null, undefined, ''].includes(loggedInUserBoxId) ? loggedInUserBoxId : localStorage.getItem("selectedLocation"));
        console.log(`⚙️ [Function] Home.signOut: User context for logout`, {
          userId: (loggedInUser && loggedInUser.username),
          parentAccountId,
          boxId,
          consultEnabled: Boolean(checkedB)
        });

        if (Boolean(checkedB)) {
          console.log(`⚙️ [Function] Home.signOut: Writing audit log for consultation disable`);
          await writeAuditLog(
            `Consultation is disabled by user.`,
            'Consultation',
            { userId: (loggedInUser && loggedInUser.username), parentAccountId: parentAccountId, boxId: boxId },
            {},
            { deferMs: 0, wait: true }
          );
          // await writeAuditLog(
          //   `Consultation is disabled by user.`,
          //   'Consultation',
          //   { userId: (loggedInUser && loggedInUser.username), parentAccountId: parentAccountId, boxId: boxId },
          //   {
          //     eventType: 'PHARMACIST_CONNECTION_LOST',
          //     source: 'PORTAL',
          //     severity: 'WARNING',
          //     metadata: {
          //       reason: 'USER_LOGOUT',
          //     },
          //   }
          // );
        }

        console.log(`⚙️ [Function] Home.signOut: Writing general logout audit log`);
        await writeAuditLog(
          `User logged out of connect.`,
          'Logout',
          { parentAccountId: parentAccountId, boxId: boxId },
          {},
          { deferMs: 0, wait: true }
        );
        /* audit trail */

        if (this.state.checkedB) {
          console.log(`⚙️ [Function] Home.signOut: User had consultation enabled, cleaning up resources`);
          console.log(`⚙️ [Function] Home.signOut: Removing Firebase FCM token`);
          const fcmRemovalResult = await this.removeFirebaseFCM();
          console.log(`⚙️ [Function] Home.signOut: FCM token removal result`, { success: fcmRemovalResult });

          if (this.socket) {
            console.log(`⚙️ [Function] Home.signOut: Disconnecting socket`);
            this.socket.disconnect();
            console.log(`🌐 [Network] Home.signOut: Socket disconnected`);
          } else {
            console.log(`⚙️ [Function] Home.signOut: No active socket to disconnect`);
          }
        }

        console.log(`🔄 [State] Home.signOut: Resetting consultation state`);
        this.setState({ checkedB: false });

        console.log(`⚙️ [Function] Home.signOut: Updating live consult status`);
        await updateLiveConsult();

        const checkIfLoggoutURLExist = localStorage.getItem('logoutURL');
        if (![undefined, 'undefined', null, 'null', ""].includes(checkIfLoggoutURLExist)) {
          console.log(`⚙️ [Function] Home.signOut: Custom logout URL found, redirecting to`, { url: checkIfLoggoutURLExist });
          window.location.href = checkIfLoggoutURLExist;
          return;
        }

        if (this.oktaAuthClient) {
          console.log(`⚙️ [Function] Home.signOut: Using Okta auth client for sign out`);
          this.oktaAuthClient.signOut({
            postLogoutRedirectUri: `${window.location.origin}/`,
          });
        } else {
          console.log(`⚙️ [Function] Home.signOut: Using standard navigation for sign out`);
          navigate(`/`);
        }

        console.log(`⚙️ [Function] Home.signOut: Unregistering service worker`);
        serviceWorker.unregister();

        console.log(`⚙️ [Function] Home.signOut: Clearing intervals`);
        if (this.timer) {
          console.log(`⚙️ [Function] Home.signOut: Clearing timer interval`, { timerId: this.timer });
          clearInterval(this.timer);
        }

        if (window.otherUsersInterval) {
          console.log(`⚙️ [Function] Home.signOut: Clearing otherUsersInterval`, { intervalId: window.otherUsersInterval });
          clearInterval(window.otherUsersInterval);
        }

        if (kioskNotificationInterval) {
          console.log(`⚙️ [Function] Home.signOut: Clearing kioskNotificationInterval`, { intervalId: kioskNotificationInterval });
          clearInterval(kioskNotificationInterval);
        }

        if (this.refreshTokenInterval) {
          console.log(`⚙️ [Function] Home.signOut: Clearing refreshTokenInterval`, { intervalId: this.refreshTokenInterval });
          clearInterval(this.refreshTokenInterval);
        }

        // Clear token expiry auto-logout timeout
        console.log(`⚙️ [Function] Home.signOut: Clearing token expiry timeout`);
        clearTokenExpiryTimeout();

        console.log(`🔄 [State] Home.signOut: Resetting component state`);
        this.setState({ anchorEl: null, checkedB: false, checkedBDialog: false });

        console.log(`⚙️ [Function] Home.signOut: Clearing session storage`);
        sessionStorage.setItem("user", JSON.stringify({}));
        sessionStorage.setItem("permissions", JSON.stringify([]));
        sessionStorage.removeItem("roleId");

        console.log(`⚙️ [Function] Home.signOut: Setting socket reference to false`);
        this.socket = false;

        if (this.oktaAuthClient) {
          console.log(`⚙️ [Function] Home.signOut: Final Okta redirect`);
          this.oktaAuthClient.signOut({
            postLogoutRedirectUri: `${window.location.origin}/`,
          });
        } else {
          const _wasRedirected = localStorage.getItem('wasRedirected');
          if ([undefined, 'undefined', null, null, 'null', false, 'false'].includes(_wasRedirected)) {
            console.log(`⚙️ [Function] Home.signOut: Standard redirect to home`);
            navigate(`/`);
          } else {
            console.log(`⚙️ [Function] Home.signOut: Redirecting to retail URL`, { retailUrl: process.env.REACT_APP_RETAIL_URL });
            window.location.href = process.env.REACT_APP_RETAIL_URL;
          }
        }
      } catch (error) {
        console.log(`❌ [Error] Home.signOut: Error during sign out process`, {
          errorName: error.name,
          errorMessage: error.message,
          errorStack: error.stack
        });
        // Still attempt to redirect to login
        navigate(`/`);
      }
    }, 0);
  };

  handleChangePasswored = () => {
    console.log(`🖱️ [Event] Home.handleChangePasswored: Password change dialog requested`);
    this.setState({ anchorEl: null, showChangePasswordDialog: true });
    console.log(`🔄 [State] Home.handleChangePasswored: Updated dialog state`, { anchorEl: null, showChangePasswordDialog: true });
  };

  renderBillingMenuItem = () => {
    try {
      const isIlocalUserValue = localStorage.getItem('isIlocalUser');
      // Only show if user is ilocalbox user - must be explicitly 'true' (string)
      // localStorage.setItem stores booleans as strings, so false becomes 'false'
      // Admin/SuperAdmin status is ignored - only ilocalbox users can see billing
      const isIlocalUser = isIlocalUserValue === 'true';
      
      if (!isIlocalUser) {
        return null;
      }
      return (
        <MenuItem>
          <Link
            tag="a"
            to="/home/billing"
            style={{ textDecoration: 'none', color: 'black' }}
          >
            {this.props.t('Navbar.Billing')}
          </Link>
        </MenuItem>
      );
    } catch (e) {
      console.error('Error checking billing permissions:', e);
      return null;
    }
  };

  handleSubmit = (event) => {
    console.log(`🖱️ [Event] Home.handleSubmit: Password change form submitted`);

    // Client-side validation: require all fields before any API call
    const current = (this.state.current_password || '').trim();
    const newPw = (this.state.new_password || '').trim();
    const confirmPw = (this.state.confirm_new_password || '').trim();

    if (!current) {
      this.setState({ errorMessage: 'Please enter your current password.', confirm_new_password_error: null });
      return;
    }
    if (!newPw) {
      this.setState({ errorMessage: 'Please enter a new password.', confirm_new_password_error: null });
      return;
    }
    if (!confirmPw) {
      this.setState({ errorMessage: 'Please confirm your new password.', confirm_new_password_error: null });
      return;
    }
    if (newPw !== confirmPw) {
      this.setState({ errorMessage: null, confirm_new_password_error: 'Passwords do not match.' });
      return;
    }
    // Password format: at least 8 chars, one upper, one lower, one special symbol (matches policy and avoids API regex error)
    if (newPw.length < 8) {
      this.setState({ errorMessage: 'Password must be at least 8 characters long.', confirm_new_password_error: null });
      return;
    }
    if (!/[A-Z]/.test(newPw)) {
      this.setState({ errorMessage: 'Password must include at least one uppercase letter.', confirm_new_password_error: null });
      return;
    }
    if (!/[a-z]/.test(newPw)) {
      this.setState({ errorMessage: 'Password must include at least one lowercase letter.', confirm_new_password_error: null });
      return;
    }
    if (!/[^A-Za-z0-9]/.test(newPw)) {
      this.setState({ errorMessage: 'Password must include at least one special symbol.', confirm_new_password_error: null });
      return;
    }

    this.setState({ confirm_new_password_error: null, errorMessage: '' });

    let user_id = JSON.parse(sessionStorage.getItem('user')).username;
      let sha256 = require('js-sha256');
      let pw_hash = sha256(`${newPw} ${user_id}`);
      let passwordObj = {
        id: user_id,
        password: pw_hash,
      };
      console.log(`🌐 [Network] Home.handleSubmit: Checking password history`);
      fetch(process.env.REACT_APP_BASEURL + 'getLastPasswords/', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(passwordObj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            console.log(`❌ [Error] Home.handleSubmit: Failed to parse response`, error);
            return null;
          }
        })
        .then((passwordmatch) => {
          let is_password_match = JSON.parse(passwordmatch);
          let sha256 = require('js-sha256');
          let current_password_hash = sha256(current);
          let new_password_hash = sha256(newPw);
          if (
            is_password_match.res === true ||
            is_password_match.res === 'true'
          ) {
            console.log(`⚙️ [Function] Home.handleSubmit: Password exists in history`);
            this.setState({ errorMessage: 'Password already exists.' });
            console.log(`🔄 [State] Home.handleSubmit: Updated error message for existing password`);
          } else if (current_password_hash === new_password_hash) {
            console.log(`⚙️ [Function] Home.handleSubmit: New password same as current password`);
            this.setState({ errorMessage: 'Password already exists.' });
            console.log(`🔄 [State] Home.handleSubmit: Updated error message for unchanged password`);
          } else {
            console.log(`🌐 [Network] Home.handleSubmit: Authenticating user for password change`);
            Auth.signIn(
              JSON.parse(sessionStorage.getItem('user')).username,
              current
            )
              .then((updatedUser) => {
                console.log(`🌐 [Network] Home.handleSubmit: User authenticated, changing password`);
                Auth.changePassword(
                  updatedUser,
                  current,
                  newPw
                )
                  .then((result) => {
                    console.log(`🌐 [Network] Home.handleSubmit: Password change result:`, result);
                    if (result === 'SUCCESS') {
                      console.log(`⚙️ [Function] Home.handleSubmit: Password changed successfully`);
                      this.setState({
                        errorMessage: '',
                        current_password: '',
                        new_password: '',
                        confirm_new_password: '',
                        showChangePasswordDialog: false,
                      });
                      console.log(`🔄 [State] Home.handleSubmit: Reset form and closed dialog`);
                    }
                    const pw_obj = {
                      userid: JSON.parse(sessionStorage.getItem('user'))
                        .username,
                      password: pw_hash,
                    };
                    console.log(`🌐 [Network] Home.handleSubmit: Saving password to history`);
                    fetch(process.env.REACT_APP_BASEURL + 'savepassword', {
                      method: 'post',
                      withCredentials: true,
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization:
                          'Bearer ' +
                          JSON.parse(sessionStorage.getItem('user'))
                            .signInUserSession.idToken.jwtToken,
                      },
                      body: JSON.stringify(pw_obj),
                    })
                      .then((response) => {
                        try {
                          return response.text();
                        } catch (error) {
                          console.log(`❌ [Error] Home.handleSubmit: Failed to parse savepassword response`, error);
                          return null;
                        }
                      })
                      .then((uData) => {
                        console.log(`🌐 [Network] Home.handleSubmit: Password saved to history successfully`);
                      });
                    delete pw_obj.password;
                    console.log(`🌐 [Network] Home.handleSubmit: Updating password reset date`);
                    fetch(process.env.REACT_APP_BASEURL + 'UpdateResetPWDate', {
                      method: 'post',
                      withCredentials: true,
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization:
                          'Bearer ' +
                          JSON.parse(sessionStorage.getItem('user'))
                            .signInUserSession.idToken.jwtToken,
                      },
                      body: JSON.stringify(pw_obj),
                    })
                      .then((response) => {
                        try {
                          return response.text();
                        } catch (error) {
                          console.log(`❌ [Error] Home.handleSubmit: Failed to parse UpdateResetPWDate response`, error);
                          return null;
                        }
                      })
                      .then((uData) => {
                        console.log(`🌐 [Network] Home.handleSubmit: Password reset date updated successfully`);
                      });
                  })
                  .catch((reason) => {
                    console.log(`❌ [Error] Home.handleSubmit: Password change failed`, reason);
                    const msg = reason && reason.message;
                    const friendly = (msg && msg.includes('Unrecognizable lambda output'))
                      ? 'Unable to change password. Please try again.'
                      : (msg && msg.includes('proposedPassword'))
                        ? 'New password does not meet requirements. Use at least 8 characters with one uppercase, one lowercase, and one special symbol.'
                        : msg || 'Unable to change password. Please try again.';
                    this.setState({ errorMessage: friendly });
                  });
              })
              .catch((reason) => {
                console.log(`❌ [Error] Home.handleSubmit: Authentication failed`, reason);
                const msg = reason && reason.message;
                const friendly = (msg && msg.includes('Unrecognizable lambda output'))
                  ? 'Unable to verify current password. Please try again.'
                  : msg || 'Current password is incorrect. Please try again.';
                this.setState({ errorMessage: friendly });
              });
          }
        });
  };

  handleFieldChange = (event) => {
    console.log(`🖱️ [Event] Home.handleFieldChange: Field value changed`, {
      fieldId: event.target.id,
      fieldValue: event.target.value
    });

    const user = {};
    user[event.target.id] = event.target.value;

    console.log(`🔄 [State] Home.handleFieldChange: Updating field state`);
    this.setState(user);
    event.preventDefault();
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleAccessPermissionStrictEnforcement = async () => {
    // Check if we're in a secure context (HTTPS or localhost)
    const isSecureContext = window.isSecureContext || 
                           window.location.protocol === 'https:' || 
                           window.location.hostname === 'localhost' || 
                           window.location.hostname === '127.0.0.1';
    
    if (!isSecureContext) {
      console.error('Camera/microphone access requires HTTPS');
      // Note: Error alert is NOT shown here - caller should show appropriate message based on context
      return { granted: false, reason: 'HTTPS_REQUIRED', errorName: 'NotSecureContext', description: 'Secure Connection Required' };
    }
    
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.warn('getUserMedia is not supported in this browser');
      // Note: Error alert is NOT shown here - caller should show appropriate message based on context
      return { granted: false, reason: 'UNSUPPORTED_BROWSER', errorName: 'NotSupportedError', description: 'Unsupported Browser' };
    }
    
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

      // Stop the tracks immediately (to release the camera/mic for Twilio)
      stream.getTracks().forEach(track => track.stop());

      return { granted: true };
    } catch (error) {
      console.log("Media device access error:", error);

      let reason, description;
      if (error.name === "NotAllowedError") {
        reason = 'PERMISSION_DENIED';
        description = 'Permission Denied';
      } else if (error.name === "NotFoundError") {
        reason = 'DEVICE_NOT_FOUND';
        description = 'Device Not Found';
      } else if (error.name === "NotReadableError") {
        reason = 'CAMERA_IN_USE';
        description = 'Camera Unavailable';
      } else if (error.name === "NotSupportedError" || (error.message && (error.message.includes('secure context') || error.message.includes('HTTPS')))) {
        reason = 'HTTPS_REQUIRED';
        description = 'Secure Connection Required';
      } else {
        reason = 'MEDIA_ACCESS_ERROR';
        description = 'Media Access Error';
      }
      // Note: Error alert is NOT shown here - caller should show appropriate message based on context

      return { granted: false, reason, errorName: error.name, description };
    }
  };

  initializeDeviceTracking = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      console.warn('enumerateDevices is not supported in this browser');
      return;
    }
    
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const audioInputs = devices.filter(d => d.kind === 'audioinput');
      const audioOutputs = devices.filter(d => d.kind === 'audiooutput');
      
      const initialMic = audioInputs.length > 0 ? audioInputs[0].deviceId : '';
      const initialSpeaker = audioOutputs.length > 0 ? audioOutputs[0].deviceId : '';
      
      const micDevice = audioInputs.find(d => d.deviceId === initialMic);
      const speakerDevice = audioOutputs.find(d => d.deviceId === initialSpeaker);
      
      console.log('🔧 [DeviceInit] Initializing device tracking:', {
        mic: initialMic,
        speaker: initialSpeaker,
        micLabel: micDevice ? micDevice.label : 'No Device',
        speakerLabel: speakerDevice ? speakerDevice.label : 'No Device'
      });
      
      this.setState({
        lastMicInput: initialMic,
        lastCallingDevice: initialSpeaker,
        lastMicCount: audioInputs.length,
        lastSpeakerCount: audioOutputs.length,
        previousAudioInputs: audioInputs,
        previousAudioOutputs: audioOutputs
      });
    } catch (err) {
      console.error("Error initializing device tracking:", err);
    }
  };

  handleDeviceChangeLogic = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      console.warn('enumerateDevices is not supported in this browser');
      return;
    }
    
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      console.log('🔍 [Consult Settings Change] Detected device change, enumerating devices:', devices.length);

      const audioInputs = devices.filter(d => d.kind === 'audioinput');
      const audioOutputs = devices.filter(d => d.kind === 'audiooutput');
  
      // Get the first available device or empty string if none available
      const newMic = audioInputs.length > 0 ? audioInputs[0].deviceId : '';
      const newSpeaker = audioOutputs.length > 0 ? audioOutputs[0].deviceId : '';
  
      const { lastMicInput, lastCallingDevice, lastMicCount, lastSpeakerCount } = this.state;
      const user = JSON.parse(sessionStorage.getItem('user')) || {};

      // Check for device availability changes (connected/disconnected)
      if (lastMicCount !== audioInputs.length) {
        const availabilityChange = audioInputs.length > lastMicCount ? 'connected' : 'disconnected';
        const deviceType = 'microphone';
        
        // Get the specific device that was added or removed
        let deviceInfo = '';
        if (availabilityChange === 'connected') {
          // Find the new device that wasn't there before
          const newDevices = audioInputs.filter(d => !this.state.previousAudioInputs || 
            !this.state.previousAudioInputs.some(prev => prev.deviceId === d.deviceId));
          if (newDevices.length > 0) {
            deviceInfo = `: ${newDevices.map(d => d.label || 'Unknown Device').join(', ')}`;
          }
        } else {
          // Find the device that was removed
          const removedDevices = this.state.previousAudioInputs ? 
            this.state.previousAudioInputs.filter(prev => 
              !audioInputs.some(d => d.deviceId === prev.deviceId)) : [];
          if (removedDevices.length > 0) {
            deviceInfo = `: ${removedDevices.map(d => d.label || 'Unknown Device').join(', ')}`;
          }
        }
        
        console.log(`🎤 [DeviceAvailability] ${deviceType} ${availabilityChange}${deviceInfo}: ${lastMicCount} → ${audioInputs.length}`);
        
        await writeAuditLog(`Audio input device ${availabilityChange}${deviceInfo}`, 'Consult Settings Change', {
          timestamp: new Date().toISOString(),
          changeType: 'availability',
          availabilityChange: availabilityChange,
          deviceKind: 'audioinput',
          previousCount: lastMicCount,
          newCount: audioInputs.length,
          deviceInfo: deviceInfo,
          userId: user.username || 'unknown',
          sessionId: this.state.Pickupcode || 'unknown'
        });
        
        this.setState({ 
          lastMicCount: audioInputs.length,
          previousAudioInputs: audioInputs
        });
      }

      if (lastSpeakerCount !== audioOutputs.length) {
        const availabilityChange = audioOutputs.length > lastSpeakerCount ? 'connected' : 'disconnected';
        const deviceType = 'speaker';
        
        // Get the specific device that was added or removed
        let deviceInfo = '';
        if (availabilityChange === 'connected') {
          // Find the new device that wasn't there before
          const newDevices = audioOutputs.filter(d => !this.state.previousAudioOutputs || 
            !this.state.previousAudioOutputs.some(prev => prev.deviceId === d.deviceId));
          if (newDevices.length > 0) {
            deviceInfo = `: ${newDevices.map(d => d.label || 'Unknown Device').join(', ')}`;
          }
        } else {
          // Find the device that was removed
          const removedDevices = this.state.previousAudioOutputs ? 
            this.state.previousAudioOutputs.filter(prev => 
              !audioOutputs.some(d => d.deviceId === prev.deviceId)) : [];
          if (removedDevices.length > 0) {
            deviceInfo = `: ${removedDevices.map(d => d.label || 'Unknown Device').join(', ')}`;
          }
        }
        
        console.log(`🔊 [DeviceAvailability] ${deviceType} ${availabilityChange}${deviceInfo}: ${lastSpeakerCount} → ${audioOutputs.length}`);
        
        await writeAuditLog(`Audio output device ${availabilityChange}${deviceInfo}`, 'Consult Settings Change', {
          timestamp: new Date().toISOString(),
          changeType: 'availability',
          availabilityChange: availabilityChange,
          deviceKind: 'audiooutput',
          previousCount: lastSpeakerCount,
          newCount: audioOutputs.length,
          deviceInfo: deviceInfo,
          userId: user.username || 'unknown',
          sessionId: this.state.Pickupcode || 'unknown'
        });
        
        this.setState({ 
          lastSpeakerCount: audioOutputs.length,
          previousAudioOutputs: audioOutputs
        });
      }

      // Helper function to get device label
      const getDeviceLabel = (deviceId, devices, kind) => {
        if (!deviceId) return 'No Device';
        const device = devices.find(d => d.deviceId === deviceId && d.kind === kind);
        return device ? device.label || 'Unknown Device' : 'Unknown Device';
      };

      // Check for microphone changes
      if (lastMicInput !== newMic) {
        const prevMicLabel = getDeviceLabel(lastMicInput, audioInputs, 'audioinput');
        const newMicLabel = getDeviceLabel(newMic, audioInputs, 'audioinput');
        
        console.log(`🎤 [Consult Settings Change] Microphone changed: ${prevMicLabel} → ${newMicLabel}`);
        
        await writeAuditLog(`Audio input changed from ${prevMicLabel} to ${newMicLabel}`, 'Consult Settings Change', {
          timestamp: new Date().toISOString(),
          previousDevice: prevMicLabel,
          previousDeviceId: lastMicInput,
          newDevice: newMicLabel,
          newDeviceId: newMic,
          changeType: 'automatic',
          userId: user.username || 'unknown',
          sessionId: this.state.Pickupcode || 'unknown',
          deviceKind: 'audioinput'
        });
        this.setState({ lastMicInput: newMic });
      }
  
      // Check for speaker changes
      if (lastCallingDevice !== newSpeaker) {
        const prevSpeakerLabel = getDeviceLabel(lastCallingDevice, audioOutputs, 'audiooutput');
        const newSpeakerLabel = getDeviceLabel(newSpeaker, audioOutputs, 'audiooutput');
        
        console.log(`🔊 [Consult Settings Change] Speaker changed: ${prevSpeakerLabel} → ${newSpeakerLabel}`);
        
        await writeAuditLog(`Audio output changed from ${prevSpeakerLabel} to ${newSpeakerLabel}`, 'Consult Settings Change', {
          timestamp: new Date().toISOString(),
          previousDevice: prevSpeakerLabel,
          previousDeviceId: lastCallingDevice,
          newDevice: newSpeakerLabel,
          newDeviceId: newSpeaker,
          changeType: 'automatic',
          userId: user.username || 'unknown',
          sessionId: this.state.Pickupcode || 'unknown',
          deviceKind: 'audiooutput'
        });
        this.setState({ lastCallingDevice: newSpeaker });
      }

      const hasCamera = devices.some((d) => d.kind === "videoinput");
      if (!hasCamera && this.state.checkedB && !this.state.isAudioOnlyConsult) {
        // Camera disconnected while consultation is enabled (and not in audio-only mode)
        // Don't disable consultation - instead add to device issues array and show warning icon
        this.addDeviceIssue({
          id: 'CAMERA_DISCONNECTED',
          title: "Can't find your camera",
          message: "Camera was disconnected. You can switch to Audio-Only mode to continue without a camera.",
          reason: 'CAMERA_DISCONNECTED',
          showAudioOnlyButton: true
        });
        
        // Audit log - fire-and-forget for performance (no await needed)
        writeAuditLogWithTokenCheck(
          'Camera disconnected detected. Warning icon shown to user.',
          'Consultation',
          {},
          {
            eventType: 'DEVICE_ISSUE_DETECTED',
            severity: 'WARNING',
            metadata: {
              actor: 'SYSTEM',
              reason: 'CAMERA_DISCONNECTED',
              consultationStillEnabled: true,
              timestamp: new Date().toISOString(),
            },
          },
          { deferMs: 0, wait: false }
        );
      } else if (hasCamera && this.state.deviceIssues.some(i => i.id === 'CAMERA_DISCONNECTED')) {
        // Camera reconnected - remove the camera disconnected issue from the array
        this.removeDeviceIssue('CAMERA_DISCONNECTED');
        
        // Log audit event for camera reconnection - fire-and-forget for performance (no await needed)
        writeAuditLogWithTokenCheck(
          'Camera detected: Camera was reconnected. Device issue cleared.',
          'Consultation',
          {},
          {
            eventType: 'DEVICE_ISSUE_RESOLVED',
            severity: 'INFO',
            metadata: {
              actor: 'SYSTEM',
              reason: 'CAMERA_RECONNECTED',
              timestamp: new Date().toISOString(),
            },
          },
          { deferMs: 0, wait: false }
        );
      }
    } catch (err) {
      console.error("❌ [Consult Settings Change] Error checking devices:", err);
      
      // Log the error as an audit event
      const user = JSON.parse(sessionStorage.getItem('user')) || {};
      try {
        await writeAuditLog(`Device enumeration failed: ${err.message}`, 'Consult Settings Change', {
          timestamp: new Date().toISOString(),
          changeType: 'error',
          error: err.message,
          userId: user.username || 'unknown',
          sessionId: this.state.Pickupcode || 'unknown'
        });
      } catch (auditErr) {
        console.error("❌ [Consult Settings Change] Failed to log audit event:", auditErr);
      }
      
      this.showDeviceErrorAlert("There was an error accessing your device list.");
    }
  };

  handleDeviceSelectionChange = async (key, newDeviceId, newDeviceLabel, prevDeviceLabel) => {
    if (prevDeviceLabel === newDeviceLabel) return;

    const user = JSON.parse(sessionStorage.getItem('user')) || {};

    const deviceKeyToLabel = {
      selectedConsultRingingDevice: "Ring Notifications",
      selectedConsultCallingDevice: "Speaker",
      selectedConsultMicInput: "Microphone"
    };

    const readableKey = deviceKeyToLabel[key] || key;

    await writeAuditLog(`Manual device change for ${readableKey} from ${prevDeviceLabel} to ${newDeviceLabel}`, 'Consult Settings Change', {
      timestamp: new Date().toISOString(),
      previousDevice: prevDeviceLabel,
      newDevice: newDeviceLabel,
      changeType: 'manual',
      userId: user.username || 'unknown',
      sessionId: this.state.Pickupcode || 'unknown'
  });

    this.setState({ [key]: newDeviceId });
  };  

  handleConsultAudioPermissionEnable = async () => {
    const userConsultData = this._pendingConsultData;
    if (!userConsultData) return;
    const records = Array.isArray(userConsultData) ? userConsultData : [userConsultData];
    const consultRecord = records[0] || null;
    if (!consultRecord) return;

    // Re-check after the user's click gesture — should now be allowed
    const audioPlayAllowed = await testAudioPlayAllowed();
    if (!audioPlayAllowed) {
      console.warn('🔇 [Consult Audio Permission] Audio still blocked after user interaction – re-showing dialog');
      return;
    }

    this.setState({ showConsultAudioPermissionDialog: false, consultToggleLoading: true });

    try {
      if (!this.socket) {
        await this.initSocket();
      }
      await this.initFirebaseFCM(true);

      const isAudioOnly = consultRecord.is_audio_only === true;
      let permissionResult = { granted: true };
      if (!isAudioOnly) {
        permissionResult = await this.handleAccessPermissionStrictEnforcement();
      }

      this.setState({
        checkedB: true,
        isAudioOnlyConsult: isAudioOnly,
        checkedBDialog: Boolean(
          !this.state.refreshServiceWorker &&
          !localStorage.getItem('consultDiagnosticsShowed')
        ),
      });

      if (!permissionResult.granted) {
        const isCameraRelatedIssue = ['PERMISSION_DENIED', 'DEVICE_NOT_FOUND', 'CAMERA_IN_USE'].includes(permissionResult.reason);
        const issueTitle = DEVICE_ISSUE_TITLES[permissionResult.reason] || 'Device Permission Issue';
        this.addDeviceIssue({
          id: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED',
          title: issueTitle,
          message: `${permissionResult.description || 'Camera/microphone permissions not granted'}. ${isCameraRelatedIssue ? 'You can switch to Audio-Only mode to continue without a camera.' : 'Please resolve the issue to use video consultation.'}`,
          reason: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED_ON_ENABLE',
          showAudioOnlyButton: isCameraRelatedIssue,
        });
      }

      this._pendingConsultData = null;
    } catch (error) {
      console.error("❌ [Consult Audio Permission] Failed to enable consultation:", error);
      this._pendingConsultData = userConsultData;
      this.setState({ showConsultAudioPermissionDialog: true });
      toast.error("Unable to enable consultation right now. Please try again.");
    } finally {
      this.setState({ consultToggleLoading: false });
    }
  };

  handleConsultAudioPermissionDisable = () => {
    this._pendingConsultData = null;
    this.setState({ showConsultAudioPermissionDialog: false });
    
    // Explicitly update backend to turn off consultation so the user isn't stuck in a prompt loop
    if (this.state && this.state.userData && this.state.userData[0]) {
      this.handleSwitchChange(false);
    }
  };

  handleSwitchChange = async (isChecked) => {
    this.setState({ consultToggleLoading: true });
    // Clear device issues when consultation is toggled OFF
    if (!isChecked && this.state.deviceIssues.length > 0) {
      this.setState({ deviceIssues: [] });
    }

    if (this.state.consultOpen && !isChecked) {
      // if the camera is removed during the accept/decline modal screen
      this.setState({
        consultError: "Camera access is required to proceed with consultation.",
      });
    } else if (this.state.startConsult && !isChecked) {
      // if the camera is removed during the actual consult modal screen
      this.setState({
        consultError: "Camera access is required to proceed with consultation.",
      });
    } else {
      this.setState({ consultError: "" });
    }

    const usersData = this.state && this.state.userData && this.state.userData[0];

    // const isAudioOnly = localStorage.getItem("isAudioOnlyConsult") === "true";

    // Check permissions when enabling (but don't block - just show warning icon if issues)
    if (isChecked === true && !this.state.isAudioOnlyConsult && Boolean(this.state.cameraAndAudioPermissions) === false) {
      const permissionResult = await this.handleAccessPermissionStrictEnforcement();
      if (!permissionResult.granted) {
        // Permissions not granted - add issue to device issues array (don't block enabling)
        const isCameraRelatedIssue = ['PERMISSION_DENIED', 'DEVICE_NOT_FOUND', 'CAMERA_IN_USE'].includes(permissionResult.reason);
        const issueTitle = DEVICE_ISSUE_TITLES[permissionResult.reason] || 'Device Permission Issue';
        
        this.addDeviceIssue({
          id: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED',
          title: issueTitle,
          message: `${permissionResult.description || 'Camera/microphone permissions not granted'}. ${isCameraRelatedIssue ? 'You can switch to Audio-Only mode to continue without a camera.' : 'Please resolve the issue to use video consultation.'}`,
          reason: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED_ON_TOGGLE',
          showAudioOnlyButton: isCameraRelatedIssue
        });

        // Audit log for device issue on toggle - fire-and-forget for performance
        const auditResult = await writeAuditLogWithTokenCheck(
          `Device issue detected on consultation toggle: ${permissionResult.description}. Warning icon shown to user.`,
          'Consultation',
          {},
          {
            eventType: 'DEVICE_ISSUE_DETECTED',
            severity: 'WARNING',
            metadata: {
              actor: 'SYSTEM',
              reason: permissionResult.reason,
              errorName: permissionResult.errorName,
              consultationStillEnabled: true,
              timestamp: new Date().toISOString(),
            },
          },
          { deferMs: 0, wait: false }
        );
        
        // If user was logged out due to token expiry, don't continue
        if (auditResult.loggedOut) {
          return;
        }
        
        // Don't return - allow consultation to be enabled, just show warning icon
      }
    }

    // Prepare payload regardless of on/off
    const consultObject = {
      is_user_consult: isChecked,
      user_id: usersData.id,
      account_id: usersData.parent_account_id,
    };

    try {
      const response = await fetch(process.env.REACT_APP_BASEURL + 'userconsultupdate', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        },
        body: JSON.stringify(consultObject),
      });

      const uData = await response.text();
      const userConsultData = JSON.parse(uData);

      const status = userConsultData.user_consult.is_user_consult ? 'enabled' : 'disabled';
      await writeAuditLog(`Consultation is ${status} by user.`, 'Consultation', {
        userId: usersData.id,
      });
      // const eventTypeForToggle = userConsultData.user_consult.is_user_consult
      //   ? 'PHARMACIST_CONNECTION_ESTABLISHED'
      //   : 'PHARMACIST_CONNECTION_LOST';
      // const severityForToggle = userConsultData.user_consult.is_user_consult ? 'INFO' : 'WARNING';
      // await writeAuditLog(
      //   `Consultation is ${status} by user.`,
      //   'Consultation',
      //   {
      //     userId: usersData.id,
      //   },
      //   {
      //     eventType: eventTypeForToggle,
      //     source: 'PORTAL',
      //     severity: severityForToggle,
      //     metadata: {
      //       status,
      //     },
      //   }
      // );

      this.setState({
        checkedB: userConsultData.user_consult.is_user_consult,
      });

      // 🔁 Init or destroy socket/FCM based on toggle
      if (userConsultData.user_consult.is_user_consult) {
        if (!this.socket) {
          await this.initSocket();
          console.log('UserConsultFlagUpdate calling: InitSocket!');
        }
        await this.initFirebaseFCM();
      } else {
        console.log('UserConsultFlagUpdate calling: FirebaseFCM Disconnect!');
        await this.removeFirebaseFCM();
        console.log('UserConsultFlagUpdate calling: Socket Disconnect!');
        this.socket && this.socket.disconnect();
        this.socket = false;
        this.firebaseToken = false;
      }
    } catch (error) {
      console.error("❌ Failed to update consultation toggle:", error);
      toast.error("An error occurred while updating consultation status.");
    } finally {
      this.setState({ consultToggleLoading: false });
    }
  };

  handleReleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: true });
  };
  releaseorderaccept = async () => {
    this.setState({ ReleaseOrder: true, isReleaseOrderProgress: true });
    var statusObj = {
      user_consult_notification_id: this.state.Notifications
        .user_consult_notification_id,
      is_releaseorder: true,
    };

    /* Audit trail for order released by consultant. */
    const { prescriptionMasterId } = this.state;
    await writeAuditLog(`User released order.`, 'Release order', { prescriptionMasterId: prescriptionMasterId });

    fetch(process.env.REACT_APP_BASEURL + 'updateReleaseOrderStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(statusObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.socket &&
          this.socket.emit('releaseOrder', {
            pucode: this.state.Pickupcode,
            message: 'Order Released Successfully!!',
          });
        toast.success(this.props.t('Toast.Success.OrderReleased'));
        this.state.orderNotReleasedOpen
          ? this.endConsultationSession()
          : this.setState({ ReleaseOrderOpen: false });
      });
  };
  handleCloseRleaseOrder = () => {
    this.setState({ ReleaseOrderOpen: false });
  };
  getPrescriptionDetailByPickupCode = (ordersPickUpCode) => {
    console.log(`⚙️ [Function] Home.getPrescriptionDetailByPickupCode: Fetching prescription details`, { ordersPickUpCode });
    fetch(
      process.env.REACT_APP_BASEURL + 'getprescriptiondetailbypucode',
      {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify({ ordersPickUpCode })
      }
    )
      .then((response) => {
        console.log(`🌐 [Network] Home.getPrescriptionDetailByPickupCode: Received response`);
        try {
          return response.text();
        } catch (error) {
          console.log(`❌ [Error] Home.getPrescriptionDetailByPickupCode: Failed to parse response`, error);
          return null;
        }
      })
      .then((pData) => {
        if (pData) {
          console.log(`🌐 [Network] Home.getPrescriptionDetailByPickupCode: Successfully parsed prescription data`);
          let data = JSON.parse(pData);
          // DI-5364: Group by pucode for multi pick-up accordion on left side
          const byPucode = {};
          (Array.isArray(data) ? data : []).forEach((row) => {
            const pucode = row.pucode || row.puCode || '';
            if (!byPucode[pucode]) byPucode[pucode] = [];
            byPucode[pucode].push(row);
          });
          const consultationOrdersByPucode = Object.keys(byPucode).map((pucode) => ({
            pucode,
            items: byPucode[pucode],
          }));
          console.log(`🔄 [State] Home.getPrescriptionDetailByPickupCode: Updating prescription state data`, { ordersCount: consultationOrdersByPucode.length });
          this.setState({
            PatietPrescriptionData: data,
            consultationOrdersByPucode,
            PatientEmail: data[0].email,
            PatientPhone: data[0].phone,
            PatientDOB: data[0].dob,
            IdRawData: data[0].dlrawdata,
            firstName: data[0].first_name,
            lastName: data[0].last_name,
            dob: [undefined, 'undefined', null, 'null', ''].includes(data[0].dob) ? '' : data[0].dob.split('-').reverse().join('-'),
            stateCode: data[0].selectedstatecode,
            relationship: data[0].relationship,
            expDate: [undefined, 'undefined', null, 'null', ''].includes(data[0].expdate) ? '' : data[0].expdate.split('-').reverse().join('-'),
            DLNo: data[0].drivers_license_no,
            cardType: data[0].cardtype,
            IdData: data,
            accountName: data[0].account_name,
            boxName: data[0].box_name,
            stockDate: data[0].stocked_date
          });
        } else {
          console.log(`⚙️ [Function] Home.getPrescriptionDetailByPickupCode: No prescription data found`);
        }
      })
      .catch(error => {
        console.log(`❌ [Error] Home.getPrescriptionDetailByPickupCode: Error fetching prescription details`, error);
      });
  };
  createRow = (dataOverride) => {
    const { classes } = this.props;
    const Data = dataOverride != null ? dataOverride : (this.state && this.state.PatietPrescriptionData);
    if (Data && Array.isArray(Data)) {
      return Data.map((val, idx) => (
        <TableRow
          key={`${val.pucode || ''}-${idx}`}
          style={
            val.is_controlled_substance === true
              ? { backgroundColor: '#FFF7ED' }
              : undefined
          }
        >
          <TableCell className={classNames(classes.removePadding)} style={{ padding: 0 }}>
            {val.rx_no}
          </TableCell>
          <TableCell className={classNames(classes.removePadding)} style={{ padding: 0 }}>
            {val.drug_name}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: 0 }}>
            {val.doseage_form}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: 0 }}>
            {val.qty}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: 0 }}>
            {val.bin_id}
          </TableCell>
          <TableCell className={classNames(classes.AmountAlignment)} style={{ padding: 0 }}>
            {this.convertToTimeZone(val.stocked_date)}
          </TableCell>
        </TableRow>
      ));
    }
    return null;
  };
  handleChangeConsultNotes = (event) => {
    console.log(`🖱️ [Event] Home.handleChangeConsultNotes: Consult notes changed`);
    event.preventDefault && event.preventDefault();
    console.log(`🔄 [State] Home.handleChangeConsultNotes: Updating consult notes state`);
    this.setState({ consultnotes: event.target.value });
  };
  handleScheduleclick = (id) => {
    let Obj = {
      id: id,
    };
    fetch(process.env.REACT_APP_BASEURL + 'UpdateScheduleNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(Obj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        //console.log(uData);
      });
    navigate(`/home/reports/consultation/scheduleconsultreport`);
  };

  handleChangeCreateSecureBadgePassword = (e) => {
    this.setState({ createSecureBadgePassword: e.target.value });
  };


  handleSubmitCreateSecureBadge = (e) => {
    e && e.preventDefault();
    this.setState({ loader: true, errorMessage: "" });
    fetch(process.env.REACT_APP_BASEURL + "generate/secure/badge", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      }
    })
      .then((response) => response.text())
      .then((res) => {
        res = JSON.parse(res);
        this.setState({
          qrCodeImg: res.secureBadge,
          loader: false,
          errorMessage: "",
        });
        if (res.secureBadge) {
          toast.success(res.message, {
            className: "topAlignment no-print",
            autoClose: 1000
          });
          this.setState({ showSecureBadgeCode: true });
        } else {
          toast.error(res.message, {
            className: "topAlignment",
            autoClose: 1000
          });
          this.setState({ showSecureBadgeCode: false });
        }
      })
      .catch((reason) => {
        toast.error(reason.message);
        this.setState({
          loader: false,
          showSecureBadgeCode: false,
          errorMessage: reason.message,
        });
      });
  };

  handleSecureBadgeUserAction = (e) => {
    this.setState({
      secureBadgeAction: e.target.value
    })
  };

  handleSecureBadgeConfirm = (e) => {
    console.log(`🖱️ [Event] Home.handleSecureBadgeConfirm: Confirming secure badge action`, { action: this.state.secureBadgeAction });
    const { secureBadgeAction } = this.state;

    if (secureBadgeAction === 'print') {
      console.log(`⚙️ [Function] Home.handleSecureBadgeConfirm: Printing secure badge`);
      this.setState({
        printSecureBadgeQR: !this.state.printSecureBadgeQR
      });
      console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Toggled printSecureBadgeQR state`);

      setTimeout(() => {
        console.log(`⚙️ [Function] Home.handleSecureBadgeConfirm: Triggering print action`);
        window.print();
        console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Resetting printSecureBadgeQR state`);
        this.setState({
          printSecureBadgeQR: false,
          loader: false,
          showSecureBadgeCode: false,
          errorMessage: '',
        });
        console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Updated state after print action`);
      }, 1700);

    } else if (secureBadgeAction === 'download') {
      console.log(`⚙️ [Function] Home.handleSecureBadgeConfirm: Downloading secure badge`);

      try {
        // get content from the s3 bucket 
        const Obj = {
          url: this.state.qrCodeImg
        };
        console.log(`🌐 [Network] Home.handleSecureBadgeConfirm: Fetching secure badge image from S3`, { url: Obj.url });
        fetch(process.env.REACT_APP_BASEURL + 'downloadSecureBadge', {
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
          body: JSON.stringify(Obj),
        })
          .then((response) => response.json())
          .then(res => {
            console.log(`🌐 [Network] Home.handleSecureBadgeConfirm: Received secure badge image URL`, { url: res.url });
            const link = document.createElement('a');
            link.href = res.url;
            link.target = "_Blank";
            link.download = "secure_badge.png"
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Resetting UI states after download`);
            this.setState({
              loader: false,
              showSecureBadgeCode: false,
              errorMessage: '',
            });
            console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Updated state after download`);
            res.success ? toast.success(res.message, { className: 'topAlignment no-print' }) : toast.error(res.message, { className: 'topAlignment' });
          })
          .catch(error => {
            console.error(`❌ [Error] Home.handleSecureBadgeConfirm: Error fetching secure badge image`, error);
          });
      } catch (error) {
        console.error(`❌ [Error] Home.handleSecureBadgeConfirm: Error generating URL`, error);
      }

    } else if (secureBadgeAction === 'email') {
      console.log(`⚙️ [Function] Home.handleSecureBadgeConfirm: Emailing secure badge`);

      const { qrCodeImg } = this.state;
      const Obj = {
        file: qrCodeImg
      };
      console.log(`🌐 [Network] Home.handleSecureBadgeConfirm: Sending secure badge image to email`, { file: Obj.file });
      fetch(process.env.REACT_APP_BASEURL + 'emailSecureBadge', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(Obj),
      })
        .then(res => res.json())
        .then((response) => {
          console.log(`🌐 [Network] Home.handleSecureBadgeConfirm: Received email response`, { success: response.success, message: response.message });
          console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Resetting UI states after email`);
          this.setState({
            showSecureBadgeCode: false,
            qrCodeImg: qrCodeImg,
            loader: false,
            errorMessage: '',
          });
          console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Updated state after email`);
          response.success ? toast.success(response.message, { className: 'topAlignment no-print' }) : toast.error(response.message, { className: 'topAlignment' });
        })
        .catch((error) => {
          console.error(`❌ [Error] Home.handleSecureBadgeConfirm: Error sending secure badge email`, error);
          toast.error(error.message);
          console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Resetting UI states after email error`);
          this.setState({
            loader: false,
            showSecureBadgeCode: false,
            errorMessage: error.message,
          });
          console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Updated state after email error`);
        })

    } else {
      console.log(`⚙️ [Function] Home.handleSecureBadgeConfirm: Invalid secure badge action`, { action: secureBadgeAction });
      console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Resetting UI states for invalid action`);
      this.setState({
        loader: false,
        showSecureBadgeCode: true,
        errorMessage: "Invalid request",
      });
      console.log(`🔄 [State] Home.handleSecureBadgeConfirm: Updated state for invalid action`);
    }

  };

  handleClosePopUp = (close) => {
    console.log(`🖱️ [Event] Home.handleClosePopUp: Closing popup`, { close, checked: this.state.checked });
    
    // Always close the popup first
    this.setState({ isOpen: false });
    console.log(`🔄 [State] Home.handleClosePopUp: Updated popup state`);

    // Only send acknowledgment if checkbox is checked and we have notification details
    if (this.state.checked && this.state.notificationDetails) {
      console.log(`🌐 [Network] Home.handleClosePopUp: Sending acknowledgment to server for announcement ID: ${this.state.notificationDetails.id}`);
      
      fetch(
        process.env.REACT_APP_BASEURL + 'releasing/history/popUpNotification',
        {
          method: 'POST',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ announcementId: this.state.notificationDetails.id }),
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((response) => {
          console.log(`🌐 [Network] Home.handleClosePopUp: Successfully acknowledged announcement`, { response });
          // Reset checkbox state after successful acknowledgment
          this.setState({ checked: false });
          console.log(`🔄 [State] Home.handleClosePopUp: Reset checkbox state after acknowledgment`);
          return response;
        })
        .catch((error) => {
          console.error(`❌ [Error] Home.handleClosePopUp: Error sending acknowledgment`, error);
          // Show error to user but don't prevent popup from closing
          toast.error('Failed to save your preference. Please try again.');
          return error;
        });
    } else {
      console.log(`⚙️ [Function] Home.handleClosePopUp: Checkbox not checked or no notification details, skipping acknowledgment`);
      // Reset checkbox state even if not checked
      this.setState({ checked: false });
    }
  };

  handleReload = () => {
    console.log(`🖱️ [Event] Home.handleReload: Reloading page`);
    window.location.reload(true);
    console.log(`🔄 [State] Home.handleReload: Updated popup state`);
    this.setState({ isOpen: false });
    console.log(`🔄 [State] Home.handleReload: Updated popup state`);
  };

  handleCheckbox = (value) => {
    console.log(`🖱️ [Event] Home.handleCheckbox: Checkbox value changed`, { value });
    this.setState({ checked: value });
    console.log(`🔄 [State] Home.handleCheckbox: Updated checkbox state`);
  };

  handleConsultDiagnostics = (value) => {
    console.log(`🖱️ [Event] Home.handleConsultDiagnostics: Consult diagnostics value changed`, { value });
    this.setState({ openConsultDiagnostics: value, loader: value });
    console.log(`🔄 [State] Home.handleConsultDiagnostics: Updated consult diagnostics state`);
  };

  handleCloseTestConsultationPopupLoader = () => {
    console.log(`🖱️ [Event] Home.handleCloseTestConsultationPopupLoader: Closing test consultation popup loader`);
    this.setState({ loader: false });
    console.log(`🔄 [State] Home.handleCloseTestConsultationPopupLoader: Updated loader state`);
  };

  handleCustomerHelp = () => {
    console.log(`🖱️ [Event] Home.handleCustomerHelp: Handling customer help`);
  }
  handleAutomationMenu = (event) => {
    console.log(`🖱️ [Event] Home.handleAutomationMenu: Opening automation menu`);
    this.setState({ anchorAutomationEl: event.currentTarget });
    console.log(`🔄 [State] Home.handleAutomationMenu: Updated automation menu state`);
  };

  handleConsultDoNotAskMeAgain = () => {
    console.log(`🖱️ [Event] Home.handleConsultDoNotAskMeAgain: Toggling consult do not ask me again`);
    this.setState({ browserTestDoNotAskMeAgain: !this.state.browserTestDoNotAskMeAgain });
    console.log(`🔄 [State] Home.handleConsultDoNotAskMeAgain: Updated consult do not ask me again state`);
  }

  handleCloseBtn = () => {
    console.log(`🖱️ [Event] Home.handleCloseBtn: Closing dialog`);
    const { browserTestDoNotAskMeAgain } = this.state;
    if (browserTestDoNotAskMeAgain) {
      console.log(`⚙️ [Function] Home.handleCloseBtn: Saving do not ask me again preference to localStorage`);
      localStorage.setItem('browserTestDoNotAskMeAgain', true);
    }
    console.log(`🔄 [State] Home.handleCloseBtn: Updated localStorage preference`);
  }

  gettingTaskNotification = (val) => {
    // console.log(`⚙️ [Function] Home.gettingTaskNotification: Fetching task notifications`, { val });
    // try {
    //   console.log(`🌐 [Network] Home.gettingTaskNotification: Sending request to server`);
    //   fetch(
    //     process.env.REACT_APP_BASEURL +
    //     `taskmanager/notification?isReadable=${val}`,
    //     {
    //       method: 'GET',
    //       headers: {
    //         Authorization:
    //           'Bearer ' +
    //           JSON.parse(sessionStorage.getItem('user')).signInUserSession
    //             .idToken.jwtToken,
    //         'Content-Type': 'application/json',
    //       },
    //     }
    //   )
    //     .then((response) => response.json())
    //     .then((response) => {
    //       console.log(`🌐 [Network] Home.gettingTaskNotification: Received server response`, { response });
    //       if (response) {
    //         let { notificationCount, notification, replica } = response['data'];
    //         console.log(`🔄 [State] Home.gettingTaskNotification: Updating notification state`, { notificationCount, replica });
    //         this.setState({ notificationCount, replica });
    //         if (val === false) {
    //           console.log(`🔄 [State] Home.gettingTaskNotification: Updating notification data state`);
    //           this.setState({ notificationData: notification });
    //         } else {
    //           let { notificationData } = this.state;
    //           if (
    //             typeof notificationData === 'object' &&
    //             Object.keys(notificationData)['length'] !== 0
    //           ) {
    //             console.log(`⚙️ [Function] Home.gettingTaskNotification: Preparing notification data`);
    //             let preparedNotificationData = Object.entries(
    //               notificationData
    //             ).reduce((obj, [node, block]) => {
    //               let blockDef = notification[node] ? notification[node] : [];
    //               return {
    //                 ...obj,
    //                 [node]: [...blockDef, ...block],
    //               };
    //             }, {});
    //             console.log(`🔄 [State] Home.gettingTaskNotification: Updating notification data state`, { preparedNotificationData });
    //             this.setState({ notificationData: preparedNotificationData });
    //           } else {
    //             console.log(`🔄 [State] Home.gettingTaskNotification: Updating notification data state`, { notification });
    //             this.setState({ notificationData: notification });
    //           }
    //         }
    //       }
    //     });
    // } catch (Error) {
    //   console.error(`❌ [Error] Home.gettingTaskNotification: Error fetching task notifications`, Error);
    // }
  };

  updateTaskNotification = (request) => {
    console.log(`⚙️ [Function] Home.updateTaskNotification: Updating task notifications`, { request });
    try {
      console.log(`🌐 [Network] Home.updateTaskNotification: Sending request to server`);
      fetch(process.env.REACT_APP_BASEURL + 'taskmanager/updatenotification', {
        method: 'PUT',
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          TaskIDs: request,
        }),
      })
        .then((response) => response.json())
        .then(() => {
          console.log(`🌐 [Network] Home.updateTaskNotification: Received server response`);
        });
    } catch (Error) {
      console.error(`❌ [Error] Home.updateTaskNotification: Error updating task notifications`, Error);
    }
  };

  handleNavigateToUserProfile = () => {
    console.log(`🖱️ [Event] Home.handleNavigateToUserProfile: Navigating to user profile`);
    navigate(`/home/manage/users`, {
      state: { UserID: this.user.id },
      replace: false,
    });
    console.log(`🔄 [State] Home.handleNavigateToUserProfile: Navigated to user profile`);
  };

  handleSkipEvent = async () => {
    console.log(`🖱️ [Event] Home.handleSkipEvent: Skipping video check fault`);
    this.setState({ refreshServiceWorker: false, showTroubleTitle: true });
    console.log(`🔄 [State] Home.handleSkipEvent: Updated video check fault state`);
    await writeAuditLog(`The user pressed the 'Skip' button during a video check fault.`, 'Video Fault Check');
    console.log(`⚙️ [Function] Home.handleSkipEvent: Wrote audit log for skip event`);
  }

  handleShowWarning = async () => {
    console.log(`🖱️ [Event] Home.handleShowWarning: Showing video fault warning`);
    this.setState({ showWarning: true })
    console.log(`🔄 [State] Home.handleShowWarning: Updated video fault warning state`);
    await writeAuditLog(`The user pressed the video fault red warning title message.`, 'Video Fault Check');
    console.log(`⚙️ [Function] Home.handleShowWarning: Wrote audit log for warning event`);
  }

  getLocationsByAccount = (forceShowDialog = false) => {
    console.log(`⚙️ [Function] Home.getLocationsByAccount: Starting location fetch for account`, { forceShowDialog });
    // Get All Locations by Account
    const parentAccountId = sessionStorage.getItem('parentAccountId');
    console.log(`⚙️ [Function] Home.getLocationsByAccount: Retrieved parent account ID`, { parentAccountId });

    if (![undefined, undefined, null, null, ''].includes(parentAccountId)) {
      console.log(`🌐 [Network] Home.getLocationsByAccount: Fetching boxes for store ID`, { parentAccountId });
      fetch(`${process.env.REACT_APP_BASEURL}getBoxesByStoreId/${parentAccountId}`, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        }
      })
        .then((response) => response.json())
        .then((locationResponse) => {
          console.log(`🌐 [Network] Home.getLocationsByAccount: Received location data`, {
            count: locationResponse.length
          });

          const selectedLocation = localStorage.getItem('selectedLocation');
          const defaultLocation = locationResponse.length > 0 ? locationResponse[0].id : null;
          const boxList = locationResponse.length > 0 ?
            (locationResponse.map((x) => { return { id: x.id, value: x.name, locationtype_id: x.location_type_id } })) : [];

          // Check if there are any Counter locations
          const hasCounterLocations = locationResponse.some(
            (location) => location.location_type_id === LOCATION_TYPE.Counter
          );
          
          // Store flag in localStorage for menu visibility
          localStorage.setItem('hasCounterLocations', hasCounterLocations ? 'true' : 'false');

          // Show preferred location dialog if:
          // 1. forceShowDialog is true (user clicked on location name to change it), OR
          // 2. No preferred location is set
          const hasPreferredLocation = ![undefined, 'undefined', null, 'null', ''].includes(selectedLocation);
          const shouldShowDialog = forceShowDialog || !hasPreferredLocation;
          const finalSelectedBoxId = hasPreferredLocation ? selectedLocation : defaultLocation;

          console.log(`🔄 [State] Home.getLocationsByAccount: Updating location state`, {
            boxListCount: boxList.length,
            preferredLocation: shouldShowDialog,
            selectedBoxId: finalSelectedBoxId,
            hasPreferredLocation: hasPreferredLocation,
            forceShowDialog: forceShowDialog
          });

          this.setState({
            boxList: boxList,
            preferredLocation: shouldShowDialog,
            selectedBoxId: finalSelectedBoxId,
            hasCounterLocations: hasCounterLocations
          });
        }).catch((error) => {
          console.log(`❌ [Error] Home.getLocationsByAccount: Failed to fetch locations`, error);
          this.setState({ boxList: [], hasCounterLocations: false });
          toast.error(error.message);
        });
    } else {
      console.log(`⚙️ [Function] Home.getLocationsByAccount: No valid parent account ID found, skipping fetch`);
      this.setState({ hasCounterLocations: false });
    }
  }

  handleBoxChange = (event) => {
    console.log(`🖱️ [Event] Home.handleBoxChange: Box selection changed`, { newBoxId: event.target.value });
    this.setState({
      selectedBoxId: event.target.value,
      hasPreferredLocationSelected: true
    });
    console.log(`🔄 [State] Home.handleBoxChange: Updated box selection state`);
  }

  handleBoxSelect = (e) => {
    console.log(`🖱️ [Event] Home.handleBoxSelect: Box selection confirmed`);
    e && e.preventDefault();
    const { selectedBoxId, boxList } = this.state;

    console.log(`⚙️ [Function] Home.handleBoxSelect: Checking if valid box ID is selected`, { selectedBoxId });
    if ([undefined, 'undefined', null, 'null', ''].includes(selectedBoxId)) {
      console.log(`🔄 [State] Home.handleBoxSelect: No valid box ID selected, updating state`);
      this.setState({ hasPreferredLocationSelected: false });
    } else {
      console.log(`⚙️ [Function] Home.handleBoxSelect: Valid box ID selected, finding location data`);
      const _selectedLocation = boxList.filter((x) => x.id === selectedBoxId)[0];
      console.log(`⚙️ [Function] Home.handleBoxSelect: Location found`, {
        locationId: _selectedLocation.id,
        locationName: _selectedLocation.value
      });

      const loggedInUser = sessionStorage.getItem('user');
      if (![undefined, 'undefined', null, 'null', ''].includes(loggedInUser)) {
        console.log(`⚙️ [Function] Home.handleBoxSelect: User found, setting preferred location`);
        this.setPreferredLocation(selectedBoxId, _selectedLocation.locationtype_id, JSON.parse(loggedInUser));
      } else {
        console.log(`⚙️ [Function] Home.handleBoxSelect: No valid user found, cannot set preferred location`);
      }
    }
  }

  setPreferredLocation = (selectedBoxId, locationtype_id, loggedInUser) => {
    console.log(`🖱️ [Event] Home.setPreferredLocation: Preferred location change requested`, { selectedBoxId, locationtype_id, loggedInUser });
    this.setState({ isInProgress: true });
    const ObjToSendAsPayload = {
      selected_location_id: selectedBoxId,
      selected_location_type_id: locationtype_id,
      user_id: loggedInUser.username
    }
    this.setState({ preferredLocation: false, hasPreferredLocationSelected: true, isInProgress: false });
    console.log(`🌐 [Network] Home.setPreferredLocation: Sending request to set preferred location`);
    fetch(process.env.REACT_APP_BASEURL + 'set/preferred/location', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(ObjToSendAsPayload),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        console.log(`🌐 [Network] Home.setPreferredLocation: Received response`, { uData });
        if (![undefined, undefined, null, null, ''].includes(uData)) {
          const parsedUData = JSON.parse(uData);
          if (parsedUData && parsedUData._userPreferredLocationResponse && parsedUData._userPreferredLocationResponse.selected_location_id) {
            console.log(`⚙️ [Function] Home.setPreferredLocation: Saving preferred location to localStorage`);
            localStorage.setItem('selectedLocation', parsedUData._userPreferredLocationResponse.selected_location_id);
            localStorage.setItem('selectedLocationTypeId', parsedUData._userPreferredLocationResponse.selected_location_type_id)
            localStorage.setItem('selected_location_name', parsedUData._userPreferredLocationResponse.selected_location_name)
            console.log(`🔄 [State] Home.setPreferredLocation: Updating preferred location state`);
            this.setState({
              preferredLocation: false,
              hasPreferredLocationSelected: true,
              isInProgress: false
            });
          } else {
            console.log(`🔄 [State] Home.setPreferredLocation: Updating preferred location state`);
            this.setState({
              isInProgress: false
            })
          }
        } else {
          console.log(`🔄 [State] Home.setPreferredLocation: Updating preferred location state`);
          this.setState({
            preferredLocation: false,
            hasPreferredLocationSelected: false,
            isInProgress: false
          });
        }
      }).catch((error) => {
        console.error(`❌ [Error] Home.setPreferredLocation: Error setting preferred location`, error);
        this.setPreferredLocation(selectedBoxId, locationtype_id, loggedInUser)
        this.setState({ isInProgress: false })
      })
  }

  submitSelectedRejection = (e) => {
    console.log(`🖱️ [Event] Home.submitSelectedRejection: Rejection reason selected`, { reasonId: e.target.value });
    this.setState({ selectedReasonId: e.target.value })
    console.log(`🔄 [State] Home.submitSelectedRejection: Updated rejection reason state`);
  }

  setSelectedReasonText = (e) => {
    console.log(`🖱️ [Event] Home.setSelectedReasonText: Rejection reason text changed`, { text: e.target.value });
    this.setState({ selectedReasonText: e.target.value })
    console.log(`🔄 [State] Home.setSelectedReasonText: Updated rejection reason text state`);
  }

  setIdCaptureType = (id_capture_type) => {
    console.log(`🖱️ [Event] Home.setIdCaptureType: ID capture type set`, { id_capture_type });
    this.setState({ id_capture_type: id_capture_type })
    console.log(`🔄 [State] Home.setIdCaptureType: Updated ID capture type state`);
  }

  handleVideoFaultRefreshAction = async (type) => {
    console.log(`🖱️ [Event] Home.handleVideoFaultRefreshAction: Video fault refresh action triggered`, { type });
    let auditLogMessage = type === 0 ? `The user pressed the 'Refresh' button during a video check fault.` : `The user pressed the 'Refresh' from the red title message dialog.`
    await writeAuditLog(auditLogMessage, 'Video Fault Check');
    console.log(`⚙️ [Function] Home.handleVideoFaultRefreshAction: Wrote audit log for refresh action`);
    this.setState({ refreshServiceWorker: false }, () => {
      console.log(`🖱️ [Event] Home.handleVideoFaultRefreshAction: Reloading page`);
      window.location.reload(true);
    })
  }


  async componentDidUpdate(prevProps, prevState) {
    console.log(`📱 [Lifecycle] Home.componentDidUpdate: Component updated`);
    
    if (this.state.checkedB) {
      console.log(`⚙️ [Function] Home.componentDidUpdate: Consultation is enabled, checking socket initialization`);
      if (!this.socket) {
        console.log(`🌐 [Network] Home.componentDidUpdate: Socket not initialized, initializing now`);
        await this.initSocket().then(() =>
          console.log(`🌐 [Network] Home.componentDidUpdate: Socket initialization complete`)
        );
      }
      // await this.initFirebaseFCM();
      // setInterval(async () => {
      //   this.firebaseToken = await getFirebaseToken(
      //     !this.state.refreshServiceWorker &&
      //     (() =>
      //       this.setState({
      //         refreshServiceWorker: true,
      //       }))
      //   );
      //   if (this.firebaseToken) {
      //     await fetch(
      //       process.env.REACT_APP_BASEURL + `fcm/user/set/${this.firebaseToken}`,
      //       {
      //         method: 'PUT',
      //         headers: {
      //             Authorization: `Bearer ${
      //               JSON.parse(sessionStorage.getItem('user')).signInUserSession
      //             .idToken.jwtToken
      //             }`,
      //           'Content-Type': 'application/json',
      //         },
      //       }
      //     );
      //   }
      // }, (30 * 60 * 1000));
      // }, (1 * 60 * 1000)); // DO NOT COMMIT THIS LINE.
      
      // Only set up FCM listener ONCE when checkedB is true
      // This prevents multiple FCM listeners from being registered on every component update
      // The listener will re-register itself after each message (since onMessageListenerFCM returns a Promise that resolves once)
      if (!this.fcmListenerInitialized) {
        console.log(`🌐 [Network] Home.componentDidUpdate: Setting up FCM message listener (first time)`);
        this.fcmListenerInitialized = true;
        this.setupFCMListener();
      }
    } else {
      console.log(`⚙️ [Function] Home.componentDidUpdate: Consultation is disabled, skipping socket and FCM setup`);
      // Reset FCM listener flag when consultation is disabled
      if (this.fcmListenerInitialized) {
        console.log(`⚙️ [Function] Home.componentDidUpdate: Resetting FCM listener flag`);
        this.fcmListenerInitialized = false;
      }
    }
  }

  // FCM listener setup extracted to separate method for clarity
  // This is called when checkedB becomes true, and re-registers itself after each message
  // because onMessageListenerFCM returns a Promise that only resolves once
  setupFCMListener = () => {
    console.log(`🌐 [Network] Home.setupFCMListener: Setting up FCM message listener`);
      onMessageListenerFCM()
        .then((payload) => {
          if (payload) {
            console.log(`🌐 [Network] Home.setupFCMListener: FCM notification received in foreground`, {
              title: payload.notification.title,
              body: payload.notification.body
            });
            
            // Phase 1: Capture active call's pickup code BEFORE state update (to prevent overwrite)
            const activeCallPucode = this.state.startConsult ? (this.state.Pickupcode || '').toLowerCase() : '';
            const incomingPucode = (payload.notification.body || '').toLowerCase();
            
            console.log(`📞 [Phase 1] Home.setupFCMListener: Captured pickup codes before state update`, {
              activeCallPucode: activeCallPucode,
              incomingPucode: incomingPucode,
              startConsult: this.state.startConsult
            });
            
            // Play sound for foreground notification (continuous for consult calls) - only if no active video call
            if (!this.state.isCallActive) {
            playNotificationSound(false, undefined, true);
            }
            
            // Phase 1: Don't update Pickupcode if there's an active call OR if dialog is already open (to prevent overwriting pending/active call details)
            const stateUpdate = {
                isFirebaseNotification: true,
                firebaseNotification: {
                  title: payload.notification.title,
                  body: payload.notification.body,
                },
            };
            
            // Only update Pickupcode if there's no active call AND dialog is not open (first-come-first-served)
            // If dialog is open, we should queue the call instead of overwriting the current pending call
            if (!this.state.startConsult && !this.state.consultOpen) {
              stateUpdate.Pickupcode = payload.notification.body;
              console.log(`📞 [Phase 1] Home.setupFCMListener: No active call and dialog not open, updating Pickupcode to`, payload.notification.body);
            } else {
              if (this.state.startConsult) {
                console.log(`📞 [Phase 1] Home.setupFCMListener: Active call exists, NOT updating Pickupcode (preserving active call: ${this.state.Pickupcode})`);
              } else if (this.state.consultOpen) {
                console.log(`📞 [Phase 1] Home.setupFCMListener: Dialog already open for pending call, NOT updating Pickupcode (preserving pending call: ${this.state.Pickupcode}) - will queue incoming call`);
              }
            }
            
            this.setState(
              stateUpdate,
              () => {
                console.log(`🔄 [State] Home.setupFCMListener: Updated notification state with FCM data`);
              }
            );
            console.log(`⚙️ [Function] Home.setupFCMListener: Initiating consultation callback from FCM foreground`, {
              consultOpen: this.state.consultOpen,
              startConsult: this.state.startConsult,
              activeCallPucode: activeCallPucode,
              incomingPucode: incomingPucode
            });
            
            // Phase 1: Always call consultCallback - it will queue if active call exists OR if dialog is open, or show dialog if not
            // Pass the captured activeCallPucode to consultCallback for proper comparison
            if (this.state.startConsult) {
              // Phase 1: Active call exists - consultCallback will queue the call
              console.log(`📞 [Phase 1] Home.setupFCMListener: ✅ Active call exists, calling consultCallback to queue incoming call`);
              // Pass the captured activeCallPucode to consultCallback
              this.consultCallback(activeCallPucode);
            } else if (this.state.consultOpen) {
              // Dialog is open for a pending call - queue this incoming call instead of overwriting
              console.log(`📞 [Phase 1] Home.setupFCMListener: Dialog open for pending call, calling consultCallback to queue incoming call (first-come-first-served)`);
              // Pass the current Pickupcode (from the pending call) as the activeCallPucode so it gets queued
              const pendingCallPucode = (this.state.Pickupcode || '').toLowerCase();
              this.consultCallback(pendingCallPucode);
            } else {
              // No active call and no dialog open - show dialog
              console.log(`⚙️ [Function] Home.setupFCMListener: No active call, calling consultCallback to show dialog`);
              // Pass the captured activeCallPucode to consultCallback
              this.consultCallback(activeCallPucode);
            }
            console.log(`⚙️ [Function] Home.setupFCMListener: Using pickup code`, { code: this.state.Pickupcode });
          } else {
            console.log(`🌐 [Network] Home.setupFCMListener: FCM message listener returned empty payload`);
          }
          
          // Re-register the FCM listener for the next message
          // onMessageListenerFCM returns a Promise that only resolves once, so we need to re-register
          if (this.state.checkedB && this.fcmListenerInitialized) {
            console.log(`🌐 [Network] Home.setupFCMListener: Re-registering FCM listener for next message`);
            this.setupFCMListener();
          }
        })
        .catch((err) => {
          console.log(`❌ [Error] Home.setupFCMListener: FCM message listener error`, err);
          // Re-register even on error to keep listening
          if (this.state.checkedB && this.fcmListenerInitialized) {
            console.log(`🌐 [Network] Home.setupFCMListener: Re-registering FCM listener after error`);
            this.setupFCMListener();
          }
        });
  };

  componentDidMount() {
    console.log(`📱 [Lifecycle] Home.componentDidMount: Component mounting`);
    
    // Log TourGuide ref status after mount
    setTimeout(() => {
      console.log('[Home] componentDidMount - TourGuide ref status', {
        timestamp: new Date().toISOString(),
        hasRef: !!this.tourGuideRef,
        hasCurrent: !!(this.tourGuideRef && this.tourGuideRef.current),
        refType: this.tourGuideRef ? this.tourGuideRef.constructor.name : 'N/A'
      });
    }, 2000);
    let preferredLang = sessionStorage.getItem('preferredLanguage');
    const doNotShowBrowserTestPopup = Boolean(JSON.parse(localStorage.getItem('browserTestDoNotAskMeAgain')));

    if (!doNotShowBrowserTestPopup) {
      console.log(`🔄 [State] Home.componentDidMount: Setting browser test popup to visible`);
      this.setState({
        showTestYourBrowserPopup: true
      })
    }
    if (preferredLang !== '' && preferredLang !== undefined) {
      console.log(`⚙️ [Function] Home.componentDidMount: Setting preferred language`, { language: preferredLang });
      this.props.i18n.changeLanguage(preferredLang);
    }
    console.log(`⚙️ [Function] Home.componentDidMount: Getting user session data`);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    console.log(`⚙️ [Function] Home.componentDidMount: Refreshing authentication token`);
    this.refreshToken();
    
    // Re-establish auto-logout timer on page refresh
    console.log(`⚙️ [Function] Home.componentDidMount: Restoring token expiry timer`);
    restoreTokenExpiryTimer();

    // Listen for session expiry warning event
    this.handleTokenExpiryWarning = (event) => {
      console.log('⏰ [TokenExpiry] Received session expiry warning', event.detail);
      this.setState({ showSessionExpiryWarning: true });
    };
    window.addEventListener('tokenExpiryWarning', this.handleTokenExpiryWarning);

    console.log(`⚙️ [Function] Home.componentDidMount: Checking consult blacklist`);
    let consultBlackList = JSON.parse(localStorage.getItem('consultBlackList'));
    if (consultBlackList && consultBlackList.length > 0) {
      console.log(`⚙️ [Function] Home.componentDidMount: Consult blacklist exists with ${consultBlackList.length} entries`);
      // do nothing!
    } else {
      console.log(`⚙️ [Function] Home.componentDidMount: Initializing empty consult blacklist`);
      let blackConsultBlackList = [];
      localStorage.setItem(
        'consultBlackList',
        JSON.stringify(blackConsultBlackList)
      );
    }

    // Helper to check and open announcement modal if needed
    const checkAndOpenAnnouncementModal = (userData, notificationDetails) => {
      if (!userData || !notificationDetails) return;
      console.log(`🔄 [State] Home.componentDidMount: Setting popup visible for concerned user (parentAccountId match)`);
      // Reset checkbox state when showing new announcement
      this.setState({ isOpen: true, checked: false });
    };

    // We'll store userData and notificationDetails temporarily
    this._announcementUserData = null;
    this._announcementNotificationDetails = null;

    // Fetch user details first
    console.log(`🌐 [Network] Home.componentDidMount: Fetching user details`);
    fetch(
      process.env.REACT_APP_BASEURL +
      'users/' +
      JSON.parse(sessionStorage.getItem('user')).username,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        console.log(`🌐 [Network] Home.componentDidMount: Received user details response`);
        try {
          return response.json();
        } catch (error) {
          console.log(`❌ [Error] Home.componentDidMount: Failed to parse user details response`, error);
          return null;
        }
      })
      .then((userData) => {
        if (userData) {
          console.log(`⚙️ [Function] Home.componentDidMount: Processing user data`);
          const accountConnectionId = userData && userData[0] && userData[0].parentAccount && userData[0].parentAccount.account_connections_id;
          localStorage.setItem('isNumericCode', userData[0].parentAccount.is_numeric_code);
          sessionStorage.setItem('accountConnectionId', accountConnectionId);
          sessionStorage.setItem('is_pre_assignment', userData && userData[0] && userData[0].parentAccount && userData[0].parentAccount.is_pre_assignment);
          const isUnplugged = accountConnectionId === connectionType.UNPLUGGED ? true : false;

          console.log(`🔄 [State] Home.componentDidMount: Updating user data state`, {
            userName: (userData && userData[0] && userData[0].name) || userData.name,
            isUnplugged
          });
          this.setState({
            LoggedInUserName:
              (userData && userData[0] && userData[0].name) || userData.name,
            userData,
            isUnplugged,
            tourWelcomeHidden: !!(userData[0] && userData[0].tour_welcome_hidden),
          });

          // Save for announcement modal logic
          this._announcementUserData = userData;
          // If notificationDetails already fetched, check for modal
          if (this._announcementNotificationDetails) {
            checkAndOpenAnnouncementModal(this._announcementUserData, this._announcementNotificationDetails);
          }

          console.log(`⚙️ [Function] Home.componentDidMount: Checking user permissions for consult`);
          let permissions = JSON.parse(sessionStorage.getItem('permissions'));
          if (permissions && permissions.length > 0) {
            let consultpermission = false;
            for (let i = 0; i < permissions.length; i++) {
              if (permissions[i].name === 'Consult' && permissions[i].is_allowed === 1 && permissions[i].permission_id === '6a9e176e-a98e-455f-b502-b3792d25f67c') {
                consultpermission = true;
                break;
              }
            }
            console.log(`🔄 [State] Home.componentDidMount: Setting consult permission flag`, { consultpermission });
            this.setState({ consultpermission });
          } else {
            console.log(`⚙️ [Function] Home.componentDidMount: No permissions found in session`);
          }
        } else {
          console.log(`❌ [Error] Home.componentDidMount: No user data received`);
        }
      })
      .catch(error => {
        console.log(`❌ [Error] Home.componentDidMount: Failed to fetch user details`, error);
      });

    // Fetch release history (announcement)
    console.log(`🌐 [Network] Home.componentDidMount: Fetching release history`);
    fetch(process.env.REACT_APP_BASEURL + 'releasing/history', {
      method: 'GET',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        console.log(`🌐 [Network] Home.componentDidMount: Received release history response`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((res) => {
        if (res && res.releasingHistory && res.releasingHistory.needsAck) {
          console.log(`🔄 [State] Home.componentDidMount: Updating notification details`, { 
            announcementId: res.releasingHistory.id, 
            needsAck: res.releasingHistory.needsAck 
          });
          this.setState({ notificationDetails: res.releasingHistory });

          // Ex. if asked to implement - Only show for non-superadmin users
          // let role = JSON.parse(sessionStorage.getItem('superadmin'));

          this._announcementNotificationDetails = res.releasingHistory;
          if (this._announcementUserData) {
            checkAndOpenAnnouncementModal(this._announcementUserData, this._announcementNotificationDetails);
          }
        } else {
          console.log(`⚙️ [Function] Home.componentDidMount: No release history data received or no acknowledgment needed`);
          // Clear any existing notification details if no announcement needs acknowledgment
          this.setState({ notificationDetails: null, isOpen: false });
        }
      })
      .catch(error => {
        console.error(`❌ [Error] Home.componentDidMount: Failed to fetch release history`, error);
        // Clear notification details on error
        this.setState({ notificationDetails: null, isOpen: false });
      });

    // --- End Announcement Modal Logic Fix ---

    //Added By : Belani Jaimin
    console.log(`🌐 [Network] Home.componentDidMount: Fetching user consult flag`);
    fetch(
      process.env.REACT_APP_BASEURL +
      'userconsultflag/' +
      JSON.parse(sessionStorage.getItem('user')).username,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        console.log(`🌐 [Network] Home.componentDidMount: Received user consult flag response`);
        if (response.status === 404) return null;
        try {
          return response.text();
        } catch (error) {
          console.log(`❌ [Error] Home.componentDidMount: Failed to parse user consult flag response`, error);
          return null;
        }
      })
      .then(async (uData) => {
        console.log(`⚙️ [Function] Home.componentDidMount: Processing consult flag data`, { dataReceived: !!uData });
        if (uData !== null && uData !== '') {
          const userConsultData = JSON.parse(uData);
          // Defensive: guard against any future shape regression
          const records = Array.isArray(userConsultData) ? userConsultData : [userConsultData];
          const consultRecord = records[0] || null;
          if (consultRecord) {
            console.log(`⚙️ [Function] Home.componentDidMount: User consult data found`, {
              isUserConsult: consultRecord.is_user_consult
            });

            const isConsultEnabled = consultRecord.is_user_consult === true;

            // Before enabling consultation, probe whether the browser will permit audio playback.
            // After an SSO redirect there is no user gesture, so play() throws NotAllowedError.
            // If that is the case we defer full initialisation until the user explicitly clicks
            // "Enable Consultation" in the permission dialog.
            let audioPlayAllowed = true;
            if (isConsultEnabled) {
              audioPlayAllowed = await testAudioPlayAllowed();
              if (!audioPlayAllowed) {
                console.log(`🔇 [Audio] Home.componentDidMount: play() blocked by autoplay policy – showing permission dialog`);
                this._pendingConsultData = userConsultData;
                this.setState({ showConsultAudioPermissionDialog: true });
              }
            }

            if (isConsultEnabled && audioPlayAllowed) {
              this.setState({ consultToggleLoading: true });
              console.log(`🌐 [Network] Home.componentDidMount: Consult is enabled, initializing socket and FCM`);
              if (!this.socket) {
                await this.initSocket().then(() =>
                  console.log(`🌐 [Network] Home.componentDidMount: Socket initialized from user consult flag`)
                );
              }
              await this.initFirebaseFCM(true);
            }

            console.log(`🔄 [State] Home.componentDidMount: Setting consult UI state based on user preference`);
            if (isConsultEnabled && audioPlayAllowed) {
              // When the component mounts, check from DB instead of localstorage if the user has enabled Audio only mode
              // const isAudioOnly = localStorage.getItem("isAudioOnlyConsult") === "true";
              const isAudioOnly = consultRecord.is_audio_only === true;
              let permissionResult = { granted: true };

              // Only enforce permission check when video is required
              if (!isAudioOnly) {
                permissionResult = await this.handleAccessPermissionStrictEnforcement();
              }

              // Keep consultation enabled regardless of permission result
              // If permissions fail, show warning icon instead of disabling
              this.setState({
                checkedB: true,
                checkedBDialog: Boolean(
                  !this.state.refreshServiceWorker &&
                  !localStorage.getItem('consultDiagnosticsShowed')
                ),
              });
              console.log(`🔄 [State] Home.componentDidMount: Consult enabled, set checkedB=true`);

              if (!permissionResult.granted) {
                // Permissions not granted - add issue to device issues array (don't disable consultation)
                const isCameraRelatedIssue = ['PERMISSION_DENIED', 'DEVICE_NOT_FOUND', 'CAMERA_IN_USE'].includes(permissionResult.reason);
                const issueTitle = DEVICE_ISSUE_TITLES[permissionResult.reason] || 'Device Permission Issue';
                
                this.addDeviceIssue({
                  id: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED',
                  title: issueTitle,
                  message: `${permissionResult.description || 'Camera/microphone permissions not granted'}. ${isCameraRelatedIssue ? 'You can switch to Audio-Only mode to continue without a camera.' : 'Please resolve the issue to use video consultation.'}`,
                  reason: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED_ON_LOAD',
                  showAudioOnlyButton: isCameraRelatedIssue
                });

                // Audit log for device issue on page load - fire-and-forget for performance
                const auditResult = await writeAuditLogWithTokenCheck(
                  `Device issue detected on page load: ${permissionResult.description || 'Camera/microphone permissions not granted'}. Warning icon shown to user.`,
                  'Consultation',
                  {},
                  {
                    eventType: 'DEVICE_ISSUE_DETECTED',
                    severity: 'WARNING',
                    metadata: {
                      actor: 'SYSTEM',
                      reason: permissionResult.reason || 'PERMISSIONS_NOT_GRANTED_ON_LOAD',
                      errorName: permissionResult.errorName,
                      consultationStillEnabled: true,
                      timestamp: new Date().toISOString(),
                    },
                  },
                  { deferMs: 0, wait: false }
                );
                
                // If user was logged out due to token expiry, don't continue
                if (auditResult.loggedOut) {
                  return;
                }
                
                console.log(`🔄 [State] Home.componentDidMount - Permissions not granted: Device issue added, consultation still enabled`);
              }
            } else if (!isConsultEnabled) {
              this.setState({
                checkedB: false,
                checkedBDialog: false,
                consultAcknowledgeDialog: Boolean(
                  !localStorage.getItem('consultAcknowledgeShowed')
                ),
              });
              console.log(`🔄 [State] Home.componentDidMount: Consult disabled, set checkedB=false`);
            }

            console.log(`🔄 [State] Home.componentDidMount: Setting Audio-only settings UI state based on user preference`);
            this.setState({
              isAudioOnlyConsult: consultRecord.is_audio_only === true,
              consultToggleLoading: false,
            })
          } else {
            console.log(`🔄 [State] Home.componentDidMount: No consult data, defaulting to disabled`);
            this.setState({
              checkedB: false,
              checkedBDialog: false,
              consultAcknowledgeDialog: Boolean(
                !localStorage.getItem('consultAcknowledgeShowed')
              ),
              isAudioOnlyConsult: false,
            });
          }
        }

        console.log(`⚙️ [Function] Home.componentDidMount: Checking for selected location`);
        const isLocationSelected = localStorage.getItem('selectedLocation');
        if ([undefined, 'undefined', null, 'null', ''].includes(isLocationSelected)) {
          console.log(`⚙️ [Function] Home.componentDidMount: No location selected, will fetch locations`);
          setTimeout(() => {
            this.getLocationsByAccount();
          }, 500);
        } else {
          console.log(`⚙️ [Function] Home.componentDidMount: Location already selected`, { locationId: isLocationSelected });
          // Always fetch locations to check for Counter locations (for Bin Mapping menu visibility)
          setTimeout(() => {
            this.getLocationsByAccount();
          }, 500);
        }
      })
      .catch(error => {
        console.log(`❌ [Error] Home.componentDidMount: Error fetching consult flag`, error);
      });

    this.checkFCMServiceWorker();
    console.log(`⚙️ [Function] Home.componentDidMount: Fetching initial task notifications`);
    this.gettingTaskNotification(false);


    // Initialize device tracking state
    this.initializeDeviceTracking();

    // Add devicechange listener (only if supported)
    if (navigator.mediaDevices && typeof navigator.mediaDevices.addEventListener === 'function') {
      navigator.mediaDevices.addEventListener("devicechange", this.debouncedHandleDeviceChange);
    } else {
      console.warn('navigator.mediaDevices.addEventListener is not supported in this browser');
    }

    //API call to get failed Message
    this.getFailedMessages()
  }

  initPresenceTracking = () => {
    // Import configuration
    const getPharmacistPresenceConfig = require('../../config/pharmacist-presence-config').default;
    const config = getPharmacistPresenceConfig();
    
    // Check if feature is enabled
    if (!config.enabled) {
      console.log('⚠️  Pharmacist presence tracking is disabled');
      return;
    }
    
    if (this.presenceWs) {
      return; // Already connected
    }

    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) return;

    const userId = user.username; // username IS email
    const username = user.username;
    
    // Get accountId from sessionStorage
    const accountId = sessionStorage.getItem('parentAccountId') || '';
    
    // Get locationId from localStorage
    let locationId = '';
    
    // Try different localStorage keys and formats
    const selectedLocationStr = localStorage.getItem('selectedLocation');
    
    if (config.debugLogging) {
      console.log('🔍 DEBUG - Raw selectedLocation value:', selectedLocationStr);
    }
    
    if (selectedLocationStr) {
      try {
        // Try parsing as JSON
        const selectedLocation = JSON.parse(selectedLocationStr);
        if (config.debugLogging) {
          console.log('🔍 DEBUG - Parsed selectedLocation:', selectedLocation);
          console.log('🔍 DEBUG - Keys:', Object.keys(selectedLocation));
        }
        locationId = selectedLocation.id || selectedLocation.location_id || selectedLocation.locationId || '';
      } catch (e) {
        // If parsing fails, it might be a plain string (the ID itself)
        if (config.debugLogging) {
          console.log('🔍 DEBUG - Not JSON, using as plain string');
        }
        locationId = selectedLocationStr;
      }
    } else {
      // Try alternative keys
      locationId = localStorage.getItem('locationId') 
        || localStorage.getItem('location_id')
        || '';
      if (config.debugLogging) {
        console.log('🔍 DEBUG - Tried alternative keys, locationId:', locationId);
      }
    }
    
    if (config.debugLogging) {
      console.log('✅ Final locationId:', locationId);
    }
    
    // Connect to serverless WebSocket for presence tracking
    const wsUrl = config.websocketUrl;
    const consultEnabled = Boolean(this.state.checkedB);
    const fullUrl = `${wsUrl}/?userId=${userId}&username=${username}&accountId=${accountId}&locationId=${locationId}&consultEnabled=${consultEnabled}`;
    
    console.log('💓 ═══════════════════════════════════════════════════════');
    console.log('💓 PRESENCE TRACKING - CONNECTING');
    console.log('💓 ═══════════════════════════════════════════════════════');
    console.log(`💓 URL: ${wsUrl}`);
    console.log(`💓 User: ${username}`);
    console.log(`💓 AccountId: ${accountId}`);
    console.log(`💓 LocationId: ${locationId}`);
    console.log(`💓 Time: ${new Date().toISOString()}`);
    console.log('💓 ═══════════════════════════════════════════════════════');
    
    // Track connecting state
    this.setState({ presenceSocketStatus: 'connecting', presenceSocketError: null });
    this.presenceWs = new WebSocket(fullUrl);
    
    this.presenceWs.onopen = async () => {
      console.log('✅ Presence tracking connected');
      this.setState({ presenceSocketStatus: 'connected', presenceSocketError: null });
      
      // Log recovery if we previously had an initial failure
      if (this.state.presenceSocketRecoveryPending) {
        await logPresenceSocketConnectionRecovered();
        this.setState({ presenceSocketRecoveryPending: false });
      }
      
      // Start heartbeat interval (configurable, default: 30 seconds)
      this.presenceHeartbeatInterval = setInterval(() => {
        if (this.presenceWs && this.presenceWs.readyState === WebSocket.OPEN) {
          const heartbeatMessage = {
            action: 'heartbeat',
            userId: userId,
            username: username,
            accountId: accountId,
            locationId: locationId,
            consultEnabled: Boolean(this.state.checkedB),
            timestamp: Date.now(),
          };
          
          this.presenceWs.send(JSON.stringify(heartbeatMessage));
          
          // Log occasionally (every 10th heartbeat to reduce noise)
          if (config.debugLogging || Math.random() < 0.1) {
            console.log('💓 Heartbeat sent:', username);
          }
        }
      }, config.heartbeatInterval);
      
      console.log(`✅ Heartbeat interval started (${config.heartbeatInterval / 1000}s)}`);
    };
    
    this.presenceWs.onclose = () => {
      console.log('❌ Presence tracking disconnected');
      this.setState({ presenceSocketStatus: 'disconnected' });
      
      // Clear heartbeat interval
      if (this.presenceHeartbeatInterval) {
        clearInterval(this.presenceHeartbeatInterval);
        this.presenceHeartbeatInterval = null;
        console.log('🔴 Heartbeat interval cleared');
      }
      
      // Only auto-reconnect if component is still mounted (not closing tab/logout)
      if (!this.presenceIntentionallyClosed && config.autoReconnect) {
        console.log(`🔄 Auto-reconnecting in ${config.reconnectDelay / 1000} seconds...`);
        setTimeout(() => {
          this.presenceWs = null;
          this.initPresenceTracking();
        }, config.reconnectDelay);
      } else {
        console.log('🔴 Not reconnecting (intentionally closed or auto-reconnect disabled)');
      }
    };
    
    this.presenceWs.onerror = async (err) => {
      console.error('❌ Presence WS error:', err);
      this.setState({ presenceSocketStatus: 'error', presenceSocketError: 'WebSocket error' });
      
      // Only log initial failure once
      if (!this.state.presenceSocketInitialFailureLogged) {
        await logPresenceSocketInitialConnectionFailed('WebSocket error');
        this.setState({ 
          presenceSocketInitialFailureLogged: true,
          presenceSocketRecoveryPending: true 
        });
      }
    };
  };

  componentWillUnmount() {
    // Close presence tracking WebSocket
    if (this.presenceWs) {
      console.log('🔴 Closing presence tracking WebSocket');
      
      // Set flag to prevent auto-reconnect
      this.presenceIntentionallyClosed = true;
      
      // Clear heartbeat interval
      if (this.presenceHeartbeatInterval) {
        clearInterval(this.presenceHeartbeatInterval);
        this.presenceHeartbeatInterval = null;
        console.log('🔴 Heartbeat interval cleared (unmount)');
      }
      
      this.presenceWs.close();
    }
    
    // Remove devicechange listener (only if it was added)
    if (navigator.mediaDevices && typeof navigator.mediaDevices.removeEventListener === 'function') {
      navigator.mediaDevices.removeEventListener("devicechange", this.debouncedHandleDeviceChange);
    }
    
    // Phase 1: Clean up incoming call beep interval
    if (this.incomingCallBeepInterval) {
      clearInterval(this.incomingCallBeepInterval);
      this.incomingCallBeepInterval = null;
    }
    stopLightBeepSound();
    
    // Remove token expiry warning listener
    if (this.handleTokenExpiryWarning) {
      window.removeEventListener('tokenExpiryWarning', this.handleTokenExpiryWarning);
    }
  }

  checkFCMServiceWorker() {
    const sw = getServiceWorker();
    console.log(`⚙️ [Function] Home.checkFCMServiceWorker: Checking FCM service worker status`, {
      consultEnabled: this.state.checkedB,
      swExists: !!sw
    });

    if (this.state.checkedB && sw && sw.getRegistrations) {
      console.log(`⚙️ [Function] Home.checkFCMServiceWorker: Consultation enabled, querying service worker registrations`);
      sw.getRegistrations().then(async (registrations) => {
        console.log(`⚙️ [Function] Home.checkFCMServiceWorker: Retrieved ${registrations.length} service worker registrations`);
        const firebaseSwExists = registrations.findIndex((data) =>
          data.active.scriptURL.includes('firebase-messaging-sw.js')
        ) !== -1;

        if (!firebaseSwExists) {
          console.log(`⚙️ [Function] Home.checkFCMServiceWorker: Firebase messaging service worker not found, reloading page`);
          window.location.reload(true);
        } else {
          console.log(`⚙️ [Function] Home.checkFCMServiceWorker: Firebase messaging service worker found, initializing FCM`);
          await this.initFirebaseFCM();
        }
      }).catch(error => {
        console.log(`❌ [Error] Home.checkFCMServiceWorker: Error checking service worker registrations`, error);
      });
    } else {
      console.log(`⚙️ [Function] Home.checkFCMServiceWorker: Skipping service worker check, requirements not met`);
    }
  }

  handleConsultAcknowledgeDialog(event) {
    console.log(`🖱️ [Event] Home.handleConsultAcknowledgeDialog: Consult acknowledge dialog closed`);
    this.setState({ consultAcknowledgeDialog: false });
    this.handleSwitchChange(true);
  }

  refreshToken = async () => {
    const functionStartTime = Date.now();
    console.log(`🌐 [Network] Home.refreshToken: Starting token refresh process`, {
      timestamp: new Date().toISOString()
    });

    try {
      // First try to get user from Cognito if possible
      let cognitoUser = null;
      try {
        console.log(`🌐 [Network] Home.refreshToken: Attempting to retrieve authenticated Cognito user`);
        cognitoUser = await Auth.currentAuthenticatedUser();
        console.log(`🌐 [Network] Home.refreshToken: Retrieved current authenticated Cognito user`, {
          username: cognitoUser && cognitoUser.username,
          userId: cognitoUser && cognitoUser.attributes && cognitoUser.attributes.sub,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      } catch (error) {
        console.log(`⚠️ [Warning] Home.refreshToken: Could not get Cognito user, may be using alternative authentication`, {
          errorName: error.name,
          errorMessage: error.message,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        // Don't throw - this could be using SSO or another auth method
      }

      // Fallback to session storage if Cognito auth failed
      if (!cognitoUser) {
        console.log(`🌐 [Network] Home.refreshToken: No Cognito user found, checking sessionStorage for user data`);
        const sessionUser = sessionStorage.getItem('user');
        if (sessionUser) {
          this.user = JSON.parse(sessionUser);
          console.log(`🌐 [Network] Home.refreshToken: Using user from sessionStorage`, {
            username: this.user && this.user.username,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
        } else {
          console.log(`❌ [Error] Home.refreshToken: No user found in sessionStorage`, {
            elapsed: `${Date.now() - functionStartTime}ms`
          });
          return null;
        }
      } else {
        // If we have a Cognito user, update this.user
        this.user = cognitoUser;
      }

      // For Cognito users, continue with token refresh
      if (cognitoUser && cognitoUser.signInUserSession && cognitoUser.signInUserSession.refreshToken) {
        const currentSession = cognitoUser.signInUserSession;

        try {
          const idTokenExpire = currentSession.idToken.payload.exp * 1000;
          const accessTokenExpire = currentSession.accessToken.payload.exp * 1000;
          const currentTimeSeconds = Date.now();

          console.log(`⚙️ [Function] Home.refreshToken: Checking token expiration`, {
            idTokenExpiresAt: new Date(idTokenExpire).toISOString(),
            accessTokenExpiresAt: new Date(accessTokenExpire).toISOString(),
            currentTime: new Date(currentTimeSeconds).toISOString(),
            idTokenTimeRemaining: Math.floor((idTokenExpire - currentTimeSeconds) / 1000) + ' seconds',
            accessTokenTimeRemaining: Math.floor((accessTokenExpire - currentTimeSeconds) / 1000) + ' seconds',
            isIdTokenExpired: idTokenExpire < currentTimeSeconds,
            isAccessTokenExpired: accessTokenExpire < currentTimeSeconds,
            elapsed: `${Date.now() - functionStartTime}ms`
          });

          if (idTokenExpire < currentTimeSeconds) {
            console.log(`🌐 [Network] Home.refreshToken: ID Token is expired, initiating refresh`, {
              elapsed: `${Date.now() - functionStartTime}ms`
            });

            // Create a promise wrapper for the callback-based refreshSession
            await new Promise((resolve, reject) => {
              cognitoUser.refreshSession(
                currentSession.refreshToken,
                (err, session) => {
                  if (err) {
                    console.log(`❌ [Error] Home.refreshToken: Failed to refresh token`, {
                      errorName: err.name,
                      errorMessage: err.message,
                      errorStack: err.stack,
                      errorCode: err.code || 'UNKNOWN',
                      retryable: err.retryable || false,
                      elapsed: `${Date.now() - functionStartTime}ms`
                    });

                    // Check for specific error types for better diagnostics
                    if (err.name === 'NotAuthorizedException') {
                      console.log(`❌ [Error] Home.refreshToken: Authorization failed - user may need to sign in again`, {
                        elapsed: `${Date.now() - functionStartTime}ms`
                      });
                    } else if (err.name === 'TokenExpiredError') {
                      console.log(`❌ [Error] Home.refreshToken: Refresh token has expired, forcing re-authentication`, {
                        elapsed: `${Date.now() - functionStartTime}ms`
                      });
                    } else if (err.name === 'NetworkError') {
                      console.log(`❌ [Error] Home.refreshToken: Network error during token refresh, check connectivity`, {
                        elapsed: `${Date.now() - functionStartTime}ms`
                      });
                    }

                    reject(err);
                    return;
                  }

                  console.log(`🌐 [Network] Home.refreshToken: Token refreshed successfully from expiry`, {
                    newIdTokenExpiry: new Date(session.idToken.payload.exp * 1000).toISOString(),
                    newAccessTokenExpiry: new Date(session.accessToken.payload.exp * 1000).toISOString(),
                    tokenIssuer: session.idToken.payload.iss,
                    elapsed: `${Date.now() - functionStartTime}ms`
                  });

                  this.user = cognitoUser;
                  sessionStorage.setItem('user', JSON.stringify(cognitoUser));
                  
                  // Reset auto-logout timer with new token expiry
                  setupTokenExpiryHandler(cognitoUser, { loginMethod: 'STANDARD' });
                  
                  resolve(session);
                }
              );
            }).catch(error => {
              // This catch is for the promise wrapper
              console.log(`❌ [Error] Home.refreshToken: Error in refresh promise`, {
                errorMessage: error.message,
                elapsed: `${Date.now() - functionStartTime}ms`
              });
              // Don't rethrow - we'll continue with existing tokens
            });
          } else {
            console.log(`🌐 [Network] Home.refreshToken: Token is still valid, no immediate refresh needed`, {
              elapsed: `${Date.now() - functionStartTime}ms`
            });
          }
        } catch (tokenError) {
          console.log(`❌ [Error] Home.refreshToken: Error processing token expiration`, {
            errorName: tokenError.name,
            errorMessage: tokenError.message,
            errorStack: tokenError.stack,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
          // Continue execution despite token expiration error
        }
      } else if (!cognitoUser) {
        // Not a Cognito user, log this but don't fail
        console.log(`⚠️ [Warning] Home.refreshToken: Not a Cognito user, using session storage data`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      }

      // Set up token refresh interval if not already set
      if (!this.refreshTokenInterval) {
        console.log(`⚙️ [Function] Home.refreshToken: Setting up token refresh interval (55 minutes)`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });

        this.refreshTokenInterval = setInterval(async () => {
          const intervalStartTime = Date.now();
          console.log(`🌐 [Network] Home.refreshToken: Scheduled refresh interval triggered`, {
            timestamp: new Date().toISOString()
          });

          try {
            // Check if we have a Cognito user by attempting to get one
            let isCognitoUser = false;
            try {
              const currentUser = await Auth.currentAuthenticatedUser();
              isCognitoUser = !!(currentUser && currentUser.signInUserSession && currentUser.signInUserSession.refreshToken);

              if (isCognitoUser) {
                // Create a promise wrapper for the callback-based refreshSession
                await new Promise((resolve, reject) => {
                  currentUser.refreshSession(
                    currentUser.signInUserSession.refreshToken,
                    (err, session) => {
                      if (err) {
                        console.log(`❌ [Error] Home.refreshToken: Interval refresh - Failed to refresh token`, {
                          errorName: err.name,
                          errorMessage: err.message,
                          errorStack: err.stack,
                          errorCode: err.code || 'UNKNOWN',
                          elapsed: `${Date.now() - intervalStartTime}ms`
                        });
                        reject(err);
                        return;
                      }

                      console.log(`🌐 [Network] Home.refreshToken: Interval refresh - Token refreshed successfully`, {
                        newIdTokenExpiry: new Date(session.idToken.payload.exp * 1000).toISOString(),
                        newAccessTokenExpiry: new Date(session.accessToken.payload.exp * 1000).toISOString(),
                        elapsed: `${Date.now() - intervalStartTime}ms`
                      });

                      this.user = currentUser;
                      sessionStorage.setItem('user', JSON.stringify(currentUser));
                      resolve(session);
                    }
                  );
                }).catch(error => {
                  // This catch is for the promise wrapper
                  console.log(`❌ [Error] Home.refreshToken: Interval refresh - Error in refresh promise`, {
                    errorMessage: error.message,
                    elapsed: `${Date.now() - intervalStartTime}ms`
                  });
                });
              } else {
                console.log(`⚠️ [Warning] Home.refreshToken: Interval refresh - No valid session to refresh`, {
                  hasUser: !!currentUser,
                  elapsed: `${Date.now() - intervalStartTime}ms`
                });
              }
            } catch (error) {
              console.log(`⚠️ [Warning] Home.refreshToken: Interval refresh - Not a Cognito user`, {
                errorName: error.name,
                errorMessage: error.message,
                elapsed: `${Date.now() - intervalStartTime}ms`
              });

              // For non-Cognito users, the token refresh is handled by their auth provider
              console.log(`⚙️ [Function] Home.refreshToken: Using alternative authentication, skipping Cognito refresh`, {
                elapsed: `${Date.now() - intervalStartTime}ms`
              });
            }
          } catch (intervalError) {
            console.log(`❌ [Error] Home.refreshToken: Interval refresh - Unexpected error`, {
              errorName: intervalError.name,
              errorMessage: intervalError.message,
              errorStack: intervalError.stack,
              elapsed: `${Date.now() - intervalStartTime}ms`
            });
          }
        }, 55 * 60 * 1000);

        console.log(`⚙️ [Function] Home.refreshToken: Refresh interval set with ID ${this.refreshTokenInterval}`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      }

      console.log(`⚙️ [Function] Home.refreshToken: Token refresh process completed successfully`, {
        totalDuration: `${Date.now() - functionStartTime}ms`
      });

      // Return whatever current session we have, could be null for non-Cognito users
      if (cognitoUser && cognitoUser.signInUserSession) {
        return cognitoUser.signInUserSession;
      } else {
        return this.user && this.user.signInUserSession;
      }
    } catch (e) {
      console.log(`❌ [Error] Home.refreshToken: Unhandled error during token refresh`, {
        errorName: e.name,
        errorMessage: e.message,
        errorStack: e.stack,
        errorCode: e.code || 'UNKNOWN',
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      // Continue with existing user from sessionStorage if available
      if (sessionStorage.getItem('user')) {
        console.log(`⚙️ [Function] Home.refreshToken: Falling back to existing user in sessionStorage`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        this.user = JSON.parse(sessionStorage.getItem('user'));
        return this.user.signInUserSession;
      }

      return null;
    }
  };

  //Added By Naresh | DI-461 | Date:16-04-2019 |Kiosk Offline Notification
  getKioskNotification = () => {
    const functionStartTime = Date.now();
    console.log(`⚙️ [Function] Home.getKioskNotification: Fetching kiosk notifications`, {
      timestamp: new Date().toISOString()
    });

    try {
      let user = JSON.parse(sessionStorage.getItem('user'));

      if (!user) {
        console.log(`❌ [Error] Home.getKioskNotification: No user found in session storage`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return;
      }

      let token =
        user &&
        user.signInUserSession &&
        user.signInUserSession.idToken &&
        user.signInUserSession.idToken.jwtToken;

      if (!token) {
        console.log(`❌ [Error] Home.getKioskNotification: No valid token found for user`, {
          userExists: !!user,
          sessionExists: !!(user && user.signInUserSession),
          tokenExists: !!(user && user.signInUserSession && user.signInUserSession.idToken),
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return;
      }

      console.log(`🌐 [Network] Home.getKioskNotification: Sending request to get kiosk notifications`, {
        endpoint: 'getKioskNotification',
        method: 'GET',
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      fetch(process.env.REACT_APP_BASEURL + 'getKioskNotification', {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          console.log(`🌐 [Network] Home.getKioskNotification: Received response`, {
            status: response.status,
            ok: response.ok,
            elapsed: `${Date.now() - functionStartTime}ms`
          });

          if (!response.ok) {
            console.log(`❌ [Error] Home.getKioskNotification: Server returned error response`, {
              status: response.status,
              statusText: response.statusText,
              elapsed: `${Date.now() - functionStartTime}ms`
            });
          }

          try {
            return response.json();
          } catch (parseError) {
            console.log(`❌ [Error] Home.getKioskNotification: Failed to parse JSON response`, {
              errorName: parseError.name,
              errorMessage: parseError.message,
              errorStack: parseError.stack,
              elapsed: `${Date.now() - functionStartTime}ms`
            });
            throw parseError;
          }
        })
        .then((boxesOffline) => {
          if (!boxesOffline) {
            console.log(`⚙️ [Function] Home.getKioskNotification: No data received`, {
              elapsed: `${Date.now() - functionStartTime}ms`
            });
            return;
          }

          console.log(`⚙️ [Function] Home.getKioskNotification: Processing received data`, {
            boxesOfflineCount: boxesOffline.boxesOffline ? boxesOffline.boxesOffline.length : 0,
            scheduleCount: boxesOffline.schedule ? boxesOffline.schedule.length : 0,
            elapsed: `${Date.now() - functionStartTime}ms`
          });

          let mergeArray = [];
          if (boxesOffline.boxesOffline && boxesOffline.boxesOffline.length > 0) {
            mergeArray = mergeArray.concat(boxesOffline.boxesOffline);
          }
          if (boxesOffline.schedule && boxesOffline.schedule.length > 0) {
            mergeArray = mergeArray.concat(boxesOffline.schedule);
          }

          console.log(`🔄 [State] Home.getKioskNotification: Updating kiosk notification state`, {
            mergedCount: mergeArray.length,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
          this.setState({ boxesOfflineNotification: mergeArray });
        })
        .catch((error) => {
          console.log(`❌ [Error] Home.getKioskNotification: Error fetching kiosk notifications`, {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
        })
        .finally(() => {
          console.log(`⚙️ [Function] Home.getKioskNotification: Function execution completed`, {
            totalDuration: `${Date.now() - functionStartTime}ms`
          });
        });
    } catch (error) {
      console.log(`❌ [Error] Home.getKioskNotification: Unexpected error`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
    }
  };

  consultCallback = (capturedActivePucode = null) => {
    console.log(`⚙️ [Function] Home.consultCallback: Initiating consultation callback process`, {
      timestamp: new Date().toISOString(),
      consultOpen: this.state.consultOpen,
      startConsult: this.state.startConsult,
      currentPickupcode: this.state.Pickupcode,
      capturedActivePucode: capturedActivePucode,
      currentIncomingCalls: this.state.incomingCalls.length
    });

    const callStartTime = Date.now();
    // ✅ CRITICAL FIX: Store both status and pucode to prevent cross-pharmacist call interference
    // This ensures we can verify the missed call modal is for the correct call
    const currentPucode = (this.state.Pickupcode || '').toString().trim().toUpperCase();
    localStorage.setItem(
      'IncomingConsultationCallStatus',
      'incomplete'
    );
    if (currentPucode) {
      localStorage.setItem(
        'IncomingConsultationCallPucode',
        currentPucode
      );
    }
    console.log(`🔄 [State] Home.consultCallback: Set initial call status to 'incomplete' in localStorage`, {
      pucode: currentPucode
    });

    let user = JSON.parse(sessionStorage.getItem('user'));
    if (
      user !== undefined &&
      user !== 'undefined' &&
      user !== null &&
      user !== 'null' &&
      user !== ''
    ) {
      console.log(`🌐 [Network] Home.consultCallback: Fetching notifications for user`, {
        userId: user.username,
        requestTime: new Date().toISOString()
      });

      fetch(
        `${process.env.REACT_APP_BASEURL}getNotificationsByUserId/${user.username}`,
        {
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => {
          console.log(`🌐 [Network] Home.consultCallback: Received notifications response`, {
            status: response.status,
            ok: response.ok,
            responseTime: new Date().toISOString(),
            elapsed: `${Date.now() - callStartTime}ms`
          });
          try {
            return response.json();
          } catch (error) {
            console.log(`❌ [Error] Home.consultCallback: Failed to parse notifications response`, {
              errorName: error.name,
              errorMessage: error.message,
              errorStack: error.stack
            });
            return null;
          }
        })
        .then(async (uData) => {
          // CRITICAL FIX: Process ALL notifications returned by API (multiple kiosks can call simultaneously)
          // API returns array ordered by created_on desc; previously only uData[0] was processed so second call never showed
          const notificationsList = Array.isArray(uData) ? uData : (uData && uData !== null ? [uData] : []);
          if (notificationsList.length === 0) {
            console.log(`⚙️ [Function] Home.consultCallback: No notification data found for user`, {
              elapsed: `${Date.now() - callStartTime}ms`
            });
            console.log(`🌐 [Network] Home.consultCallback: Writing generic audit log for incoming call`);
            try {
              await writeAuditLog(`User got incoming consultation call.`, 'Consultation');
              console.log(`🌐 [Network] Home.consultCallback: Generic audit log written successfully`);
            } catch (error) {
              console.log(`❌ [Error] Home.consultCallback: Error writing generic audit log`, {
                errorName: error.name,
                errorMessage: error.message,
                errorStack: error.stack
              });
            }
            console.log(`⚙️ [Function] Home.consultCallback: Closing consultation dialog due to missing notification data`);
            this.handleConsultClose();
            return;
          }

          console.log(`⚙️ [Function] Home.consultCallback: Processing ${notificationsList.length} notification(s) (multi-call fix)`, {
            resourceIds: notificationsList.map(n => (n.resource_id || '').toLowerCase()),
            elapsed: `${Date.now() - callStartTime}ms`
          });

          // Phase 1: Use captured active pucode if provided (to avoid state overwrite issue), otherwise use current state
          const currentActivePucode = (capturedActivePucode || this.state.Pickupcode || '').toString().trim().toLowerCase();
          // Issue A Fix: Queue if there's an active call OR if dialog is open for a pending call (first-come-first-served)
          const shouldQueue = (this.state.startConsult || this.state.consultOpen) && currentActivePucode;

          // Helper to build incoming call object from notification row
          const toIncomingCall = (notif) => {
            const pucode = (notif.resource_id || '').toString().trim().toLowerCase();
            return {
              pucode: pucode,
              notificationId: notif.user_consult_notification_id,
              notificationData: notif,
              patientName: notif.User_name || 'Patient',
              location: notif.kiosk_name || notif.store_name || 'Unknown Location',
              timestamp: Date.now(),
              isSilenced: false
            };
          };

          const currentIncomingCalls = Array.isArray(this.state.incomingCalls) ? this.state.incomingCalls : [];
          const existingPucodes = new Set(currentIncomingCalls.map(c => (c.pucode || '').toLowerCase()));

          if (shouldQueue) {
            // Queue ALL notifications that are not the current active/pending call and not already in queue
            const toAdd = [];
            for (let i = 0; i < notificationsList.length; i++) {
              const notif = notificationsList[i];
              const pucode = (notif.resource_id || '').toString().trim().toLowerCase();
              if (!pucode || pucode === currentActivePucode) continue;
              if (existingPucodes.has(pucode)) continue;
              existingPucodes.add(pucode);
              toAdd.push(toIncomingCall(notif));
            }

            if (toAdd.length > 0) {
              console.log(`📞 [Phase 1] Home.consultCallback: ✅ QUEUEING ${toAdd.length} incoming call(s) (active/dialog exists)`, {
                currentActivePucode: currentActivePucode,
                queuedPucodes: toAdd.map(c => c.pucode),
                patientNames: toAdd.map(c => c.patientName),
                currentIncomingCallsBefore: currentIncomingCalls.length
              });

              this.setState(prevState => {
                const prev = Array.isArray(prevState.incomingCalls) ? prevState.incomingCalls : [];
                const updatedIncomingCalls = [...prev];
                toAdd.forEach(call => {
                  const idx = updatedIncomingCalls.findIndex(c => (c.pucode || '').toLowerCase() === (call.pucode || '').toLowerCase());
                  if (idx >= 0) updatedIncomingCalls[idx] = call;
                  else updatedIncomingCalls.unshift(call);
                });
                return { incomingCalls: updatedIncomingCalls };
              }, () => {
                console.log(`📞 [Phase 1] Home.consultCallback: State updated, incoming calls:`, this.state.incomingCalls.length);
              });

              const queueTime = new Date().toISOString();
              toAdd.forEach(call => {
                if (this.socket && call.pucode) {
                  this.socket.emit('joinConsultationRoom', { pucode: call.pucode });
                  console.log(`🟡 [PORTAL][${queueTime}] Emitted joinConsultationRoom for ${call.pucode}`);
                }
                const silencedCallsArray = Array.isArray(this.state.silencedCalls) ? this.state.silencedCalls : [];
                if (!silencedCallsArray.includes((call.pucode || '').toLowerCase())) {
                  playLightBeepSound();
                }
              });
              console.log(`🟡 [PORTAL][${queueTime}] ✅ ${toAdd.length} call(s) queued - NOT showing dialog`);
            }
            return;
          }

          // No active call - show first notification in dialog and enqueue the rest so both show (Accept/Decline/Silence)
          const firstNotif = notificationsList[0];
          const pucode = (firstNotif.resource_id || '').toString().trim().toLowerCase();
          const isRecallAfterDisconnect = this.state.startConsult && !this.state.isCallActive && pucode === currentActivePucode;
          console.log(`⚙️ [Function] Home.consultCallback: No active call - showing first of ${notificationsList.length} in dialog, rest in queue`);

          if (isRecallAfterDisconnect) {
            console.log(`📞 [BUG FIX] Home.consultCallback: Same patient calling again after disconnect - resetting startConsult to show Accept/Decline`, {
              pucode: pucode,
              startConsult: this.state.startConsult,
              isCallActive: this.state.isCallActive
            });
            this.setState({ startConsult: false });
          }

          this.handleConsultClickOpen();
          console.log(`⚙️ [Function] Home.consultCallback: Setting notification object in state (first call)`);
          this.setNotificationObject(firstNotif);
          if (this.socket && firstNotif && firstNotif.resource_id) {
            const firstPucode = firstNotif.resource_id.toLowerCase();
            console.log(`🌐 [Network] Home.consultCallback: Joining consultation websocket room`, { pucode: firstPucode });
            this.socket.emit('joinConsultationRoom', { pucode: firstPucode });
          }

          // Enqueue any additional notifications so second (and subsequent) calls show in IncomingCallNotification with Accept/Decline/Silence
          if (notificationsList.length > 1) {
            const restCalls = [];
            for (let i = 1; i < notificationsList.length; i++) {
              const notif = notificationsList[i];
              const restPucode = (notif.resource_id || '').toString().trim().toLowerCase();
              if (!restPucode || restPucode === pucode) continue;
              if (existingPucodes.has(restPucode)) continue;
              restCalls.push(toIncomingCall(notif));
            }
            if (restCalls.length > 0) {
              console.log(`📞 [Phase 1] Home.consultCallback: Adding ${restCalls.length} simultaneous call(s) to incoming queue`, {
                pucodes: restCalls.map(c => c.pucode),
                patientNames: restCalls.map(c => c.patientName)
              });
              this.setState(prevState => {
                const prev = Array.isArray(prevState.incomingCalls) ? prevState.incomingCalls : [];
                const updatedIncomingCalls = [...prev];
                restCalls.forEach(call => {
                  const idx = updatedIncomingCalls.findIndex(c => (c.pucode || '').toLowerCase() === (call.pucode || '').toLowerCase());
                  if (idx >= 0) updatedIncomingCalls[idx] = call;
                  else updatedIncomingCalls.unshift(call);
                });
                return { incomingCalls: updatedIncomingCalls };
              });
              restCalls.forEach(call => {
                if (this.socket && call.pucode) {
                  this.socket.emit('joinConsultationRoom', { pucode: call.pucode });
                }
              });
            }
          }

          console.log(`⚙️ [Function] Home.consultCallback: Setting patient name and call metadata`);
          this.setPatientName(firstNotif, async () => {
              console.log(`⚙️ [Function] Home.consultCallback: Patient name set, recording box and resource IDs`);
              const { box_id, resource_id } = firstNotif;
              console.log(`⚙️ [Function] Home.consultCallback: Call metadata`, {
                boxId: box_id,
                resourceId: resource_id,
                elapsed: `${Date.now() - callStartTime}ms`
              });

              console.log(`⚙️ [Function] Home.consultCallback: Preparing audit log for incoming call`);
              const { first_name, last_name, patientName, prescriptionMasterId } = this.state;
              const auditPatientName = patientName || (this.state.Notifications && this.state.Notifications.User_name) || ((first_name && last_name) ? (first_name + ' ' + last_name) : 'patient');

              console.log(`🔄 [State] Home.consultCallback: Setting missed call patient name for future reference`, { patientName: auditPatientName });
              this.setState({
                missedCallPatientName: auditPatientName
              });

              console.log(`🌐 [Network] Home.consultCallback: Writing audit log for incoming call`);
              try {
                // Notification UI specific log: User got the incoming call
                const notifications = this.state && this.state.Notifications ? this.state.Notifications : {};
                const resourceIdUpper = (resource_id || '').toString().trim().toUpperCase();
                await logIncomingCallReceived(resourceIdUpper, auditPatientName, {
                  prescriptionMasterId: prescriptionMasterId,
                  notificationId: notifications.notification_id || firstNotif.notification_id,
                  userConsultNotificationId: notifications.user_consult_notification_id || firstNotif.user_consult_notification_id,
                  boxId: box_id,
                });
                
                // Check and audit WebSocket connectivity status
                await logWebSocketStatusOnIncomingCall(resourceIdUpper, auditPatientName, {
                  mainSocketStatus: this.state.mainSocketStatus,
                  mainSocketError: this.state.mainSocketError,
                  presenceSocketStatus: this.state.presenceSocketStatus,
                  presenceSocketError: this.state.presenceSocketError
                });
                
                // Legacy audit log (keeping for backward compatibility)
                await writeAuditLog(`User got incoming consultation call from '${auditPatientName}'.`, 'Consultation', { prescriptionMasterId: prescriptionMasterId });

                // await writeAuditLog(
                //   `User got incoming consultation call from '${auditPatientName}'.`,
                //   'Consultation',
                //   { prescriptionMasterId: prescriptionMasterId },
                //   {
                //     eventType: 'VIDEO_CONSULT_BROADCASTED_TO_PORTAL',
                //     source: 'PORTAL',
                //     severity: 'INFO',
                //     metadata: {
                //       pickupCode: resource_id,
                //       notificationId: notifications.notification_id || uData[0].notification_id,
                //       userConsultNotificationId: notifications.user_consult_notification_id || uData[0].user_consult_notification_id,
                //       boxId: box_id,
                //     },
                //   }
                // );
                console.log(`🌐 [Network] Home.consultCallback: Audit log written successfully`, {
                  elapsed: `${Date.now() - callStartTime}ms`,
                  completionTime: new Date().toISOString()
                });
              } catch (error) {
                console.log(`❌ [Error] Home.consultCallback: Error writing audit log`, {
                  errorName: error.name,
                  errorMessage: error.message,
                  errorStack: error.stack
                });
              }

              // Fetch prescription details to populate dialog data (accountName, boxName, stockDate, Rx data)
              console.log(`⚙️ [Function] Home.consultCallback: Fetching prescription details for dialog`, {
                ordersPickUpCode: this.state.ordersPickUpCode,
                elapsed: `${Date.now() - callStartTime}ms`
              });
              if (this.state.ordersPickUpCode) {
                this.getPrescriptionDetailByPickupCode(this.state.ordersPickUpCode);
              } else {
                console.log(`⚠️ [Warning] Home.consultCallback: No ordersPickUpCode available to fetch prescription details`);
              }
            });
        })
        .catch(error => {
          console.log(`❌ [Error] Home.consultCallback: Error processing consultation notifications`, {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            elapsed: `${Date.now() - callStartTime}ms`
          });
          this.handleConsultClose();
        });
    } else {
      console.log(`❌ [Error] Home.consultCallback: No valid user found in session storage`, {
        elapsed: `${Date.now() - callStartTime}ms`
      });
    }
  };

  state = {
    open: window.innerWidth > 768,
    openNotification: window.innerWidth > 768, //Added by Naresh | DI-461 | Date:16-04-2019
    anchorEl: null,
    anchorElNotification: null,
    value: 0,
  };

  handleConsultClickOpen = () => {
    console.log(`🖱️ [Event] Home.handleConsultClickOpen: Consult dialog opened`);
    this.setState({ consultOpen: true });
  };

  // Called when Twilio room disconnects (e.g., patient ends call from kiosk)
  handleTwilioRoomDisconnected = (roomName) => {
    console.log(`🔌 [Twilio] Home.handleTwilioRoomDisconnected: Room disconnected`, {
      roomName,
      currentPickupcode: this.state.Pickupcode,
      startConsult: this.state.startConsult
    });
    
    // Mark call as inactive so new calls can ring, but keep dialog open for notes
    this.setState({
      isCallActive: false,
      remoteAudioStreamForVisualizer: null, // Remove visualizer when patient ends call
      // Keep startConsult: true so dialog stays open for pharmacist to take notes
      // The "consultation has ended" overlay will be shown in TwilioVideo
    });
    
    // Stop notification sound if still playing
    stopNotificationSound();
  };

  acceptConsultCall = async () => {
    const callStartTime = Date.now();
    
    // Critical Fix: Ensure Pickupcode matches Notifications.resource_id to prevent overwrite issues
    // This ensures first-come-first-served behavior - we use the pickup code from the notification
    // that the pharmacist is actually accepting, not a later overwritten value
    const correctPickupCode = (this.state.Notifications && this.state.Notifications.resource_id) || this.state.Pickupcode || '';
    if (correctPickupCode && correctPickupCode !== this.state.Pickupcode) {
      console.log(`🔧 [Fix] Home.acceptConsultCall: Correcting Pickupcode from overwritten value`, {
        oldPickupcode: this.state.Pickupcode,
        correctPickupcode: correctPickupCode,
        source: 'Notifications.resource_id'
      });
      this.setState({ Pickupcode: correctPickupCode });
    }
    
    console.log(`🖱️ [Event] Home.acceptConsultCall: Accepting consult call`, {
      timestamp: new Date().toISOString(),
      notificationId: this.state.Notifications.notification_id,
      consultNotificationId: this.state.Notifications.user_consult_notification_id,
      resourceId: this.state.Notifications.resource_id,
      patientName: this.state.PatientName,
      pickupCode: correctPickupCode || this.state.Pickupcode
    });

    // Stop the notification sound
    stopNotificationSound();
    this.setState({ isButtonDisabled: true, loader: true });
    console.log(`🔄 [State] Home.acceptConsultCall: Updated UI state`, { isButtonDisabled: true, loader: true });

    var notificationObj = {
      user_consult_notification_id: this.state.Notifications.user_consult_notification_id,
      User_name: this.state.Notifications.User_name,
      is_consult_accepted: true,
      is_consult_end_call: false,
      is_user_end_call: false,
      resource_id: this.state.Notifications.resource_id,
      notification_id: this.state.Notifications.notification_id,
      user_id: JSON.parse(sessionStorage.getItem('user')).username,
      consult_start_date: new Date(),
      consult_end_date: null,
      is_call_status: 'Accepted',
      auth_token: this.state.Notifications.auth_token,
      consultant_name: this.state.LoggedInUserName,
      is_releaseorder: this.state.Notifications.is_releaseorder,
      pharmacist_id: this.state.Notifications.user_id,
    };

    console.log(`🌐 [Network] Home.acceptConsultCall: Sending notification update`, {
      endpoint: 'notificationUpdate',
      elapsed: `${Date.now() - callStartTime}ms`
    });

    fetch(process.env.REACT_APP_BASEURL + 'notificationUpdate', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(notificationObj),
    })
      .then(async (response) => {
        console.log(`🌐 [Network] Home.acceptConsultCall: Received response`, {
          status: response.status,
          ok: response.ok,
          elapsed: `${Date.now() - callStartTime}ms`
        });
        let responseData;
        try {
          responseData = await response.json();
        } catch (error) {
          console.log(`❌ [Error] Home.acceptConsultCall: Failed to parse response`, {
            errorName: error.name,
            errorMessage: error.message,
            elapsed: `${Date.now() - callStartTime}ms`
          });
          return null;
        }

        // Handle session expired (401 Unauthorized)
        if (response.status === 401) {
          console.log('⏰ [TokenExpiry] Accept call failed with 401, session expired');
          this.handleConsultClose();
          this.setState({
            consultOpen: false,
            loader: false,
            isButtonDisabled: false,
          });
          // Log the failure with session expired context
          const auditPatientName = this.state.PatientName || (this.state.Notifications && this.state.Notifications.User_name) || 'patient';
          const auditPucode = (correctPickupCode || this.state.Pickupcode || '').toString().trim().toUpperCase();
          await logConsultAcceptFailed(
            auditPucode,
            auditPatientName,
            {
              message: 'Session expired (401 Unauthorized)',
              name: 'SessionExpiredError',
              metadata: {
                notificationId: this.state.Notifications && this.state.Notifications.notification_id,
                userConsultNotificationId: this.state.Notifications && this.state.Notifications.user_consult_notification_id,
                prescriptionMasterId: this.state.prescriptionMasterId,
                reason: 'TOKEN_EXPIRY'
              }
            },
            {
              startConsult: this.state.startConsult,
              isCallActive: this.state.isCallActive,
              consultOpen: this.state.consultOpen
            }
          );
          alert('Your session has expired. Please log in again.');
          this.signOut();
          throw new Error('SESSION_EXPIRED');
        }

        // Handle race condition
        if (response.status === 409) {
          this.handleConsultClose();
          this.setState({
            consultOpen: false,
            loader: false,
            isButtonDisabled: false,
            errorCallAlreadyAcceptedDialog: true,
            errorCallAlreadyAcceptedMessage: responseData.message || 'This consultation has already been accepted by another pharmacist.'
          });
          throw new Error('CONSULTATION_ALREADY_ACCEPTED');
        }

        return responseData;
      })
      .then(async (uData) => {
        /* Audit trail for user call accepted */
        const { first_name, last_name, patientName, prescriptionMasterId } = this.state;
        const auditPatientName = patientName || (this.state.Notifications && this.state.Notifications.User_name) || ((first_name && last_name) ? (first_name + ' ' + last_name) : 'patient');

        console.log(`🌐 [Network] Home.acceptConsultCall: Writing audit log`, {
          patientName: auditPatientName,
          elapsed: `${Date.now() - callStartTime}ms`
        });

        // Standardized audit log
        let acceptedPucode = correctPickupCode || this.state.Pickupcode || '';
        await logConsultAccepted(acceptedPucode, { prescriptionMasterId: prescriptionMasterId });
        
        // Note: Removed legacy audit log to prevent duplicates - standardized log above is sufficient
        // await writeAuditLog(
        //   `User accepted the video consultation from '${auditPatientName}'.`,
        //   'Consultation',
        //   { prescriptionMasterId: prescriptionMasterId },
        //   {
        //     eventType: 'CONSULTATION_ACCEPTED_SIGNAL',
        //     source: 'PORTAL',
        //     severity: 'INFO',
        //     metadata: {
        //       pickupCode: this.state.Pickupcode,
        //       notificationId:
        //         this.state && this.state.Notifications ? this.state.Notifications.notification_id : undefined,
        //       userConsultNotificationId:
        //         this.state && this.state.Notifications
        //           ? this.state.Notifications.user_consult_notification_id
        //           : undefined,
        //     },
        //   }
        // );

        console.log(`⚙️ [Function] Home.acceptConsultCall: Updating call status in localStorage`, {
          elapsed: `${Date.now() - callStartTime}ms`
        });

        // ✅ CRITICAL FIX: Also update pucode when setting status to 'accepted'
        // Transform acceptedPucode to uppercase for localStorage
        acceptedPucode = (acceptedPucode || '').toString().trim().toUpperCase();
        localStorage.setItem(
          'IncomingConsultationCallStatus',
          'accepted'
        );
        // ✅ CRITICAL FIX: Also update pucode when setting status to 'accepted'
        if (acceptedPucode) {
          localStorage.setItem(
            'IncomingConsultationCallPucode',
            acceptedPucode
          );
        }

        console.log(`⚙️ [Function] Home.acceptConsultCall: Call accepted successfully`, {
          elapsed: `${Date.now() - callStartTime}ms`,
          pucode: acceptedPucode
        });

        if (this.socket) {
          // Use resource_id from Notifications instead of Pickupcode to prevent overwrite issues
          const pucodeToEmit = (this.state.Notifications && this.state.Notifications.resource_id) || this.state.Pickupcode || '';
          console.log(`🌐 [Network] Home.acceptConsultCall: Emitting videoCallAccepted event`, {
            pucode: pucodeToEmit,
            source: (this.state.Notifications && this.state.Notifications.resource_id) ? 'Notifications.resource_id' : 'Pickupcode (fallback)',
            elapsed: `${Date.now() - callStartTime}ms`
          });

          this.socket.emit('videoCallAccepted', {
            pucode: pucodeToEmit.toString(),
            message: 'Call Accepted from Portal.',
            connectedPharmacistName: this.state.LoggedInUserName,
            // isAudioOnlyConsult: localStorage.getItem("isAudioOnlyConsult") === "true",
            isAudioOnlyConsult: this.state.isAudioOnlyConsult,
          });
        }

        console.log(`⚙️ [Function] Home.acceptConsultCall: Starting consultation UI`, {
          elapsed: `${Date.now() - callStartTime}ms`
        });
        this.startConsultation();

        console.log(`⚙️ [Function] Home.acceptConsultCall: Closing consult dialog`, {
          elapsed: `${Date.now() - callStartTime}ms`
        });
        this.handleConsultClose();

        console.log(`⚙️ [Function] Home.acceptConsultCall: Clearing interval`, {
          elapsed: `${Date.now() - callStartTime}ms`
        });
        clearInterval(window.otherUsersInterval);

        /* If notification id is not present then get prescriptionbypickup would get called */
        if (!!!this.state.Notifications.notification_id) {
          // DI-5364: Use full list of pucodes for multi pick-up so all orders are fetched and shown
          const pickupCodeForPrescription = (this.state.Notifications && this.state.Notifications.resource_id) || this.state.Pickupcode || '';
          const hasMultipleOrders = this.state.ordersPickUpCode && Array.isArray(this.state.ordersPickUpCode) && this.state.ordersPickUpCode.length > 0;
          const ordersPickUpCodeToUse = hasMultipleOrders ? this.state.ordersPickUpCode : (pickupCodeForPrescription ? [pickupCodeForPrescription] : []);
          console.log(`⚙️ [Function] Home.acceptConsultCall: Fetching prescription by pickup code`, {
            pickupCode: pickupCodeForPrescription,
            source: hasMultipleOrders ? 'ordersPickUpCode (multi pick-up)' : ((this.state.Notifications && this.state.Notifications.resource_id) ? 'Notifications.resource_id' : 'Pickupcode (fallback)'),
            ordersPickUpCode: ordersPickUpCodeToUse,
            elapsed: `${Date.now() - callStartTime}ms`
          });
          this.getPrescriptionDetailByPickupCode(ordersPickUpCodeToUse);
        }

        console.log(`⚙️ [Function] Home.acceptConsultCall: Process completed successfully`, {
          totalDuration: `${Date.now() - callStartTime}ms`
        });
      })
      .catch(async (err) => {
        // Check if this is a race condition error (already handled above)
        if (err.message === 'CONSULTATION_ALREADY_ACCEPTED') {
          console.log(`⚠️ [Info] Home.acceptConsultCall: Error accepting call as someone has already accepted it.`, {
            errorName: err.name,
            errorMessage: err.message,
            errorStack: err.stack,
            elapsed: `${Date.now() - callStartTime}ms`
          });
        } else {
          console.log(`❌ [Error] Home.acceptConsultCall: Error accepting call`, {
            errorName: err.name,
            errorMessage: err.message,
            errorStack: err.stack,
            elapsed: `${Date.now() - callStartTime}ms`
          });
        }

        /* Audit trail server error occured */
        console.log(`🌐 [Network] Home.acceptConsultCall: Writing error audit log`, {
          elapsed: `${Date.now() - callStartTime}ms`
        });
        const auditPatientName = this.state.PatientName || (this.state.Notifications && this.state.Notifications.User_name) || 'patient';
        const auditPucode = (this.state.Pickupcode || '').toString().trim().toUpperCase();
        await logConsultAcceptFailed(
          auditPucode,
          auditPatientName,
          {
            message: err.message,
            name: err.name,
            stack: err.stack,
            metadata: {
              notificationId: this.state.Notifications && this.state.Notifications.notification_id,
              userConsultNotificationId: this.state.Notifications && this.state.Notifications.user_consult_notification_id,
              prescriptionMasterId: this.state.prescriptionMasterId
            }
          },
          {
            startConsult: this.state.startConsult,
            isCallActive: this.state.isCallActive,
            consultOpen: this.state.consultOpen
          }
        );
      });
  };

  declineConsultCall = async () => {
    console.log(`🖱️ [Event] Home.declineConsultCall: Declining consult call`, {
      pickupCode: this.state.Pickupcode
    });

    // Stop the notification sound
    stopNotificationSound();

    // This causes an issue: DI-4729 decline by one pharmacist ends the call attempt for all other pharmacists
    // In the future, we need to change this event and figure out a way to detect if all the pharmacists have declined the call

    // NOTE => One-one decline call doesn't ends the call on kiosk side but it does on the portal side.
    //         But we are ignoring this for now as the fix might require some changes in the websockets
    //         which is difficult to deploy

    // if (this.socket) {
    //   console.log(`🌐 [Network] Home.declineConsultCall: Emitting videoCallDeclined event`);
    //   this.socket.emit('videoCallDeclined', {
    //     pucode: this.state.Pickupcode,
    //     message: 'Pharmacist declined video call.'
    //   });
    // }

    var endSessionObj = {
      user_consult_notification_id: this.state.Notifications
        .user_consult_notification_id,
      is_consult_end_call: false,
      is_user_end_call: false,
      is_call_status: 'Rejected',
    };

    /* Audit trail for user call declined */
    console.log(`⚙️ [Function] Home.declineConsultCall: Preparing audit log for declined call`);
    const { first_name, last_name, patientName, prescriptionMasterId } = this.state;
    const auditPatientName = patientName || (this.state.Notifications && this.state.Notifications.User_name) || ((first_name && last_name) ? (first_name + ' ' + last_name) : 'patient');

    console.log(`🌐 [Network] Home.declineConsultCall: Writing audit log for declined call`);
    // Standardized audit log
    const declinedPucode = (this.state.Pickupcode || '').toString().trim();
    await logConsultDeclined(declinedPucode, { prescriptionMasterId: prescriptionMasterId });
    
    // Legacy audit log (keeping for backward compatibility)
    await writeAuditLog(`User declined video call from '${auditPatientName}'.`, 'Consultation', { prescriptionMasterId: prescriptionMasterId });
    // await writeAuditLog(
    //   `User declined video call from '${auditPatientName}'.`,
    //   'Consultation',
    //   { prescriptionMasterId: prescriptionMasterId },
    //   {
    //     eventType: 'CONSULTATION_DECLINED_SIGNAL',
    //     source: 'PORTAL',
    //     severity: 'INFO',
    //     metadata: {
    //       pickupCode: this.state.Pickupcode,
    //     },
    //   }
    // );

    console.log(`⚙️ [Function] Home.declineConsultCall: Setting call status in localStorage`);
    localStorage.setItem(
      'IncomingConsultationCallStatus',
      'declined'
    );

    console.log(`🌐 [Network] Home.declineConsultCall: Sending end consult session request`);
    fetch(process.env.REACT_APP_BASEURL + 'endconsultsession', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(endSessionObj),
    })
      .then((response) => {
        console.log(`🌐 [Network] Home.declineConsultCall: Received response`);
        try {
          return response.json();
        } catch (error) {
          console.log(`❌ [Error] Home.declineConsultCall: Failed to parse response`, {
            errorName: error.name,
            errorMessage: error.message
          });
          return null;
        }
      })
      .then((uData) => {
        console.log(`⚙️ [Function] Home.declineConsultCall: Processing consultant blacklist`);
        let consultBlackList = JSON.parse(
          localStorage.getItem('consultBlackList')
        );
        let consultalreadyBlocked;
        if (consultBlackList.length > 0) {
          console.log(`⚙️ [Function] Home.declineConsultCall: Checking if consult already blocked`);
          consultBlackList.every((blockedConsult) => {
            if (
              blockedConsult.consultId === uData.user_consult_notification_id
            ) {
              consultalreadyBlocked = true;
              return false; // This will break the loop if id matched!
            } else {
              consultalreadyBlocked = false;
            }
            return false;
          });
          if (!consultalreadyBlocked) {
            console.log(`⚙️ [Function] Home.declineConsultCall: Adding consult to blacklist`);
            consultBlackList.push({
              consultId: uData.user_consult_notification_id,
              created_on: uData.created_on,
            });
            localStorage.setItem(
              'consultBlackList',
              JSON.stringify(consultBlackList)
            );
          }
        } else {
          console.log(`⚙️ [Function] Home.declineConsultCall: Creating new entry in blacklist`);
          consultBlackList.push({
            consultId: uData.user_consult_notification_id,
            created_on: uData.created_on,
          });
          localStorage.setItem(
            'consultBlackList',
            JSON.stringify(consultBlackList)
          );
        }
        console.log(`⚙️ [Function] Home.declineConsultCall: Closing consult dialog`);
        this.handleConsultClose();
        console.log(`⚙️ [Function] Home.declineConsultCall: Clearing interval`);
        clearInterval(window.otherUsersInterval);
      })
      .catch(error => {
        console.log(`❌ [Error] Home.declineConsultCall: Error declining call`, {
          errorName: error.name,
          errorMessage: error.message,
          errorStack: error.stack
        });
      });
  };

  // ========== Phase 1: Incoming Call Notification During Active Call ==========

  /**
   * Silence an incoming call (stop beep sound but keep notification visible)
   */
  silenceIncomingCall = async (pucode) => {
    const silenceTime = new Date().toISOString();
    console.log(`🔇 [PORTAL][${silenceTime}] silenceIncomingCall CALLED`, { 
      pucode,
      incomingCallsCount: (this.state.incomingCalls && this.state.incomingCalls.length) || 0,
      silencedCallsCount: (this.state.silencedCalls && this.state.silencedCalls.length) || 0
    });
    
    // Find the incoming call to get patient name
    const incomingCall = this.state.incomingCalls.find(call => call.pucode.toLowerCase() === pucode.toLowerCase());
    const patientName = (incomingCall && incomingCall.patientName) || 'patient';
    
    this.setState(prevState => {
      const pucodeLower = pucode.toLowerCase();
      const silencedCallsArray = Array.isArray(prevState.silencedCalls) ? prevState.silencedCalls : [];
      const newSilencedCalls = silencedCallsArray.includes(pucodeLower) 
        ? silencedCallsArray 
        : [...silencedCallsArray, pucodeLower];
      
      // Update incoming call to mark as silenced
      const updatedIncomingCalls = prevState.incomingCalls.map(call => 
        call.pucode.toLowerCase() === pucodeLower 
          ? { ...call, isSilenced: true }
          : call
      );

      // Check if there are other unsilenced calls after this update
      const hasUnsilencedCalls = updatedIncomingCalls.some(
        call => !call.isSilenced && call.pucode.toLowerCase() !== pucodeLower
      );
      
      // Stop beep sound if no other unsilenced calls
      if (!hasUnsilencedCalls) {
        stopLightBeepSound();
      }

      console.log(`📞 [Phase 1] Home.silenceIncomingCall: State updated`, {
        silencedCalls: newSilencedCalls,
        incomingCallsCount: updatedIncomingCalls.length
      });

      return {
        silencedCalls: newSilencedCalls,
        incomingCalls: updatedIncomingCalls
      };
    });

    // Log the silenced call
    try {
      await logIncomingCallSilenced(pucode, patientName, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
    } catch (error) {
      console.log(`❌ [Error] Home.silenceIncomingCall: Error writing audit log`, {
        error: error.message,
        pucode,
        patientName
      });
      
      // Audit trail for error - log that silence operation audit failed
      const auditPucode = (pucode || '').toString().trim().toUpperCase();
      await logConsultSilenceFailed(
        auditPucode,
        patientName,
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            prescriptionMasterId: this.state.prescriptionMasterId,
            originalAction: 'logIncomingCallSilenced'
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
    }
  };

  /**
   * Decline an incoming call from the notification UI
   * 
   * Uses the same logic as declineConsultCall:
   * - Calls API with 'Rejected' status (marks as rejected for THIS pharmacist only)
   * - Adds to consultBlackList (prevents the same call from appearing again)
   * - Does NOT end the call on the kiosk side
   * 
   * Other pharmacists can still accept the call within the 45-second timeout.
   */
  declineIncomingCall = async (incomingCall) => {
    const pucode = incomingCall.pucode.toLowerCase();
    const activeCallPucode = (this.state.Pickupcode || '').toLowerCase();
    
    console.log(`📞 [Phase 1] Home.declineIncomingCall: Rejecting incoming call (same logic as main decline)`, { 
      pucode, 
      patientName: incomingCall.patientName,
      notificationId: incomingCall.notificationId,
      activeCallPucode: activeCallPucode,
      isActiveCall: pucode === activeCallPucode
    });
    
    // Phase 1: Safety check - never decline the active call through this function
    if (pucode === activeCallPucode && activeCallPucode !== '') {
      console.error(`❌ [Error] Home.declineIncomingCall: Attempted to decline active call! This should never happen.`, {
        pucode: pucode,
        activeCallPucode: activeCallPucode
      });
      return; // Don't process - this is the active call, not a queued call
    }

    // Remove from incoming calls queue and check if beep should continue
    this.setState(prevState => {
      const updatedIncomingCalls = prevState.incomingCalls.filter(call => call.pucode.toLowerCase() !== pucode);
      const updatedSilencedCalls = prevState.silencedCalls.filter(silencedPucode => silencedPucode !== pucode);
      
      // Check if there are other unsilenced calls remaining
      const hasUnsilencedCalls = updatedIncomingCalls.some(call => !call.isSilenced);
      
      // Only stop beep if no other unsilenced calls
      if (!hasUnsilencedCalls) {
        stopLightBeepSound();
        console.log(`📞 [Phase 1] Home.declineIncomingCall: No more unsilenced calls, stopped beep sound`);
      } else {
        console.log(`📞 [Phase 1] Home.declineIncomingCall: Other unsilenced calls remain, beep continues`, {
          remainingUnsilencedCount: updatedIncomingCalls.filter(call => !call.isSilenced).length
        });
      }
      
      return {
        incomingCalls: updatedIncomingCalls,
        silencedCalls: updatedSilencedCalls
      };
    });

    // Call API with 'Rejected' status - same as declineConsultCall
    // This marks it as rejected for THIS pharmacist only, does NOT end call on kiosk
    if (incomingCall.notificationId) {
      try {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const endSessionObj = {
          user_consult_notification_id: incomingCall.notificationId,
          is_consult_end_call: false,
          is_user_end_call: false,
          is_call_status: 'Rejected', // Same as declineConsultCall - NOT 'Declined'
        };
        
        console.log(`📞 [Phase 1] Home.declineIncomingCall: Calling endconsultsession API with Rejected status`);
        const response = await fetch(
          `${process.env.REACT_APP_BASEURL}endconsultsession`,
          {
            method: 'post',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
            },
            body: JSON.stringify(endSessionObj),
          }
        );
        
        if (response.ok) {
          const uData = await response.json();
          console.log(`📞 [Phase 1] Home.declineIncomingCall: API call successful, adding to blacklist`);
          
          // Add to consultBlackList - same as declineConsultCall
          // This prevents the same call from appearing again for this pharmacist
          let consultBlackList = JSON.parse(localStorage.getItem('consultBlackList')) || [];
          const consultalreadyBlocked = consultBlackList.some(
            blockedConsult => blockedConsult.consultId === uData.user_consult_notification_id
          );
          
          if (!consultalreadyBlocked) {
            consultBlackList.push({
              consultId: uData.user_consult_notification_id,
              created_on: uData.created_on,
            });
            localStorage.setItem('consultBlackList', JSON.stringify(consultBlackList));
            console.log(`📞 [Phase 1] Home.declineIncomingCall: Added to consultBlackList`);
          }
        } else {
          console.warn(`📞 [Phase 1] Home.declineIncomingCall: API call failed`, {
            status: response.status,
            statusText: response.statusText
          });
        }
      } catch (error) {
        console.error(`❌ [Error] Home.declineIncomingCall: Error calling API`, {
          errorName: error.name,
          errorMessage: error.message
        });
      }
    }

    // Write audit log
    try {
      // Standardized audit log
      await logConsultDeclined(pucode, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
      
      // Notification UI specific log: User Declined the incoming call
      const patientName = incomingCall.patientName || 'patient';
      await logIncomingCallDeclined(pucode, patientName, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
      
      // Legacy audit log (keeping for backward compatibility)
      await writeAuditLog(`User rejected incoming consultation call from '${incomingCall.patientName}' while on active call.`, 'Consultation', {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
    } catch (error) {
      console.log(`❌ [Error] Home.declineIncomingCall: Error writing audit log`, {
        errorName: error.name,
        errorMessage: error.message
      });
    }

    // Check if there are other unsilenced incoming calls - restart beep if needed
    this.setState(prevState => {
      const remainingCalls = prevState.incomingCalls.filter(call => call.pucode.toLowerCase() !== pucode);
      const hasUnsilencedCalls = remainingCalls.some(call => !call.isSilenced);
      if (hasUnsilencedCalls) {
        playLightBeepSound();
        console.log(`📞 [Phase 1] Home.declineIncomingCall: Restarted beep for remaining unsilenced calls`);
      }
      return {};
    });

    console.log(`📞 [Phase 1] Home.declineIncomingCall: ✅ Call rejected for this pharmacist, other pharmacists can still accept`);
  };

  /**
   * Clean up incoming calls when active call ends
   */
  clearIncomingCalls = () => {
    console.log(`📞 [Phase 1] Home.clearIncomingCalls: Clearing incoming calls queue`, {
      currentIncomingCallsCount: this.state.incomingCalls.length,
      startConsult: this.state.startConsult,
    });
    stopLightBeepSound();
    this.setState({
      incomingCalls: [],
      silencedCalls: [],
      heldCalls: [],
      isCallOnHold: false,
      consultOpen: false,
      startConsult: false,
      isCallActive: false,
      Notifications: {},           
      Pickupcode: '',             
      PatientName: '',            
      isFirebaseNotification: false, 
      prescriptionMasterId: '',   
      // ✅ FIX: Also clear missed call related state to prevent stale data
      missedCallAckDialog: false,
      missedCallPatientName: '',
    });
  };

  // ========== Phase 2: Hold & Switch - Multi-call Management ==========

  /**
   * Verify if a queued call is still active (not ended on kiosk side)
   * This is a defensive check to handle missed socket events
   */
  verifyCallStillActive = async (incomingCall) => {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      if (!user || !incomingCall.notificationId) {
        console.log(`📞 [Phase 2] Home.verifyCallStillActive: No user or notification ID`, {
          notificationId: incomingCall.notificationId
        });
        return true; // Proceed if we can't verify
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}getNotificationByid/${incomingCall.notificationId}`,
        {
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
          }
        }
      );
      
      if (!response.ok) {
        console.log(`📞 [Phase 2] Home.verifyCallStillActive: Notification not found (call ended)`, {
          notificationId: incomingCall.notificationId,
          status: response.status
        });
        return false; // Call no longer exists
      }
      
      const data = await response.json();
      
      if (!data) {
        console.log(`📞 [Phase 2] Home.verifyCallStillActive: No data returned`, {
          notificationId: incomingCall.notificationId
        });
        return false;
      }

      const callStatus = data.is_call_status;
      
      // Allow accepting if status is 'Pending' (no one has accepted yet)
      if (callStatus === 'Pending') {
        console.log(`📞 [Phase 2] Home.verifyCallStillActive: Call still pending, can accept`, {
          notificationId: incomingCall.notificationId,
          status: callStatus
        });
        return true;
      }

      // Allow accepting if status is 'Rejected' (another pharmacist declined, but call is still active on kiosk)
      // This fixes the issue where User B declining prevents User A from accepting
      if (callStatus === 'Rejected') {
        console.log(`📞 [Phase 2] Home.verifyCallStillActive: Call marked as Rejected by another pharmacist, but still active - allowing accept`, {
          notificationId: incomingCall.notificationId,
          status: callStatus
        });
        return true;
      }

      // If status is 'Accepted', check if it was accepted by another pharmacist
      // This is a race condition that will be handled by the acceptConsultCall function
      if (callStatus === 'Accepted') {
        console.log(`📞 [Phase 2] Home.verifyCallStillActive: Call already accepted - will be handled by race condition check`, {
          notificationId: incomingCall.notificationId,
          status: callStatus,
          acceptedBy: data.is_anyone_accepted ? 'another pharmacist' : 'unknown'
        });
        // Still allow proceeding - acceptConsultCall will handle the race condition
        return true;
      }

      // For any other status (Completed, Ended, Cancelled, etc.), reject
      console.log(`📞 [Phase 2] Home.verifyCallStillActive: Call not in acceptable status`, {
        notificationId: incomingCall.notificationId,
        status: callStatus
      });
      return false;
    } catch (error) {
      console.error(`❌ [Error] Home.verifyCallStillActive: Error checking call status`, error);
      return true; // Proceed on error (optimistic)
    }
  };

  /**
   * Hold the current active call
   * - Mutes audio/video tracks (patient sees "on hold" state)
   * - Moves current call details to heldCalls array
   * - Emits socket event to notify kiosk
   */
  holdCurrentCall = async () => {
    const functionStartTime = Date.now();
    console.log(`📞 [Call Waiting] Home.holdCurrentCall: Putting current call on hold`, {
      timestamp: new Date().toISOString(),
      pickupCode: this.state.Pickupcode,
      patientName: this.state.PatientName,
      hasActiveCall: this.state.startConsult,
      heldCallsCount: this.state.heldCalls ? this.state.heldCalls.length : 0
    });

    if (!this.state.startConsult) {
      console.warn(`📞 [Call Waiting] Home.holdCurrentCall: No active call to hold`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      return false;
    }

    try {
      // Mute audio and video tracks
      if (this.twilio && this.twilio.state && this.twilio.state.activeRoom) {
        const room = this.twilio.state.activeRoom;
        room.localParticipant.audioTracks.forEach(publication => {
          publication.track.disable();
          console.log(`📞 [Call Waiting] Home.holdCurrentCall: Disabled audio track`);
        });
        room.localParticipant.videoTracks.forEach(publication => {
          publication.track.disable();
          console.log(`📞 [Call Waiting] Home.holdCurrentCall: Disabled video track`);
        });
      }

      // Create held call object with current call details
      // ✅ FIX: Save consultation notes, release order, prescription details, and ID capture fields per call
      const heldCall = {
        pucode: this.state.Pickupcode,
        notificationId: this.state.Notifications && this.state.Notifications.user_consult_notification_id,
        patientName: this.state.PatientName || (this.state.Notifications && this.state.Notifications.User_name),
        location: (this.state.Notifications && this.state.Notifications.kiosk_name) || (this.state.Notifications && this.state.Notifications.store_name),
        holdStartTime: Date.now(),
        notificationData: this.state.Notifications,
        twilioRef: this.twilio, // Keep reference to resume
        // Per-call consult start (ISO) for reports; must survive hold/switch and complete-other-first
        consultStartTime: this.state.consultStartTime || null,
        // ✅ FIX: Save consultation-specific state per call
        consultnotes: this.state.consultnotes || '',
        ReleaseOrder: this.state.ReleaseOrder || false,
        PatietPrescriptionData: this.state.PatietPrescriptionData || null,
        prescriptionMasterId: this.state.prescriptionMasterId || '',
        // ✅ FIX: Save ID capture fields per call
        IdRawData: this.state.IdRawData || '',
        firstName: this.state.firstName || '',
        lastName: this.state.lastName || '',
        dob: this.state.dob || '',
        stateCode: this.state.stateCode || '',
        relationship: this.state.relationship || '',
        expDate: this.state.expDate || '',
        cardType: this.state.cardType || '',
        DLNo: this.state.DLNo || ''
      };

      // Emit socket event to notify kiosk that call is on hold
      if (this.socket && this.state.Pickupcode) {
        this.socket.emit('callOnHold', {
          pucode: this.state.Pickupcode,
          message: 'Pharmacist put call on hold'
        });
        console.log(`📞 [Call Waiting] Home.holdCurrentCall: Emitted callOnHold socket event`, {
          pucode: this.state.Pickupcode,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      }

      // Update state - move to held calls
      this.setState(prevState => ({
        heldCalls: [...prevState.heldCalls, heldCall],
        isCallOnHold: true
      }), () => {
        console.log(`📞 [Call Waiting] Home.holdCurrentCall: State updated - call moved to held calls`, {
          heldCallsCount: this.state.heldCalls.length,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      });

      // Write audit log
      // Notification UI specific log: User kept X on Hold
      const patientName = heldCall.patientName || 'patient';
      const holdPucode = (heldCall.pucode || '').toString().trim().toUpperCase();
      await logCallPutOnHold(holdPucode, patientName, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
      
      // Legacy audit log (keeping for backward compatibility)
      await writeAuditLog(
        `User put consultation call with '${heldCall.patientName}' on hold.`,
        'Consultation',
        { prescriptionMasterId: this.state.prescriptionMasterId }
      );

      console.log(`📞 [Call Waiting] Home.holdCurrentCall: ✅ Call placed on hold successfully`, {
        pucode: heldCall.pucode,
        patientName: heldCall.patientName,
        heldCallsCount: this.state.heldCalls.length,
        totalElapsed: `${Date.now() - functionStartTime}ms`
      });
      return true;
    } catch (error) {
      console.error(`❌ [Error] Home.holdCurrentCall: Failed to hold call`, {
        errorName: error.name,
        errorMessage: error.message
      });
      
      // Audit trail for error
      const auditPucode = (this.state.Pickupcode || '').toString().trim().toUpperCase();
      const auditPatientName = this.state.PatientName || (this.state.Notifications && this.state.Notifications.User_name) || 'patient';
      await logConsultHoldFailed(
        auditPucode,
        auditPatientName,
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            notificationId: this.state.Notifications && this.state.Notifications.notification_id,
            userConsultNotificationId: this.state.Notifications && this.state.Notifications.user_consult_notification_id,
            prescriptionMasterId: this.state.prescriptionMasterId
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
      return false;
    }
  };

  /**
   * Resume a held call
   * - Unmutes audio/video tracks
   * - Swaps with current active call (if any)
   * - Emits socket event to notify kiosk
   */
  resumeHeldCall = async (heldCallPucode) => {
    console.log(`📞 [Phase 2] Home.resumeHeldCall: Resuming held call`, {
      heldCallPucode,
      currentActiveCall: this.state.Pickupcode,
      heldCallsCount: this.state.heldCalls.length
    });

    const heldCall = this.state.heldCalls.find(
      call => call.pucode.toLowerCase() === heldCallPucode.toLowerCase()
    );

    if (!heldCall) {
      console.error(`❌ [Error] Home.resumeHeldCall: Held call not found`, { heldCallPucode });
      return false;
    }

    try {
      // If there's currently an active call, hold it first
      if (this.state.startConsult && this.state.Pickupcode !== heldCallPucode) {
        console.log(`📞 [Phase 2] Home.resumeHeldCall: Holding current active call first`);
        await this.holdCurrentCall();
      }

      // Re-enable audio and video tracks for the held call
      if (heldCall.twilioRef && heldCall.twilioRef.state && heldCall.twilioRef.state.activeRoom) {
        const room = heldCall.twilioRef.state.activeRoom;
        room.localParticipant.audioTracks.forEach(publication => {
          publication.track.enable();
          console.log(`📞 [Phase 2] Home.resumeHeldCall: Enabled audio track`);
        });
        room.localParticipant.videoTracks.forEach(publication => {
          publication.track.enable();
          console.log(`📞 [Phase 2] Home.resumeHeldCall: Enabled video track`);
        });
      }

      // Emit socket event to notify kiosk that call is resumed
      if (this.socket && heldCallPucode) {
        this.socket.emit('callResumed', {
          pucode: heldCallPucode,
          message: 'Pharmacist resumed call'
        });
        console.log(`📞 [Phase 2] Home.resumeHeldCall: Emitted callResumed socket event`);
      }

      // ✅ ROOT CAUSE FIX: Update twilio reference BEFORE state update to ensure TwilioVideo component gets the correct ref
      // This ensures that when the component remounts, it uses the correct Twilio instance for the resumed call
      // CRITICAL: Set this BEFORE state update so existingTwilioRef prop gets the correct value
      const previousTwilio = this.twilio;
      this.twilio = heldCall.twilioRef;
      
      console.log(`📞 [Call Waiting] Home.resumeHeldCall: Updated Twilio reference`, {
        previousTwilioExists: !!previousTwilio,
        newTwilioExists: !!this.twilio,
        heldCallPucode: heldCallPucode,
        heldCallRoomName: (heldCall.twilioRef && heldCall.twilioRef.state && heldCall.twilioRef.state.activeRoom && heldCall.twilioRef.state.activeRoom.name) || null,
        note: 'This ensures existingTwilioRef prop points to the correct Twilio instance'
      });

      // Update state - remove from held calls, restore as active
      // ✅ FIX: Restore consultation notes, release order, and prescription details from held call
      this.setState(prevState => ({
        heldCalls: prevState.heldCalls.filter(
          call => call.pucode.toLowerCase() !== heldCallPucode.toLowerCase()
        ),
        Pickupcode: heldCall.pucode,
        PatientName: heldCall.patientName,
        Notifications: heldCall.notificationData,
        prescriptionMasterId: heldCall.prescriptionMasterId || (heldCall.notificationData && heldCall.notificationData.prescription_master_id) || '',
        isCallOnHold: false,
        consultOpen: true,  // ✅ FIX: Open consult dialog
        startConsult: true,  // ✅ FIX: Mark consultation as active
        isCallActive: true,  // ✅ FIX: Mark video call as active
        // ✅ FIX: Restore consultation-specific state from held call
        consultStartTime: heldCall.consultStartTime != null ? heldCall.consultStartTime : null,
        consultnotes: heldCall.consultnotes || '',
        ReleaseOrder: heldCall.ReleaseOrder || false,
        PatietPrescriptionData: heldCall.PatietPrescriptionData || null,
        // ✅ FIX: Restore ID capture fields from held call
        IdRawData: heldCall.IdRawData || '',
        firstName: heldCall.firstName || '',
        lastName: heldCall.lastName || '',
        dob: heldCall.dob || '',
        stateCode: heldCall.stateCode || '',
        relationship: heldCall.relationship || '',
        expDate: heldCall.expDate || '',
        cardType: heldCall.cardType || '',
        DLNo: heldCall.DLNo || ''
      }), () => {
        // Callback after state update to open dialog
        console.log(`📞 [Call Waiting] Home.resumeHeldCall: Opening Consult Details modal`, {
          pucode: heldCall.pucode,
          patientName: heldCall.patientName,
          consultOpen: this.state.consultOpen,
          startConsult: this.state.startConsult,
          twilioRefExists: !!this.twilio
        });
        
        // ✅ FIX: Force TwilioVideo to re-render with new room/identity by ensuring state is fully updated
        // The component should automatically re-render when Pickupcode and PatientName change,
        // but we ensure the twilio ref is set before state update to avoid race conditions
        this.handleConsultClickOpen(); // ✅ FIX: Open the consult dialog
        
        // ✅ FIX: If prescription details weren't saved, fetch them now
        // This will also populate ID capture fields if they weren't saved
        if (!heldCall.PatietPrescriptionData && heldCall.pucode) {
          console.log(`📞 [Call Waiting] Home.resumeHeldCall: Fetching prescription details for resumed call`, {
            pucode: heldCall.pucode
          });
          this.getPrescriptionDetailByPickupCode([heldCall.pucode]);
        } else if (!heldCall.IdRawData && heldCall.pucode) {
          // ✅ FIX: If ID data wasn't saved but prescription data exists, fetch ID data separately
          console.log(`📞 [Call Waiting] Home.resumeHeldCall: ID data not saved, fetching prescription details to populate ID fields`, {
            pucode: heldCall.pucode
          });
          this.getPrescriptionDetailByPickupCode([heldCall.pucode]);
        }
      });

      // Write audit log
      // Standardized audit log
      const resumePucode = (heldCallPucode || '').toString().trim().toUpperCase();
      if (resumePucode) {
        await logConsultResumed(resumePucode, { 
          prescriptionMasterId: (heldCall.notificationData && heldCall.notificationData.prescription_master_id) || this.state.prescriptionMasterId 
        });
      }
      
      // Notification UI specific log: User resumed the Hold call
      const patientName = heldCall.patientName || 'patient';
      await logHeldCallResumed(resumePucode, patientName, {
        prescriptionMasterId: (heldCall.notificationData && heldCall.notificationData.prescription_master_id) || this.state.prescriptionMasterId
      });
      
      // Legacy audit log (keeping for backward compatibility)
      await writeAuditLog(
        `User resumed held consultation call with '${heldCall.patientName}'.`,
        'Consultation',
        { prescriptionMasterId: this.state.prescriptionMasterId }
      );

      console.log(`📞 [Call Waiting] Home.resumeHeldCall: ✅ Call resumed successfully and modal opened`, {
        pucode: heldCall.pucode,
        patientName: heldCall.patientName,
        twilioRefExists: !!heldCall.twilioRef,
        remainingHeldCalls: this.state.heldCalls.length
      });
      return true;
    } catch (error) {
      console.error(`❌ [Error] Home.resumeHeldCall: Failed to resume call`, {
        errorName: error.name,
        errorMessage: error.message
      });
      
      // Audit trail for error
      const auditPucode = (heldCall.pucode || '').toString().trim().toUpperCase();
      await logConsultResumeFailed(
        auditPucode,
        heldCall.patientName || 'patient',
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            notificationId: heldCall.notificationData && heldCall.notificationData.notification_id,
            userConsultNotificationId: heldCall.notificationData && heldCall.notificationData.user_consult_notification_id,
            prescriptionMasterId: heldCall.prescriptionMasterId
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
      return false;
    }
  };

  /**
   * End a held call without resuming it
   */
  endHeldCall = async (heldCallPucode) => {
    console.log(`📞 [Phase 2] Home.endHeldCall: Ending held call`, { heldCallPucode });

    const heldCall = this.state.heldCalls.find(
      call => call.pucode.toLowerCase() === heldCallPucode.toLowerCase()
    );

    if (!heldCall) {
      console.error(`❌ [Error] Home.endHeldCall: Held call not found`, { heldCallPucode });
      return false;
    }

    try {
      // Disconnect the Twilio room for the held call
      if (heldCall.twilioRef && heldCall.twilioRef.state && heldCall.twilioRef.state.activeRoom) {
        heldCall.twilioRef.leaveRoom();
        console.log(`📞 [Phase 2] Home.endHeldCall: Left Twilio room for held call`);
      }

      // Emit socket event to end the call on kiosk side
      if (this.socket) {
        this.socket.emit('completeConsult', {
          pucode: heldCallPucode,
          message: 'Held call ended by pharmacist'
        });
      }

      // Remove from held calls
      this.setState(prevState => ({
        heldCalls: prevState.heldCalls.filter(
          call => call.pucode.toLowerCase() !== heldCallPucode.toLowerCase()
        )
      }));

      // Write audit log
      // Notification UI specific log: User declined the Hold call
      const patientName = heldCall.patientName || 'patient';
      const endPucode = (heldCallPucode || '').toString().trim().toUpperCase();
      await logHeldCallDeclined(endPucode, patientName, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
      
      // Legacy audit log (keeping for backward compatibility)
      await writeAuditLog(
        `User ended held consultation call with '${heldCall.patientName}'.`,
        'Consultation',
        { prescriptionMasterId: this.state.prescriptionMasterId }
      );

      console.log(`📞 [Phase 2] Home.endHeldCall: ✅ Held call ended successfully`);
      return true;
    } catch (error) {
      console.error(`❌ [Error] Home.endHeldCall: Failed to end held call`, {
        errorName: error.name,
        errorMessage: error.message
      });
      
      // Audit trail for error
      const auditPucode = (heldCall.pucode || '').toString().trim().toUpperCase();
      await logConsultEndFailed(
        auditPucode,
        heldCall.patientName || 'patient',
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            notificationId: heldCall.notificationData && heldCall.notificationData.notification_id,
            userConsultNotificationId: heldCall.notificationData && heldCall.notificationData.user_consult_notification_id,
            prescriptionMasterId: heldCall.prescriptionMasterId,
            action: 'endHeldCall'
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
      return false;
    }
  };

  /**
   * Accept incoming call and END the current active call
   * - Ends the current consultation session
   * - Accepts the new incoming call
   */
  acceptAndEndCurrentCall = async (incomingCall) => {
    const functionStartTime = Date.now();
    console.log(`📞 [Call Waiting] Home.acceptAndEndCurrentCall: Accepting new call, ending current`, {
      timestamp: new Date().toISOString(),
      incomingPucode: incomingCall.pucode,
      incomingPatientName: incomingCall.patientName,
      currentPucode: this.state.Pickupcode,
      currentPatientName: this.state.PatientName,
      hasActiveConsultation: this.state.startConsult
    });

    try {
      // Stop the beep sound
      stopLightBeepSound();
      
      // DEFENSIVE CHECK: Verify the incoming call is still valid (not ended on kiosk side)
      // This handles cases where socket event was missed
      const notificationCheck = await this.verifyCallStillActive(incomingCall);
      if (!notificationCheck) {
        console.log(`📞 [Phase 2] Home.acceptAndEndCurrentCall: Call no longer active, removing from queue`, {
          pucode: incomingCall.pucode
        });
        // Remove from queue
        this.setState(prevState => ({
          incomingCalls: prevState.incomingCalls.filter(
            call => call.pucode.toLowerCase() !== incomingCall.pucode.toLowerCase()
          )
        }));
        // Show user-friendly message
        alert('This call has ended. The patient may have disconnected.');
        return false;
      }

      // Capture current call details before state changes
      const currentCallNotificationData = this.state.Notifications;
      const currentCallPucode = this.state.Pickupcode;
      const currentCallStartTime = this.state.consultStartTime;

      // End the current consultation session properly
      if (this.state.startConsult) {
        console.log(`📞 [Phase 2] Home.acceptAndEndCurrentCall: Ending current call`, {
          currentPucode: currentCallPucode
        });
        
        // Leave Twilio room
        if (this.twilio) {
          this.twilio.leaveRoom();
        }

        // Emit socket event to notify kiosk
        if (this.socket && currentCallPucode) {
          this.socket.emit('completeConsult', {
            pucode: currentCallPucode,
            message: 'Pharmacist ended call to accept new call'
          });
        }

        // End session via API and save as completed
        const user = JSON.parse(sessionStorage.getItem('user'));
        const endSessionResponse = await fetch(`${process.env.REACT_APP_BASEURL}endconsultsession`, {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
          },
          body: JSON.stringify({
            user_consult_notification_id: currentCallNotificationData && currentCallNotificationData.user_consult_notification_id,
            is_consult_end_call: true,
            is_user_end_call: false,
            is_call_status: 'Completed'
          })
        });

        // Save the completed consultation entry
        if (endSessionResponse.ok && currentCallNotificationData) {
          const endTime = new Date().toISOString();
          const pharmacistName = (sessionStorage.getItem('user.firstname') || '') + ' ' + (sessionStorage.getItem('user.lastname') || '');
          
          const masterObj = {
            consult_start_date: currentCallStartTime || currentCallNotificationData.consult_start_date,
            consult_end_date: endTime,
            pickup_code: currentCallNotificationData.resource_id,
            notification_id: currentCallNotificationData.notification_id,
            user_name: currentCallNotificationData.User_name,
            call_duration: currentCallStartTime ? this.getMinutes(currentCallStartTime, endTime) : null,
            user_id: currentCallNotificationData.user_id,
            consultation_name: pharmacistName,
            Status: 'Completed',
            accounts_id: currentCallNotificationData.accounts_id,
            store_name: currentCallNotificationData.store_name,
            box_id: currentCallNotificationData.box_id,
            kiosk_name: currentCallNotificationData.kiosk_name,
            consultation_notes: this.state.consultnotes,
            is_releaseorder: this.state.ReleaseOrder,
            selectedReasonId: this.state.selectedReasonId,
            selectedReasonText: this.state.selectedReasonText,
            id_capture_type: this.state.id_capture_type
          };

          await fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + user.signInUserSession.idToken.jwtToken,
            },
            body: JSON.stringify(masterObj),
          });
        }
      }

      // Remove the incoming call from queue
      this.setState(prevState => ({
        incomingCalls: prevState.incomingCalls.filter(
          call => call.pucode.toLowerCase() !== incomingCall.pucode.toLowerCase()
        ),
        silencedCalls: prevState.silencedCalls.filter(
          p => p.toLowerCase() !== incomingCall.pucode.toLowerCase()
        ),
        startConsult: false,
        isCallActive: false,
        consultOpen: false,
        consultStartTime: null,
        consultnotes: '',
        ReleaseOrder: false,
        selectedReasonId: null,
        selectedReasonText: null,
        id_capture_type: 9
      }));

      // Set up state for new call BEFORE accepting it
      // This ensures acceptConsultCall has the correct state
      // ✅ FIX: Reset consultation notes, release order, and ID capture fields for new call
      this.setState({
        Pickupcode: incomingCall.pucode,
        Notifications: incomingCall.notificationData,
        PatientName: incomingCall.patientName,
        isFirebaseNotification: true,
        prescriptionMasterId: incomingCall.notificationData && incomingCall.notificationData.prescription_master_id,
        // ✅ FIX: Reset consultation-specific state for new call
        consultnotes: '',
        ReleaseOrder: false,
        PatietPrescriptionData: null,
        // ✅ FIX: Reset ID capture fields for new call
        IdRawData: '',
        firstName: '',
        lastName: '',
        dob: '',
        stateCode: '',
        relationship: '',
        expDate: '',
        cardType: '',
        DLNo: ''
      });

      // Set notification object and patient name
      this.setNotificationObject(incomingCall.notificationData);
      this.setPatientName(incomingCall.notificationData);

      // Clear localStorage to prevent handleConsultClose from treating new call as missed
      // acceptConsultCall will set it to 'accepted' when the call is accepted
      localStorage.removeItem('IncomingConsultationCallStatus');
      localStorage.removeItem('IncomingConsultationCallPucode');

      // Accept the call immediately without opening the dialog
      // acceptConsultCall will handle all the acceptance logic and close any open dialogs
      console.log(`📞 [Phase 2] Home.acceptAndEndCurrentCall: Accepting new call via acceptConsultCall`, {
        newPucode: incomingCall.pucode,
        newPatientName: incomingCall.patientName
      });
      
      // Call acceptConsultCall directly - it will handle opening/closing dialogs as needed
      // We set consultOpen: false above to ensure no dialog is shown before acceptance
      this.acceptConsultCall();

      // Write audit log
      // Notification UI specific log: User End & Accepted the incoming call
      const patientName = incomingCall.patientName || 'patient';
      const incomingPucode = (incomingCall.pucode || '').toString().trim().toUpperCase();
      await logIncomingCallEndAndAccepted(incomingPucode, patientName, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
      
      // Legacy audit log (keeping for backward compatibility)
      await writeAuditLog(
        `User ended current call and accepted new call from '${incomingCall.patientName}'.`,
        'Consultation',
        { prescriptionMasterId: this.state.prescriptionMasterId }
      );

      console.log(`📞 [Call Waiting] Home.acceptAndEndCurrentCall: ✅ Switched to new call successfully`, {
        newPucode: incomingCall.pucode,
        newPatientName: incomingCall.patientName,
        totalElapsed: `${Date.now() - functionStartTime}ms`
      });
      return true;
    } catch (error) {
      console.error(`❌ [Error] Home.acceptAndEndCurrentCall: Failed to switch calls`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      
      // Audit trail for error
      const auditPucode = (incomingCall.pucode || '').toString().trim().toUpperCase();
      await logConsultAcceptFailed(
        auditPucode,
        incomingCall.patientName || 'patient',
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            notificationId: incomingCall.notificationData && incomingCall.notificationData.notification_id,
            userConsultNotificationId: incomingCall.notificationData && incomingCall.notificationData.user_consult_notification_id,
            prescriptionMasterId: this.state.prescriptionMasterId,
            action: 'acceptAndEndCurrentCall'
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
      return false;
    }
  };

  /**
   * Accept incoming call when there's no active consultation
   * - Simply accepts the call without ending or holding anything
   * - Used when there's no active consultation (startConsult: false)
   */
  acceptIncomingCall = async (incomingCall) => {
    const functionStartTime = Date.now();
    console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Accepting incoming call (no active consultation)`, {
      timestamp: new Date().toISOString(),
      incomingPucode: incomingCall.pucode,
      patientName: incomingCall.patientName,
      notificationId: incomingCall.notificationId,
      hasActiveConsultation: this.state.startConsult,
      incomingCallsCount: this.state.incomingCalls ? this.state.incomingCalls.length : 0
    });

    try {
      // Stop the beep sound
      stopLightBeepSound();
      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Stopped beep sound`);
      
      // DEFENSIVE CHECK: Verify the incoming call is still valid (not ended on kiosk side)
      // Also check if it has been accepted by another pharmacist
      const notificationCheck = await this.verifyCallStillActive(incomingCall);
      if (!notificationCheck) {
        console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Call no longer active, removing from queue`, {
          pucode: incomingCall.pucode,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        // Remove from queue
        this.setState(prevState => ({
          incomingCalls: prevState.incomingCalls.filter(
            call => call.pucode.toLowerCase() !== incomingCall.pucode.toLowerCase()
          )
        }));
        // Show user-friendly message
        alert('This call has ended. The patient may have disconnected.');
        return false;
      }

      
      // Set state for the new call
      // ✅ FIX: Reset consultation notes, release order, and ID capture fields for new call
      this.setState({
        Pickupcode: incomingCall.pucode,
        PatientName: incomingCall.patientName,
        Notifications: incomingCall.notificationData,
        isFirebaseNotification: true,
        prescriptionMasterId: incomingCall.notificationData && incomingCall.notificationData.prescription_master_id,
        // ✅ FIX: Reset consultation-specific state for new call
        consultnotes: '',
        ReleaseOrder: false,
        PatietPrescriptionData: null,
        // ✅ FIX: Reset ID capture fields for new call
        IdRawData: '',
        firstName: '',
        lastName: '',
        dob: '',
        stateCode: '',
        relationship: '',
        expDate: '',
        cardType: '',
        DLNo: ''
      });
      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Set state for new call`, {
        pucode: incomingCall.pucode,
        patientName: incomingCall.patientName,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      // Remove from incoming calls queue
      this.setState(prevState => {
        const updatedIncomingCalls = prevState.incomingCalls.filter(
          call => call.pucode.toLowerCase() !== incomingCall.pucode.toLowerCase()
        );
        console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Removed from incoming calls queue`, {
          removedPucode: incomingCall.pucode,
          remainingIncomingCalls: updatedIncomingCalls.length,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return { incomingCalls: updatedIncomingCalls };
      });

      // Set notification object and patient name
      this.setNotificationObject(incomingCall.notificationData);
      this.setPatientName(incomingCall.notificationData);
      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Set notification object and patient name`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      // Open the consult dialog
      this.handleConsultClickOpen();
      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Opened consult dialog`);

      // Accept the call
      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Calling acceptConsultCall to start consultation`);
      this.acceptConsultCall();

      // Write audit log
      await writeAuditLog(
        `User accepted incoming call from '${incomingCall.patientName}' (no active consultation).`,
        'Consultation',
        { prescriptionMasterId: this.state.prescriptionMasterId }
      );
      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: Audit log written`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      console.log(`📞 [Call Waiting] Home.acceptIncomingCall: ✅ Call accepted successfully`, {
        pucode: incomingCall.pucode,
        patientName: incomingCall.patientName,
        totalElapsed: `${Date.now() - functionStartTime}ms`
      });
      return true;
    } catch (error) {
      console.error(`❌ [Error] Home.acceptIncomingCall: Failed to accept call`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        incomingPucode: incomingCall.pucode,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      
      // Audit trail for error
      const auditPucode = (incomingCall.pucode || '').toString().trim().toUpperCase();
      await logConsultAcceptFailed(
        auditPucode,
        incomingCall.patientName || 'patient',
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            notificationId: incomingCall.notificationData && incomingCall.notificationData.notification_id,
            userConsultNotificationId: incomingCall.notificationData && incomingCall.notificationData.user_consult_notification_id,
            prescriptionMasterId: this.state.prescriptionMasterId,
            action: 'acceptIncomingCall'
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
      return false;
    }
  };

  /**
   * Accept incoming call and HOLD the current active call
   * - Puts the current call on hold (mutes tracks)
   * - Accepts the new incoming call
   */
  acceptAndHoldCurrentCall = async (incomingCall) => {
    const functionStartTime = Date.now();
    console.log(`📞 [Call Waiting] Home.acceptAndHoldCurrentCall: Accepting new call, holding current`, {
      timestamp: new Date().toISOString(),
      incomingPucode: incomingCall.pucode,
      incomingPatientName: incomingCall.patientName,
      currentPucode: this.state.Pickupcode,
      currentPatientName: this.state.PatientName,
      hasActiveConsultation: this.state.startConsult
    });

    try {
      // Stop the beep sound
      stopLightBeepSound();
      
      // DEFENSIVE CHECK: Verify the incoming call is still valid (not ended on kiosk side)
      const notificationCheck = await this.verifyCallStillActive(incomingCall);
      if (!notificationCheck) {
        console.log(`📞 [Call Waiting] Home.acceptAndHoldCurrentCall: Call no longer active, removing from queue`, {
          pucode: incomingCall.pucode,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        // Remove from queue
        this.setState(prevState => ({
          incomingCalls: prevState.incomingCalls.filter(
            call => call.pucode.toLowerCase() !== incomingCall.pucode.toLowerCase()
          )
        }));
        // Show user-friendly message
        alert('This call has ended. The patient may have disconnected.');
        return false;
      }

      // Hold the current call first
      if (this.state.startConsult) {
        const holdSuccess = await this.holdCurrentCall();
        if (!holdSuccess) {
          console.error(`❌ [Error] Home.acceptAndHoldCurrentCall: Failed to hold current call`);
          return false;
        }
      }

      // Remove the incoming call from queue
      this.setState(prevState => ({
        incomingCalls: prevState.incomingCalls.filter(
          call => call.pucode.toLowerCase() !== incomingCall.pucode.toLowerCase()
        ),
        silencedCalls: prevState.silencedCalls.filter(
          p => p.toLowerCase() !== incomingCall.pucode.toLowerCase()
        )
      }));

      // Set up state for new call BEFORE accepting it
      // This ensures acceptConsultCall has the correct state
      // ✅ FIX: Reset consultation notes, release order, and ID capture fields for new call
      this.setState({
        Pickupcode: incomingCall.pucode,
        Notifications: incomingCall.notificationData,
        PatientName: incomingCall.patientName,
        isFirebaseNotification: true,
        startConsult: false,
        isCallActive: false,
        consultOpen: false,
        isCallOnHold: false,
        prescriptionMasterId: incomingCall.notificationData && incomingCall.notificationData.prescription_master_id,
        // ✅ FIX: Reset consultation-specific state for new call
        consultnotes: '',
        ReleaseOrder: false,
        PatietPrescriptionData: null,
        // ✅ FIX: Reset ID capture fields for new call
        IdRawData: '',
        firstName: '',
        lastName: '',
        dob: '',
        stateCode: '',
        relationship: '',
        expDate: '',
        cardType: '',
        DLNo: ''
      });

      // Set notification object and patient name
      this.setNotificationObject(incomingCall.notificationData);
      this.setPatientName(incomingCall.notificationData);

      // Clear localStorage to prevent handleConsultClose from treating new call as missed
      // acceptConsultCall will set it to 'accepted' when the call is accepted
      localStorage.removeItem('IncomingConsultationCallStatus');
      localStorage.removeItem('IncomingConsultationCallPucode');

      // Accept the call immediately without opening the dialog
      // acceptConsultCall will handle all the acceptance logic and close any open dialogs
      console.log(`📞 [Call Waiting] Home.acceptAndHoldCurrentCall: Accepting new call via acceptConsultCall`, {
        newPucode: incomingCall.pucode,
        newPatientName: incomingCall.patientName,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      
      // Call acceptConsultCall directly - it will handle opening/closing dialogs as needed
      // We set consultOpen: false above to ensure no dialog is shown before acceptance
      this.acceptConsultCall();

      // Write audit log
      // Notification UI specific log: User Hold & Accepted the incoming call
      const patientName = incomingCall.patientName || 'patient';
      const incomingPucode = (incomingCall.pucode || '').toString().trim().toUpperCase();
      await logIncomingCallHoldAndAccepted(incomingPucode, patientName, {
        prescriptionMasterId: this.state.prescriptionMasterId
      });
      
      // Legacy audit log (keeping for backward compatibility)
      await writeAuditLog(
        `User put current call on hold and accepted new call from '${incomingCall.patientName}'.`,
        'Consultation',
        { prescriptionMasterId: this.state.prescriptionMasterId }
      );

      console.log(`📞 [Call Waiting] Home.acceptAndHoldCurrentCall: ✅ Held current call and accepting new call`, {
        newPucode: incomingCall.pucode,
        newPatientName: incomingCall.patientName,
        heldCallsCount: this.state.heldCalls ? this.state.heldCalls.length : 0,
        totalElapsed: `${Date.now() - functionStartTime}ms`
      });
      return true;
    } catch (error) {
      console.error(`❌ [Error] Home.acceptAndHoldCurrentCall: Failed to hold and accept`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      
      // Audit trail for error
      const auditPucode = (incomingCall.pucode || '').toString().trim().toUpperCase();
      await logConsultAcceptFailed(
        auditPucode,
        incomingCall.patientName || 'patient',
        {
          message: error.message,
          name: error.name,
          stack: error.stack,
          metadata: {
            notificationId: incomingCall.notificationData && incomingCall.notificationData.notification_id,
            userConsultNotificationId: incomingCall.notificationData && incomingCall.notificationData.user_consult_notification_id,
            prescriptionMasterId: this.state.prescriptionMasterId,
            action: 'acceptAndHoldCurrentCall'
          }
        },
        {
          startConsult: this.state.startConsult,
          isCallActive: this.state.isCallActive,
          consultOpen: this.state.consultOpen
        }
      );
      return false;
    }
  };

  endConsultationSession = async () => {
    const functionStartTime = Date.now();
    console.log(`📞 [Call Waiting] Home.endConsultationSession: Ending consultation session`, {
      timestamp: new Date().toISOString(),
      pickupCode: this.state.Pickupcode,
      patientName: this.state.PatientName,
      startConsult: this.state.startConsult,
      consultOpen: this.state.consultOpen,
      heldCallsCount: this.state.heldCalls ? this.state.heldCalls.length : 0,
      incomingCallsCount: this.state.incomingCalls ? this.state.incomingCalls.length : 0
    });

    // ✅ CRITICAL FIX: Capture pucode BEFORE any state changes to ensure we're working with the correct room
    // This prevents race conditions where state is cleared before leaveRoom() completes
    const currentPucode = this.state.Pickupcode;
    const currentRoomName = currentPucode; // Store for verification
    
    console.log(`📞 [Call Waiting] Home.endConsultationSession: Captured current pucode before state changes`, {
      currentPucode: currentPucode,
      elapsed: `${Date.now() - functionStartTime}ms`
    });

    // ✅ CRITICAL FIX: Leave Twilio room BEFORE clearing state to prevent affecting other pharmacists' calls
    // Only leave room if we have a valid twilio reference AND the room name matches
    if (this.twilio && currentPucode) {
      console.log(`📞 [Call Waiting] Home.endConsultationSession: Leaving Twilio room for current call`, {
        pucode: currentPucode,
        roomName: currentRoomName,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      // Verify the twilio component's room name matches before leaving
      // This ensures we're only disconnecting from the correct room
      if (this.twilio.props && this.twilio.props.roomName === currentPucode) {
        this.twilio.leaveRoom();
      } else {
        console.warn(`⚠️ [Call Waiting] Home.endConsultationSession: Room name mismatch - not leaving room`, {
          twilioRoomName: this.twilio.props ? this.twilio.props.roomName : 'unknown',
          currentPucode: currentPucode,
          note: 'This should not happen - skipping leaveRoom to prevent affecting other calls'
        });
      }
    } else {
      console.log(`📞 [Call Waiting] Home.endConsultationSession: No Twilio room to leave, closing consult dialog`, {
        hasTwilio: !!this.twilio,
        hasPucode: !!currentPucode,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      this.handleConsultClose();
    }

    if (this.socket && currentPucode) {
      console.log(`📞 [Call Waiting] Home.endConsultationSession: Emitting completeConsult socket event`, {
        pucode: currentPucode,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      this.socket.emit('completeConsult', {
        pucode: currentPucode,
        message: 'Complete consult from portal',
      });
    }

    console.log(`📞 [Call Waiting] Home.endConsultationSession: Capturing session data before state reset`, {
      elapsed: `${Date.now() - functionStartTime}ms`
    });
    
    // Log consultation ended by pharmacist
    if (currentPucode) {
      logConsultEndedByPharmacist(currentPucode, { prescriptionMasterId: this.state.prescriptionMasterId });
    }
    
    const notificationData = this.state.Notifications;
    const capturedStartTime = this.state.consultStartTime;
    const capturedConsultNotes = this.state.consultnotes;
    const capturedReleaseOrder = this.state.ReleaseOrder;
    const capturedReasonId = this.state.selectedReasonId;
    const capturedReasonText = this.state.selectedReasonText;
    const capturedIdCaptureType = this.state.id_capture_type;
    
    // Get pharmacist name from session storage (since notification doesn't have it)
    const pharmacistName = (sessionStorage.getItem('user.firstname') || '') + ' ' + (sessionStorage.getItem('user.lastname') || '');
    
    // ✅ FIX: Always clear consultation-related state for the completed call to prevent modal from reappearing
    // But preserve held calls and incoming calls arrays if they exist
    const hasHeldCalls = this.state.heldCalls && this.state.heldCalls.length > 0;
    const hasIncomingCalls = this.state.incomingCalls && this.state.incomingCalls.length > 0;
    const completedPucode = currentPucode; // Use captured pucode instead of state
    
    console.log(`📞 [Call Waiting] Home.endConsultationSession: Checking if should clear incoming calls`, {
      hasHeldCalls: hasHeldCalls,
      heldCallsCount: this.state.heldCalls ? this.state.heldCalls.length : 0,
      hasIncomingCalls: hasIncomingCalls,
      incomingCallsCount: this.state.incomingCalls ? this.state.incomingCalls.length : 0,
      completedPucode: completedPucode
    });
    
    // ✅ FIX: Always clear consultation state for completed call, but preserve held/incoming calls if they exist
    // This prevents the "Accept/Decline" modal from reappearing due to stale state
    this.setState({ 
      startConsult: false,
      isCallActive: false,
      orderNotReleasedOpen: false, 
      consultStartTime: null,
      // Clear consultation-related state to prevent modal from reappearing
      Notifications: {},
      Pickupcode: '',
      PatientName: '',
      isFirebaseNotification: false,
      prescriptionMasterId: '',
      consultOpen: false,
      missedCallAckDialog: false,
      missedCallPatientName: ''
    });
    
    // Clear localStorage status to prevent stale data
    localStorage.removeItem('IncomingConsultationCallStatus');
    localStorage.removeItem('IncomingConsultationCallPucode');
    
    if (!hasHeldCalls && !hasIncomingCalls) {
      console.log(`📞 [Call Waiting] Home.endConsultationSession: No held or incoming calls - clearing all call state`);
      // Clear everything including held calls and incoming calls
      this.setState({
        heldCalls: [],
        incomingCalls: [],
        silencedCalls: [],
        isCallOnHold: false
      });
      stopLightBeepSound();
    } else {
      console.log(`📞 [Call Waiting] Home.endConsultationSession: Keeping held/incoming calls visible for pharmacist choice`, {
        heldCallsCount: this.state.heldCalls ? this.state.heldCalls.length : 0,
        incomingCallsCount: this.state.incomingCalls ? this.state.incomingCalls.length : 0,
        action: 'Pharmacist can manually resume held calls or accept incoming calls',
        note: 'Consultation state cleared to prevent modal reappearance'
      });
    }

    var endSessionObj = {
      user_consult_notification_id: notificationData.user_consult_notification_id,
      is_consult_end_call: true,
      is_user_end_call: false,
      is_call_status: 'Completed',
    };

    console.log(`📞 [Call Waiting] Home.endConsultationSession: Sending end session API request`, {
      startTime: capturedStartTime,
      pharmacistName: pharmacistName,
      elapsed: `${Date.now() - functionStartTime}ms`
    });
    
    fetch(process.env.REACT_APP_BASEURL + 'endconsultsession', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(endSessionObj),
    })
      .then((response) => {
        console.log(`📞 [Call Waiting] Home.endConsultationSession: Received end session API response`, {
          status: response.status,
          ok: response.ok,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return response.ok;
      })
      .then((success) => {
        if (success && notificationData) {
          console.log(`📞 [Call Waiting] Home.endConsultationSession: Saving consult master entry with Status=Completed`, {
            elapsed: `${Date.now() - functionStartTime}ms`
          });
          
          const endTime = new Date().toISOString();
          
          const masterObj = {
            consult_start_date: capturedStartTime, // Use captured start time
            consult_end_date: endTime,
            pickup_code: notificationData.resource_id,
            notification_id: notificationData.notification_id,
            user_name: notificationData.User_name,
            call_duration: capturedStartTime ? this.getMinutes(capturedStartTime, endTime) : null,
            user_id: notificationData.user_id,
            consultation_name: pharmacistName.trim() || notificationData.consultant_name, // Use pharmacist name from session
            Status: 'Completed',
            accounts_id: notificationData.accounts_id,
            store_name: notificationData.store_name,
            box_id: notificationData.box_id,
            kiosk_name: notificationData.kiosk_name,
            consultation_notes: capturedConsultNotes,
            is_releaseorder: capturedReleaseOrder,
            selectedReasonId: capturedReasonId,
            selectedReasonText: capturedReasonText,
            id_capture_type: capturedIdCaptureType
          };
          
          console.log(`📞 [Call Waiting] Home.endConsultationSession: Consult master object prepared`, {
            startTime: capturedStartTime,
            endTime: endTime,
            pharmacist: masterObj.consultation_name,
            status: masterObj.Status,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
          
          fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
            method: 'post',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
            },
            body: JSON.stringify(masterObj),
          })
            .then((res) => {
              console.log(`📞 [Call Waiting] Home.endConsultationSession: Consult master entry saved successfully`, {
                elapsed: `${Date.now() - functionStartTime}ms`
              });
            })
            .catch((err) => {
              console.log(`❌ [Error] Home.endConsultationSession: Failed to save consult master entry`, {
                error: err,
                elapsed: `${Date.now() - functionStartTime}ms`
              });
            });
        }
      })
      .catch(error => {
        console.log(`❌ [Error] Home.endConsultationSession: Error ending session`, {
          errorName: error.name,
          errorMessage: error.message,
          errorStack: error.stack,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      });

    console.log(`📞 [Call Waiting] Home.endConsultationSession: Processing ID data`, {
      elapsed: `${Date.now() - functionStartTime}ms`
    });
    
    // Safely access IdData - may be empty for test calls (e.g., VTSCLL)
    const hasIdData = this.state.IdData && this.state.IdData.length > 0;
    const idDataFirst = hasIdData ? this.state.IdData[0] : {};
    
    const currentConsultPucode = (this.state.Pickupcode || (this.state.Notifications && this.state.Notifications.resource_id) || '').toString().trim().toUpperCase();
    const matchedPrescriptionRow =
      Array.isArray(this.state.PatietPrescriptionData)
        ? this.state.PatietPrescriptionData.find((row) => {
          const rowPucode = (row && (row.pucode || row.pickup_code || row.puCode || '')).toString().trim().toUpperCase();
          return rowPucode === currentConsultPucode;
        })
        : null;

    let order_id =
      idDataFirst.order_id ||
      idDataFirst.prescription_master_id ||
      idDataFirst.id ||
      (matchedPrescriptionRow && (matchedPrescriptionRow.order_id || matchedPrescriptionRow.prescription_master_id || matchedPrescriptionRow.id)) ||
      null;

    let orderIds = [];
    if (order_id) {
      orderIds.push({
        id: order_id
      });
    }

    let IdObject = {
      customer_id:
        idDataFirst.customer_id ||
        (matchedPrescriptionRow && matchedPrescriptionRow.customer_id) ||
        (this.state.Notifications && this.state.Notifications.customer_id) ||
        null,
      order_id: order_id,
      drivers_license_no: this.state.DLNo,
      first_name: this.state.firstName,
      middle_name: null,
      last_name: this.state.lastName,
      dob: this.state.dob,
      relationship: this.state.relationship,
      box_id:
        idDataFirst.box_id ||
        (matchedPrescriptionRow && matchedPrescriptionRow.box_id) ||
        (this.state.Notifications && this.state.Notifications.box_id) ||
        null,
      account_id:
        idDataFirst.account_id ||
        (matchedPrescriptionRow && (matchedPrescriptionRow.account_id || matchedPrescriptionRow.accountId)) ||
        (this.state.Notifications && this.state.Notifications.account_id) ||
        null,
      orderIds: JSON.stringify(orderIds),
      selectedStateCode: this.state.stateCode,
      dlrawdata: this.state.IdRawData,
      is_consult_requested: true,
      call_third_party_API: false,
      exp_date: this.state.expDate,
      card_type: this.state.cardType
    };

    /* audit trail for end consultation session with patient */
    console.log(`📞 [Call Waiting] Home.endConsultationSession: Preparing audit log for session end`, {
      elapsed: `${Date.now() - functionStartTime}ms`
    });
    const { first_name, last_name, patientName, prescriptionMasterId } = this.state;
    const auditPatientName = patientName || (this.state.Notifications && this.state.Notifications.User_name) || ((first_name && last_name) ? (first_name + ' ' + last_name) : 'patient');

    console.log(`📞 [Call Waiting] Home.endConsultationSession: Writing audit log for session end`, {
      patientName: auditPatientName,
      elapsed: `${Date.now() - functionStartTime}ms`
    });
    await writeAuditLog(`Consultation session with '${auditPatientName}' ended by user.`, 'Consultation', { prescriptionMasterId: prescriptionMasterId });
    // await writeAuditLog(
    //   `Consultation session with '${auditPatientName}' ended by user.`,
    //   'Consultation',
    //   { prescriptionMasterId: prescriptionMasterId },
    //   {
    //     eventType: 'CONSULT_ENDED',
    //     source: 'PORTAL',
    //     severity: 'INFO',
    //     metadata: {
    //       pickupCode: this.state.Pickupcode,
    //     },
    //   }
    // );

    console.log(`📞 [Call Waiting] Home.endConsultationSession: Saving customer collected details`, {
      elapsed: `${Date.now() - functionStartTime}ms`
    });
    const user = JSON.parse(sessionStorage.getItem('user'));
    const sessionToken =
      user &&
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.jwtToken;

    // Keep backward compatibility for older auth bootstrap flows.
    const legacyAuthToken = localStorage.getItem('authTokens');
    let legacyToken = null;
    if (legacyAuthToken) {
      try {
        legacyToken = atob(legacyAuthToken);
      } catch (error) {
        console.log(`⚠️ [Warning] Home.endConsultationSession: Failed to decode legacy authTokens`, {
          errorName: error && error.name,
          errorMessage: error && error.message
        });
      }
    }
    const actualToken = sessionToken || legacyToken;

    if (!actualToken) {
      console.log(`❌ [Error] Home.endConsultationSession: No valid auth token available for saveKioskCustomerCollectedDetail`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
    }
    const requestHeaders = {
      'Content-Type': 'application/json'
    };
    if (actualToken) {
      requestHeaders.Authorization = 'Bearer ' + actualToken;
    }

    fetch(process.env.REACT_APP_BASEURL + 'saveKioskCustomerCollectedDetail', {
      method: 'post',
      withCredentials: true,
      headers: requestHeaders,
      body: JSON.stringify(IdObject)
    })
      .then((response) => {
        console.log(`📞 [Call Waiting] Home.endConsultationSession: Received response for customer details`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        try {
          return response.text();
        } catch (error) {
          console.log(`❌ [Error] Home.endConsultationSession: Failed to parse response`, {
            errorName: error.name,
            errorMessage: error.message
          });
          return null;
        }
      })
      .then(() => {
        console.log(`📞 [Call Waiting] Home.endConsultationSession: Resetting ID state data`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        this.setState({
          firstName: "",
          lastName: "",
          DLNo: "",
          dob: "",
          stateCode: "",
          cardType: "",
          relationship: "",
          expDate: "",
          IdRawData: ""
        });
      })
      .catch(error => {
        console.log(`❌ [Error] Home.endConsultationSession: Error saving customer details`, {
          errorName: error.name,
          errorMessage: error.message,
          errorStack: error.stack,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      });
    
    console.log(`📞 [Call Waiting] Home.endConsultationSession: ✅ Consultation session ended successfully`, {
      pickupCode: this.state.Pickupcode,
      heldCallsCount: this.state.heldCalls ? this.state.heldCalls.length : 0,
      incomingCallsCount: this.state.incomingCalls ? this.state.incomingCalls.length : 0,
      totalElapsed: `${Date.now() - functionStartTime}ms`
    });
  };

  saveConsultMasterEntry = (uData) => {
    const functionStartTime = Date.now();
    console.log(`⚙️ [Function] Home.saveConsultMasterEntry: Starting to save consult master entry`, {
      timestamp: new Date().toISOString()
    });

    try {
      console.log(`⚙️ [Function] Home.saveConsultMasterEntry: Parsing input data`);
      var uDatas = JSON.parse(uData);

      const callDuration = this.getMinutes(
        uDatas.consult_start_date,
        uDatas.consult_end_date
      );

      console.log(`⚙️ [Function] Home.saveConsultMasterEntry: Creating master object`, {
        pickupCode: uDatas.resource_id,
        userName: uDatas.User_name,
        callDuration,
        callStatus: uDatas.is_call_status,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      var masterObj = {
        consult_start_date: uDatas.consult_start_date,
        consult_end_date: uDatas.consult_end_date,
        pickup_code: uDatas.resource_id,
        notification_id: uDatas.notification_id,
        user_name: uDatas.User_name,
        call_duration: callDuration,
        user_id: uDatas.user_id,
        consultation_name: uDatas.consultant_name,
        Status: uDatas.is_call_status,
        accounts_id: uDatas.accounts_id,
        store_name: uDatas.store_name,
        box_id: uDatas.box_id,
        kiosk_name: uDatas.kiosk_name,
        consultation_notes: this.state.consultnotes,
        is_releaseorder: this.state.ReleaseOrder,
        selectedReasonId: this.state && this.state.selectedReasonId,
        selectedReasonText: this.state && this.state.selectedReasonText,
        id_capture_type: this.state && this.state.id_capture_type
      };

      console.log(`🌐 [Network] Home.saveConsultMasterEntry: Sending consultation data to server`, {
        endpoint: 'saveuserconsult',
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      fetch(process.env.REACT_APP_BASEURL + 'saveuserconsult', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(masterObj),
      })
        .then((response) => {
          console.log(`🌐 [Network] Home.saveConsultMasterEntry: Received response`, {
            status: response.status,
            ok: response.ok,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
          try {
            return response.text();
          } catch (error) {
            console.log(`❌ [Error] Home.saveConsultMasterEntry: Failed to parse response`, {
              errorName: error.name,
              errorMessage: error.message,
              errorStack: error.stack,
              elapsed: `${Date.now() - functionStartTime}ms`
            });
            return null;
          }
        })
        .then((responseData) => {
          if (responseData) {
            console.log(`⚙️ [Function] Home.saveConsultMasterEntry: Consult data saved successfully`, {
              elapsed: `${Date.now() - functionStartTime}ms`,
              responseLength: responseData.length
            });
          } else {
            console.log(`⚙️ [Function] Home.saveConsultMasterEntry: No response data received`, {
              elapsed: `${Date.now() - functionStartTime}ms`
            });
          }
        })
        .catch((error) => {
          console.log(`❌ [Error] Home.saveConsultMasterEntry: Error saving consult data`, {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
        });
    } catch (error) {
      console.log(`❌ [Error] Home.saveConsultMasterEntry: Unexpected error processing consult data`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
    }
  };

  minsToHHMMSS = (resultInMinutes) => {
    var mins_num = parseFloat(resultInMinutes, 10);
    var hours = Math.floor(mins_num / 60);
    var minutes = Math.floor(mins_num - (hours * 3600) / 60);
    var seconds = Math.floor(mins_num * 60 - hours * 3600 - minutes * 60);
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
  };

  getMinutes = (consult_start_date, consult_end_date) => {
    if (
      (consult_start_date !== '' || consult_start_date !== undefined) &&
      (consult_end_date !== '' || consult_end_date !== undefined)
    ) {
      var startTime = this.getFormattedDate(consult_start_date);
      var endTime = this.getFormattedDate(consult_end_date);
      var difference =
        new Date(endTime).getTime() - new Date(startTime).getTime();
      var resultInMinutes = difference / 60000;
      return this.minsToHHMMSS(resultInMinutes);
    } else {
      return '';
    }
  };

  getFormattedDate = (date) => {
    var d = new Date(date),
      dformat =
        [d.getFullYear(), padLeft(d.getMonth() + 1), padLeft(d.getDate())].join(
          '/'
        ) +
        ' ' +
        [
          padLeft(d.getHours()),
          padLeft(d.getMinutes()),
          padLeft(d.getSeconds()),
        ].join(':');
    return dformat;
  };

  getNotificationByNotificationID = (notificationId) => {
    const functionStartTime = Date.now();
    console.log(`⚙️ [Function] Home.getNotificationByNotificationID: Fetching notification details`, {
      timestamp: new Date().toISOString(),
      notificationId: notificationId
    });

    try {
      if (!notificationId) {
        console.log(`❌ [Error] Home.getNotificationByNotificationID: Missing notification ID`, {
          notificationId: notificationId,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return;
      }

      console.log(`🌐 [Network] Home.getNotificationByNotificationID: Sending request`, {
        endpoint: `getNotificationByid/${notificationId}`,
        method: 'GET',
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      fetch(
        process.env.REACT_APP_BASEURL + 'getNotificationByid/' + notificationId,
        {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
          },
        }
      )
        .then((response) => {
          console.log(`🌐 [Network] Home.getNotificationByNotificationID: Received response`, {
            status: response.status,
            ok: response.ok,
            elapsed: `${Date.now() - functionStartTime}ms`
          });

          if (!response.ok) {
            console.log(`❌ [Error] Home.getNotificationByNotificationID: Server returned error response`, {
              status: response.status,
              statusText: response.statusText,
              elapsed: `${Date.now() - functionStartTime}ms`
            });
          }

          try {
            return response.text();
          } catch (error) {
            console.log(`❌ [Error] Home.getNotificationByNotificationID: Failed to parse response text`, {
              errorName: error.name,
              errorMessage: error.message,
              errorStack: error.stack,
              elapsed: `${Date.now() - functionStartTime}ms`
            });
            return null;
          }
        })
        .then((uData) => {
          if (uData !== null && uData !== '') {
            console.log(`⚙️ [Function] Home.getNotificationByNotificationID: Notification data received, saving consult master entry`, {
              dataLength: uData.length,
              elapsed: `${Date.now() - functionStartTime}ms`
            });
            this.saveConsultMasterEntry(uData);
          } else {
            console.log(`⚙️ [Function] Home.getNotificationByNotificationID: No notification data received`, {
              elapsed: `${Date.now() - functionStartTime}ms`
            });
          }
        })
        .catch((error) => {
          console.log(`❌ [Error] Home.getNotificationByNotificationID: Error fetching notification`, {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack,
            notificationId: notificationId,
            elapsed: `${Date.now() - functionStartTime}ms`
          });
        })
        .finally(() => {
          console.log(`⚙️ [Function] Home.getNotificationByNotificationID: Function execution completed`, {
            totalDuration: `${Date.now() - functionStartTime}ms`
          });
        });
    } catch (error) {
      console.log(`❌ [Error] Home.getNotificationByNotificationID: Unexpected error`, {
        errorName: error.name,
        errorMessage: error.message,
        errorStack: error.stack,
        notificationId: notificationId,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
    }
  };

  setPatientName = (uData, callback) => {
    let ordersByPickupCode = null;
    const raw = uData.orders_pickup_codes;
    if (raw != null && raw !== '' && raw !== 'undefined' && raw !== 'null') {
      // API may return JSON string (from text column) or already-parsed array (from JSONB)
      if (Array.isArray(raw)) {
        ordersByPickupCode = raw;
      } else if (typeof raw === 'string') {
        try {
          ordersByPickupCode = JSON.parse(raw);
          if (!Array.isArray(ordersByPickupCode)) ordersByPickupCode = [uData.resource_id];
        } catch (_) {
          ordersByPickupCode = [uData.resource_id];
        }
      } else {
        ordersByPickupCode = [uData.resource_id];
      }
    } else {
      ordersByPickupCode = [uData.resource_id];
    }
    this.setState({
      PatientName: uData.User_name,
      Pickupcode: uData.resource_id || uData.notification_id,
      isNormalConsult: Boolean(uData.notification_id),
      prescriptionMasterId: uData.prescriptions_master_id,
      ordersPickUpCode: ordersByPickupCode
    }, callback);
  };

  setNotificationObject = (udatas) => {
    this.setState({
      Notifications: udatas,
      ReleaseOrder: udatas.is_releaseorder,
      consultnotes: udatas.consultation_notes,
    });
  };

  startConsultation = () => {
    const startTime = new Date().toISOString();
    console.log(`🖱️ [Event] Home.startConsultation: Starting consultation`, {
      timestamp: startTime,
      startConsult: this.state.startConsult,
      loader: this.state.loader,
      isButtonDisabled: this.state.isButtonDisabled
    });
    
    // Log consultation started
    const pucode = (this.state.Pickupcode || '').toString().trim();
    if (pucode) {
      logConsultStarted(pucode, { prescriptionMasterId: this.state.prescriptionMasterId });
    }
    
    this.setState({
      startConsult: true,
      isCallActive: true, // Mark video call as active
      consultStartTime: startTime, // Record when consultation started
      loader: false,
      isButtonDisabled: false,
    });
  };

  writeTaskManagerMissedCallEntry = async (notificationObj) => {
    const functionStartTime = Date.now();
    console.log(`⚙️ [Function] Home.writeTaskManagerMissedCallEntry: Starting to write missed call entry`, {
      timestamp: new Date().toISOString(),
      taskTitle: notificationObj.taskTitle,
      action: notificationObj.action,
      userId: notificationObj.userID,
      priority: notificationObj.priority
    });

    try {
      console.log(`🌐 [Network] Home.writeTaskManagerMissedCallEntry: Sending request to taskmanager endpoint`, {
        endpoint: 'taskmanager',
        method: 'POST',
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      const response = await fetch(process.env.REACT_APP_BASEURL + 'taskmanager', {
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(notificationObj),
      });

      console.log(`🌐 [Network] Home.writeTaskManagerMissedCallEntry: Received response`, {
        status: response.status,
        ok: response.ok,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      try {
        const responseData = await response.json();
        console.log(`⚙️ [Function] Home.writeTaskManagerMissedCallEntry: Task entry created successfully`, {
          success: responseData.success || true,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return responseData;
      } catch (parseError) {
        console.log(`❌ [Error] Home.writeTaskManagerMissedCallEntry: Failed to parse response`, {
          errorName: parseError.name,
          errorMessage: parseError.message,
          errorStack: parseError.stack,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        return null;
      }
    } catch (err) {
      console.log(`❌ [Error] Home.writeTaskManagerMissedCallEntry: Error creating task entry`, {
        errorName: err.name,
        errorMessage: err.message,
        errorStack: err.stack,
        taskDetails: notificationObj.taskDetails,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      // Attempt to log the error in a more structured way
      try {
        await writeAuditLog(`Failed to create missed call task entry: ${err.message}`, 'Error');
        // await writeAuditLog(
        //   `Failed to create missed call task entry: ${err.message}`,
        //   'Error',
        //   {},
        //   {
        //     eventType: 'CONSULT_MISSED_RECORDED',
        //     source: 'PORTAL',
        //     severity: 'ERROR',
        //     metadata: {
        //       error: err && err.message ? err.message : err,
        //       taskTitle: notificationObj.taskTitle,
        //     },
        //   }
        // );
        console.log(`🌐 [Network] Home.writeTaskManagerMissedCallEntry: Created audit log for error`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      } catch (auditError) {
        console.log(`❌ [Error] Home.writeTaskManagerMissedCallEntry: Failed to create audit log for error`, {
          errorName: auditError.name,
          errorMessage: auditError.message,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      }

      return null;
    } finally {
      console.log(`⚙️ [Function] Home.writeTaskManagerMissedCallEntry: Function execution completed`, {
        totalDuration: `${Date.now() - functionStartTime}ms`
      });
    }
  };

  handleMissedCallAcknowledgement = async (event) => {
    const functionStartTime = Date.now();
    console.log(`🖱️ [Event] Home.handleMissedCallAcknowledgement: Acknowledging missed call`, {
      timestamp: new Date().toISOString()
    });

    try {
      const prescriptionMasterId = localStorage.getItem('IncomingConsultationCallPrescriptionId');
      const username = (sessionStorage.getItem('user.firstname') + ' ' + sessionStorage.getItem('user.lastname')) || 'User';

      console.log(`⚙️ [Function] Home.handleMissedCallAcknowledgement: Retrieved context data`, {
        prescriptionMasterId: prescriptionMasterId,
        username: username,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      console.log(`🌐 [Network] Home.handleMissedCallAcknowledgement: Writing audit log`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      try {
        const auditMsg = `'${username}' acknowledged missed consultation request.`;
        await writeAuditLog(auditMsg, 'Consultation', { prescriptionMasterId: prescriptionMasterId });
        // await writeAuditLog(
        //   auditMsg,
        //   'Consultation',
        //   { prescriptionMasterId: prescriptionMasterId },
        //   {
        //     eventType: 'CONSULT_MISSED_RECORDED',
        //     source: 'PORTAL',
        //     severity: 'INFO',
        //     metadata: {
        //       user: username,
        //     },
        //   }
        // );
        console.log(`🌐 [Network] Home.handleMissedCallAcknowledgement: Audit log written successfully`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      } catch (auditError) {
        console.log(`❌ [Error] Home.handleMissedCallAcknowledgement: Failed to write audit log`, {
          errorName: auditError.name,
          errorMessage: auditError.message,
          errorStack: auditError.stack,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        // Continue execution despite audit log failure
      }

      console.log(`⚙️ [Function] Home.handleMissedCallAcknowledgement: Clearing localStorage entries`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      localStorage.removeItem('IncomingConsultationCallStatus');
      localStorage.removeItem('IncomingConsultationCallPucode');
      localStorage.removeItem('IncomingConsultationCallPrescriptionId');

      console.log(`🔄 [State] Home.handleMissedCallAcknowledgement: Resetting UI state`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      this.setState({
        missedCallAckDialog: false,
        consultOpen: false,
        loader: false,
        isButtonDisabled: false,
        orderNotReleasedOpen: false,
        prescriptionMasterId: '',
        missedCallPatientName: '',
      });

      console.log(`⚙️ [Function] Home.handleMissedCallAcknowledgement: Refreshing notifications`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      // fetch latest notification 
      try {
        this.gettingTaskNotification(false);
        console.log(`⚙️ [Function] Home.handleMissedCallAcknowledgement: Notifications refreshed successfully`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      } catch (notificationError) {
        console.log(`❌ [Error] Home.handleMissedCallAcknowledgement: Failed to refresh notifications`, {
          errorName: notificationError.name,
          errorMessage: notificationError.message,
          errorStack: notificationError.stack,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      }

      console.log(`⚙️ [Function] Home.handleMissedCallAcknowledgement: Function completed successfully`, {
        totalDuration: `${Date.now() - functionStartTime}ms`
      });
    } catch (err) {
      console.log(`❌ [Error] Home.handleMissedCallAcknowledgement: Error processing missed call acknowledgement`, {
        errorName: err.name,
        errorMessage: err.message,
        errorStack: err.stack,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      // Try recovery by at least closing the dialog
      try {
        console.log(`⚙️ [Function] Home.handleMissedCallAcknowledgement: Attempting recovery by resetting UI state`, {
          elapsed: `${Date.now() - functionStartTime}ms`
        });
        this.setState({
          missedCallAckDialog: false,
          consultOpen: false,
          loader: false
        });
      } catch (recoveryError) {
        console.log(`❌ [Error] Home.handleMissedCallAcknowledgement: Recovery attempt failed`, {
          errorName: recoveryError.name,
          errorMessage: recoveryError.message,
          elapsed: `${Date.now() - functionStartTime}ms`
        });
      }
    }
  };

  handleCallAcceptedByOtherUserAcknowledgement = async () => {
    const functionStartTime = Date.now();
    console.log(`🖱️ [Event] Home.handleCallAcceptedByOtherUserAcknowledgement: Acknowledging call accepted by other user`, {
      timestamp: new Date().toISOString()
    });

    try {
      const prescriptionMasterId = localStorage.getItem('IncomingConsultationCallPrescriptionId');
      const username = (sessionStorage.getItem('user.firstname') + ' ' + sessionStorage.getItem('user.lastname')) || 'User';

      console.log(`⚙️ [Function] Home.handleCallAcceptedByOtherUserAcknowledgement: Retrieved context data`, {
        prescriptionMasterId: prescriptionMasterId,
        username: username,
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      console.log(`🌐 [Network] Home.handleCallAcceptedByOtherUserAcknowledgement: Writing audit log`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });

      const auditMsg = `'${username}' acknowledged that consultation call was accepted by another user.`;
      await writeAuditLog(auditMsg, 'Consultation', { prescriptionMasterId: prescriptionMasterId });
      // await writeAuditLog(
      //   auditMsg,
      //   'Consultation',
      //   { prescriptionMasterId: prescriptionMasterId },
      //   {
      //     eventType: 'CONSULTATION_ACCEPTED_SIGNAL',
      //     source: 'PORTAL',
      //     severity: 'INFO',
      //     metadata: {
      //       acknowledgedBy: username,
      //       pickupCode: this.state.Pickupcode,
      //     },
      //   }
      // );
      console.log(`🌐 [Network] Home.handleCallAcceptedByOtherUserAcknowledgement: Audit log written successfully`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
    } catch (auditError) {
      console.log(`❌ [Error] Home.handleCallAcceptedByOtherUserAcknowledgement: Failed to write audit log`, {
        errorName: auditError.name,
        errorMessage: auditError.message,
        errorStack: auditError.stack,
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      // Continue execution despite audit log failure
    } finally {
      console.log(`⚙️ [Function] Home.handleCallAcceptedByOtherUserAcknowledgement: Clearing localStorage entries`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      localStorage.removeItem('IncomingConsultationCallPrescriptionId');

      console.log(`🔄 [State] Home.handleCallAcceptedByOtherUserAcknowledgement: Resetting UI state`, {
        elapsed: `${Date.now() - functionStartTime}ms`
      });
      this.setState({
        callAcceptedByOtherUser: false,
        consultOpen: false,
        loader: false,
        isButtonDisabled: false,
        orderNotReleasedOpen: false,
        prescriptionMasterId: '',
        missedCallPatientName: '',
      });

      console.log(`⚙️ [Function] Home.handleCallAcceptedByOtherUserAcknowledgement: Function completed successfully`, {
        totalDuration: `${Date.now() - functionStartTime}ms`
      });
    }
  };

  handleMissedCallCount = () => {
    console.log(`🖱️ [Event] Home.handleMissedCallCount: Handling missed call count`, { missedCallCount: this.state.missedCallCount });
    /* reset missed call counter */
    localStorage.setItem('missedCallCount', 0);
    this.setState({ missedCallCount: 0 });
  };

  handleOpenConsultSettingsPopup = (event) => {
    this.setState({ consultSettingsAnchorEl: event.currentTarget, consultSettingsIsPopupOpen: true });
  };

  handleCloseConsultSettingsPopup = () => {
    this.setState({ consultSettingsAnchorEl: null, consultSettingsIsPopupOpen: false });
  };

  handleIsAudioOnlyChange = (audioOnlyCheckboxIsChecked) => {
    this.setState({ isAudioOnlyConsult: audioOnlyCheckboxIsChecked });
  };

  getFailedMessages = async () => {
    try {
      const res = await fetch(process.env.REACT_APP_BASEURL + 'messageLog/last7days', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).signInUserSession
            .idToken.jwtToken
            }`,
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) {
        console.log(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();

      if (data.length > 0) {
        this.setState({ failedMessageData: data, unReadCount: data && data.length })
      } else {
        this.setState({ failedMessageData: [], unReadCount: 0 })
      }
    } catch (err) {
      console.log("Error while fetching failed message data.", err);
    }
  };

  handleResendMessage = async (currentMessageData) => {
    try {
      this.setState({ resendingMessageId: currentMessageData.id }); // Start loading
  
      const res = await fetch(process.env.REACT_APP_BASEURL + 'resendMessage', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(currentMessageData),
      });
  
      if (!res.ok) {
        console.log(`HTTP error! status: ${res.status}`);
      }
  
      const data = await res.json();
      console.log("Response for resend message", data);
  
    } catch (err) {
      console.log("Error while resending message.", err);
    } finally {
      this.getFailedMessages();
      this.setState({ isResending: false }); // Stop loading
    }
  };

  convertToTimeZone = (requestDate) => {
      const currentUserLang = localStorage.getItem('i18nextLng');
      let zone;
      zone = sessionStorage.getItem('timeZone');
      const date = moment(new Date(requestDate));
      if (['null', null, 'undefined', undefined].includes(zone)) {
        zone = defaultZone;
      }
      return currentUserLang === 'en'
        ? date
          .tz(zone.substring(zone.lastIndexOf(' ') + 1))
          .format('MM/DD/YYYY')
        : date
          .tz(zone.substring(zone.lastIndexOf(' ') + 1))
          .format('DD/MM/YYYY');
    };
  
  
  render() {
    // Getting FCM Notification from Service Worker!
    const sw = getServiceWorker();
    if (sw && this.state.checkedB) {
      sw.onmessage = ({ data }) => {
        if (
          data &&
          data.type &&
          ['notificationArrived', 'notificationclick'].includes(data.type)
        ) {
          // Phase 1: Capture active call's pickup code BEFORE state update (to prevent overwrite)
          const activeCallPucode = this.state.startConsult ? (this.state.Pickupcode || '').toLowerCase() : '';
          const incomingPucode = (data.notification.body || '').toLowerCase();
          
          console.log(`📞 [Phase 1] Home.render: Service worker - Captured pickup codes before state update`, {
            activeCallPucode: activeCallPucode,
            incomingPucode: incomingPucode,
            startConsult: this.state.startConsult
          });
          
          // Phase 1: Don't update Pickupcode if there's an active call (to prevent overwriting active call details)
          const stateUpdate = {
              isFirebaseNotification: true,
              firebaseNotification: {
                title: data.notification.title,
                body: data.notification.body,
              },
          };
          
          // Issue A Fix: Only update Pickupcode if there's no active call AND no consultation dialog is currently open
          if (!this.state.startConsult && !this.state.consultOpen) {
            stateUpdate.Pickupcode = data.notification.body;
            console.log(`📞 [Phase 1] Home.render: Service worker - No active call and dialog not open, updating Pickupcode to`, data.notification.body);
          } else if (this.state.startConsult) {
            console.log(`📞 [Phase 1] Home.render: Service worker - Active call exists, NOT updating Pickupcode (preserving active call: ${this.state.Pickupcode})`);
          } else if (this.state.consultOpen) {
            console.log(`📞 [Phase 1] Home.render: Service worker - Consultation dialog already open, NOT updating Pickupcode (preserving pending call: ${this.state.Pickupcode})`);
          }
          
          this.setState(
            stateUpdate,
            () => {
              console.log(
                '***FCM Notification Received At App by : ServiceWorker***'
              );
              // Remove the playSound code since it's now handled by the notification-handler
            }
          );
          console.log(
            '***ConsultCallback Function Call From : FCM Background***'
          );
          
          // Play the notification sound (continuous for consult calls) - only if no active video call
          if (!this.state.isCallActive) {
          playNotificationSound(false, undefined, true);
          }
          
          // Phase 1: Always call consultCallback - it will queue if active call exists or dialog is open
          // Pass the captured activeCallPucode to consultCallback for proper comparison
          // If consultOpen is true, it means a dialog is already open for a pending call, so new calls should be queued.
          if (this.state.startConsult || this.state.consultOpen) {
            console.log(`📞 [Phase 1] Home.render: Service worker notification - Active call or pending dialog exists, calling consultCallback to queue incoming call`, {
              activeCallPucode: activeCallPucode,
              incomingPucode: incomingPucode,
              startConsult: this.state.startConsult,
              consultOpen: this.state.consultOpen
            });
          } else {
            console.log(`📞 [Phase 1] Home.render: Service worker notification - No active call and no pending dialog, calling consultCallback to show dialog`);
          }
          // Always call consultCallback - it will queue if needed or show dialog if not
          this.consultCallback(activeCallPucode);
          console.log('Pickupcode: ' + this.state.Pickupcode);
        }
      };
    }

    const { classes, theme, children, t } = this.props;
    const {
      anchorEl,
      showTestYourBrowserPopup,
      value,
      anchorElNotification,
      isOpen,
      notificationData,
      notificationCount,
      showTroubleTitle,
      preferredLocation,
      selectedBoxId,
      boxList,
      hasPreferredLocationSelected,
      isInProgress,
      selectedReasonId,
      selectedReasonText,
      notificationDetails,
      consultSettingsAnchorEl,
      consultSettingsIsPopupOpen,
      failedMessageData,
      unReadCount,
      resendingMessageId
    } = this.state;
    const badgeContent = notificationCount + unReadCount;
    const currentLang = localStorage.getItem('i18nextLng');
    const open = Boolean(anchorEl);
    const openNotification = Boolean(anchorElNotification); //Added by Naresh | DI-461 | Date:16-04-2019
    // const lang = localStorage.getItem('i18nextLng') || 'en';
    const selected_location_name = localStorage.getItem('selected_location_name');
    const groupName = sessionStorage.getItem('groupName');
    let _isRetail = localStorage.getItem('isRetail');

    const cardOpt = [
      { id: 1, value: "34eb3711-40ae-42c5-99f4-16970ba9467b", label: t("Consult.DriverLicense") },
      { id: 2, value: "007bdf83-dcfb-48db-b33b-9a1fe410270e", label: t("Consult.Passport") },
      { id: 3, value: "a0fcb2c6-fa97-4e3e-8517-7e8aec217690", label: t("Consult.StateID") },
      { id: 4, value: "43542fe2-326d-42cb-9208-534a76f3d97c", label: t("Consult.MilitaryID") },
      { id: 7, value: "11fe0c8c-272f-4752-ba3f-7d79a2ce4066", label: t("Consult.Other") },
    ];

    const relationshipOpt = [
      { id: 1, value: "Patient", label: t("Report.Stocked.ManualOverride.Patient") },
      { id: 2, value: "Parent/Legal Gardian", label: t("Report.Stocked.ManualOverride.PatientLegalGardian") },
      { id: 3, value: "Spouse", label: t("Report.Stocked.ManualOverride.Spouse") },
      { id: 4, value: "Other", label: t("Report.Stocked.ManualOverride.Other") },
    ];

    return (
      <div className={classes.root}>
        {isInProgress ? (
          <div className={classes.preferredLocationLoader}>
            <Box
              component="img"
              sx={{
                width: 100,
              }}
              className={classes.preferredLocationLoaderImage}
              alt="locationBackground"
              src={defaultLoader}
            />
          </div>
        ) : null}
        {notificationDetails && (
          <UserPopUpNotification
            notificationDetails={this.state.notificationDetails}
            isOpen={isOpen}
            closePopup={this.handleClosePopUp}
            reload={this.handleReload}
            handelOnChangeCheckBox={this.handleCheckbox}
            checked={this.state.checked}
          />
        )}
        {/* Multi-tab warning dialog */}
        <Dialog
          open={(this.context && this.context.multiTabWarningOpen) || false}
          aria-labelledby="multi-tab-warning-dialog-title"
          aria-describedby="multi-tab-warning-dialog-description"
          PaperProps={{
            sx: {
              borderRadius: '12px',
              minWidth: '420px',
              maxWidth: '480px',
              overflow: 'hidden',
              boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
              transform: 'translate(0px, 0px) scale(1)',
              opacity: 1,
              transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
              ...(this.context && this.context.isDismissing && {
                transform: this.context.iconPosition 
                  ? `translate(${this.context.iconPosition.translateX}px, ${this.context.iconPosition.translateY}px) scale(0.05)`
                  : 'translate(400px, -300px) scale(0.05)',
                opacity: 0,
              }),
            }
          }}
          slotProps={{
            backdrop: {
              sx: {
                transition: 'opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                ...(this.context && this.context.isDismissing && {
                  opacity: '0 !important',
                }),
              }
            }
          }}
        >
          <DialogTitle 
            id="multi-tab-warning-dialog-title" 
            sx={{ 
              background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              py: 1.75,
              px: 2.5,
              mb: 1,
            }}
          >
            <WarningAmberIcon sx={{ fontSize: '1.6rem' }} />
            <span style={{ fontWeight: 600, fontSize: '1.1rem' }}>
              {t("MultiTab.WarningTitle")}
            </span>
          </DialogTitle>
          <DialogContent sx={{ pt: 3, pb: 1.5, px: 2.5 }}>
            <DialogContentText 
              id="multi-tab-warning-dialog-description"
              sx={{ 
                color: '#424242',
                fontSize: '0.9rem',
                lineHeight: 1.6,
                m: 0,
              }}
            >
              {t("MultiTab.WarningMessage")}
              <br /><br />
              {t("MultiTab.WarningAction")}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 2.5, pb: 2, pt: 0.5, justifyContent: 'flex-end' }}>
            <Button 
              onClick={() => this.context && this.context.dismissWarning()} 
              variant="contained"
              autoFocus
              sx={{
                background: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
                color: '#fff',
                fontWeight: 600,
                px: 3.5,
                py: 0.75,
                borderRadius: '6px',
                textTransform: 'none',
                fontSize: '0.9rem',
                boxShadow: '0 2px 8px rgba(255,152,0,0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #f57c00 0%, #e65100 100%)',
                  boxShadow: '0 4px 12px rgba(255,152,0,0.4)',
                }
              }}
            >
              {t("MultiTab.OkButton")}
            </Button>
          </DialogActions>
        </Dialog>
        
        <Dialog
          open={this.state.refreshServiceWorker}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {t("Home.ServiceWorkerPopup.PerformanceOptMessage")}
              <br />
              {t("Home.ServiceWorkerPopup.LetsRefreshPageMessage")}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={this.handleSkipEvent}
              className={classes.buttonFace}
            >
              {t("Home.ServiceWorkerPopup.SKIP")}
            </Button>
            <Button
              onClick={() => this.handleVideoFaultRefreshAction(0)}
              className={classes.buttonFace}
            >
              {t("Home.ServiceWorkerPopup.Refresh")}
            </Button>
          </DialogActions>
        </Dialog>
        {this.state && this.state.consultpermission === true
          && [false, "false", undefined, "undefined", null, "null", "",].includes(_isRetail) ? (
          <Dialog
            open={this.state.consultAcknowledgeDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText className={classes.DialogText}>
                {t("Home.ConsultPopup.DoYouWantEnableConsult")}
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.ButtonAlign}>
              <Button
                onClick={() =>
                  this.setState({ consultAcknowledgeDialog: false }, () => {
                    localStorage.setItem("consultAcknowledgeShowed", true);
                  })
                }
                className={classes.buttonFace}
              >
                {t("Home.ConsultPopup.NotNow")}
              </Button>
              <Button
                onClick={this.handleConsultAcknowledgeDialog}
                className={classes.buttonFace}
              >
                {t("Home.ConsultPopup.Yes")}
              </Button>
            </DialogActions>
          </Dialog>
        ) : (
          ""
        )}

        <Dialog
          open={this.state.showChangePasswordDialog || false}
          onClose={(event, reason) => {
            if (reason === 'backdropClick') return;
            this.handleClose();
          }}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {t("Home.ChangePassPopup.ChangePasswordTitle")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("Home.ChangePassPopup.ValidationMessage")}
              <br />
              <span>{t("Home.ChangePassPopup.PassCannotBeOneOfLast")}</span>
              <br />
              <span className={classes.errorText}>
                {this.state.errorMessage}
              </span>
            </DialogContentText>
            <TextField
              autoFocus
              className={classes.halfTextField}
              margin="normal"
              id="current_password"
              label={t("Home.ChangePassPopup.CurrentPassword")}
              placeholder=""
              type="password"
              onChange={this.handleFieldChange}
              onBlur={this.handleFieldChange}
              fullWidth
              inputProps={{
                name: 'random-name',
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              variant="standard"
            />
            <TextField
              className={classes.halfTextField}
              margin="normal"
              id="new_password"
              label={t("Home.ChangePassPopup.NewPassword")}
              type="password"
              onChange={this.handleFieldChange}
              fullWidth
              inputProps={{
                name: 'random-name',
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              variant="standard"
            />

            <TextField
              className={classes.halfTextField}
              margin="normal"
              id="confirm_new_password"
              label={t("Home.ChangePassPopup.ConfirmPassword")}
              type="password"
              error={
                this.state.confirm_new_password_error &&
                this.state.confirm_new_password_error.length > 0
              }
              helperText={this.state.confirm_new_password_error}
              onChange={this.handleFieldChange}
              fullWidth
              inputProps={{
                name: 'random-name',
                autocomplete: 'new-password',
                form: {
                  autocomplete: 'off',
                },
              }}
              variant="standard"
            />

            <br />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              className={classes.primaryButton}
            >
              {t("Home.ChangePassPopup.Cancel")}
            </Button>
            <Button
              onClick={this.handleSubmit}
              className={classes.primaryButton}
            >
              {t("Home.ChangePassPopup.ChangePassword")}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Secure badge download popup starts */}

        <Dialog
          open={(this.state.showSecureBadgeCode && this.state.qrCodeImg !== '')}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            <IconButton
              aria-label="close"
              onClick={this.handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '130px',
                  }}
                >
                  <img
                    alt={t("Home.SecureBadgePopup.YourSecureBadge")}
                    src={secureBadgeImg}
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    padding: 2,
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    variant="h3"
                    component="h3"
                    sx={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '30px', color: '#3A414A' }}
                  >
                    {t("Home.SecureBadgePopup.instruction1")}
                  </Typography>


                  <Typography
                    variant="h5"
                    component="h5"
                    sx={{ fontSize: '1.1rem' }}
                  >
                    {t("Home.SecureBadgePopup.instruction2")}
                  </Typography>
                </Box>
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    padding: 2,
                    textAlign: 'center',
                  }}
                >
                  <FormControl component="fieldset">
                    <RadioGroup aria-label="options" name="secureBadgeUserType" value={this.state.secureBadgeAction} onChange={this.handleSecureBadgeUserAction} >
                      <FormControlLabel value="print" control={<Radio />} label={t("Home.SecureBadgePopup.Print")} sx={{ '& .MuiFormControlLabel-label': { fontSize: '1.2rem' } }} />
                      <FormControlLabel value="download" control={<Radio />} label={t("Home.SecureBadgePopup.Download")} sx={{ '& .MuiFormControlLabel-label': { fontSize: '1.2rem' } }} />
                      <FormControlLabel value="email" control={<Radio />} label={t("Home.SecureBadgePopup.Email")} sx={{ '& .MuiFormControlLabel-label': { fontSize: '1.2rem' } }} />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

          </DialogContent>
          <DialogActions style={{ justifyContent: "end", marginRight: '80px', marginBottom: '20px' }} sx={{ marginRight: '0px', marginBottom: '0px' }}>
            <Button
              onClick={(e) => {
                this.setState({ loader: true, errorMessage: "" });
                this.handleSecureBadgeConfirm()
              }}
              style={{
                backgroundColor: '#6DB1FF',
                borderRadius: '14px',
                border: '3px solid #0a5d66',
                width: '130px',
                fontSize: '1.2rem'
              }}
            >
              {t("Home.SecureBadgePopup.Confirm")}
            </Button>
          </DialogActions>
        </Dialog>



        {/* Loader space     */}
        {this.state.loader && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.3)",
              zIndex: "999999",
            }}
          >
            <img
              src={defaultLoader}
              alt="Processing"
              style={{
                position: "absolute",
                top: "50%",
                width: "100px",
                zIndex: "999999999",
              }}
            />
          </div>
        )}
        {/* Loader space     */}




        {this.state.qrCodeImg && (<Box component='div' id='print_secure_badge_qr' className='secure-badge-print-modal'>
          <PrintTemplate>
            <Box className='modal-dialog'>
              <Dialog
                open={this.state.printSecureBadgeQR || false}
                PaperProps={{
                  sx: { borderRadius: '0px', width: '320px', height: '400px' },
                }}
              >
                <Box className='modal-content'>
                  <DialogContent className='modal-body' sx={{ p: '10px' }}>
                    <Box component="div" id="printableArea" className={classes.boxDesign}>
                      <Box
                        component="img"
                        className="secure-badge-print-image"
                        sx={{
                          width: 300,
                          height: 300,
                          display: 'flex',
                          justifyContent: 'center',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          boxShadow: 3,
                        }}
                        alt={t("Home.SecureBadgePopup.YourSecureBadge")}
                        src={this.state.qrCodeImg}
                      />
                    </Box>
                  </DialogContent>
                </Box>
              </Dialog>
            </Box>
          </PrintTemplate>
        </Box>)}



        {/* Secure badge download popup ends*/}

        <AppBar
          component="nav"
          style={{
            backgroundColor: "#2d9bd1",
            zIndex: 9999,
            textAlign: "right",
            padding: "0px 15px",
          }}
          id="react-no-print"
        >
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
            style={{ fontSize: "1em" }}
            id="react-no-print"
          >
            {![undefined, undefined, null, null, ""].includes(groupName) ? (<span>
              {t("Groups.Dialog.Title")}:
              &nbsp;
              <span
                style={{ cursor: "pointer" }}
                onClick={this.getLocationsByAccount}
              >
                <b>{groupName}</b>
              </span>
              &nbsp;
              <b>|</b>
              &nbsp;
            </span>) : null}

            {t("Home.Location.YourworkingAt")}
            &nbsp;
            <span
              style={{ cursor: "pointer" }}
              onClick={() => this.getLocationsByAccount(true)}
            >
              <b>{selected_location_name}</b>
            </span>
          </Typography>
        </AppBar>
        <AppBar
          id="react-no-print"
          position="absolute"
          className={classNames(
            classes.appBar,
            this.state.open && classes.appBarShift
          )}
        >
          <Toolbar disableGutters>
            <IconButton
              aria-label="open drawer"
              onClick={
                !this.state.open
                  ? this.handleDrawerOpen
                  : this.handleDrawerClose
              }
              className={classNames(classes.menuButton)}
            >
              <MenuIcon />
            </IconButton>
            <Box component="div" className={classes.flex} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="title" noWrap style={{ color: "white" }}>
                {t("Navbar.RxConnect")}
              </Typography>
              {
                [
                  false,
                  "false",
                  undefined,
                  "undefined",
                  null,
                  "null",
                  "",
                ].includes(_isRetail) && (
                  <Typography
                    variant="title"
                    noWrap
                    sx={{
                      ml: "6.5rem",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: 400,
                      fontSize: "1rem",
                      lineHeight: 1.5,
                      letterSpacing: "0.00938em",
                    }}
                    onClick={this.handleAutomationMenu}
                  >
                    {t("Navbar.Automation")}
                  </Typography>
                )}
              {currentLang === "en" &&
                [
                  false,
                  "false",
                  undefined,
                  "undefined",
                  null,
                  "null",
                  "",
                ].includes(_isRetail) && (
                  <Typography
                    variant="title"
                    noWrap
                    sx={{
                      ml: "1.5rem",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: 400,
                      fontSize: "1rem",
                      lineHeight: 1.5,
                      letterSpacing: "0.00938em",
                    }}
                  >
                    <Link
                      to="/home/taskmanager"
                      style={{
                        textDecoration: "none",
                        color: "white",
                      }}
                    >
                      {t("Navbar.Task")}
                    </Link>
                  </Typography>
                )}
              {(
                <Menu
                  anchorEl={this.state.anchorAutomationEl}
                  id="AutomationMenu"
                  keepMounted
                  open={Boolean(this.state.anchorAutomationEl)}
                  onClose={() => this.setState({ anchorAutomationEl: null })}
                  onClick={() => this.setState({ anchorAutomationEl: null })}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 4.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <Link
                    to="/home/automation"
                    style={{
                      textDecoration: "none",
                      color: "#232323",
                    }}
                  >
                    <MenuItem>
                      <ListItemIcon>
                        <AttachEmail fontSize="small" />
                      </ListItemIcon>
                      {t("Navbar.Email")}
                    </MenuItem>
                  </Link>
                </Menu>
              )}
            </Box>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* Added By : Belani Jaimin */}
              {showTroubleTitle ? (
                <div
                  onClick={this.handleShowWarning}
                  style={{
                    marginRight: "10px",
                    background: "red",
                    border: "1px solid red",
                    padding: "5px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  {t("Home.ServiceWorkerPopup.ErrorMessage_1")}
                </div>
              ) : null}
              {this.state && this.state.consultpermission === true
                && [false, "false", undefined, "undefined", null, "null", "",].includes(_isRetail) ? (
                <React.Fragment>
                  {/* Device issue warning icon - shows when there are unresolved device issues */}
                  {this.state.deviceIssues && this.state.deviceIssues.length > 0 && (
                    <IconButton
                      onClick={this.handleDeviceIssueIconClick}
                      sx={{ 
                        mr: 1,
                        backgroundColor: '#fff3cd',
                        border: '1px solid #ffc107',
                        '&:hover': {
                          backgroundColor: '#ffe69c',
                        }
                      }}
                      title={t("DeviceIssue.WarningTitle", { defaultValue: "Device issue detected - click for details" })}
                      size="small"
                    >
                      <WarningAmberIcon sx={{ color: '#856404', fontSize: '1.2rem' }} />
                    </IconButton>
                  )}
                  {this.state.consultToggleLoading && (
                    <CircularProgress size={16} thickness={5} sx={{ mr: 1, color: 'inherit' }} />
                  )}
                  <FormControlLabel
                    label={t("Navbar.Consult")}
                    sx={{ mr: 0 }}
                    control={
                      <Switch
                        classes={{
                          switchBase: classes.iOSSwitchBase,
                          bar: classes.iOSBar,
                          icon: classes.iOSIcon,
                          iconChecked: classes.iOSIconChecked,
                          checked: classes.iOSChecked,
                        }}
                        checked={this.state.checkedB}
                        disabled={this.state.consultToggleLoading}
                        onChange={(e) =>
                          this.handleSwitchChange(e.target.checked)
                        }
                      />
                    }
                  />
                  {currentLang === "en" && (
                    <Typography
                      component="span"
                      sx={{ m: "0 15px 0 15px", cursor: "pointer" }}
                      onClick={this.handleOpenConsultSettingsPopup}
                      data-tour="consult-settings"
                    >
                      {"Consult Settings"}
                    </Typography>
                  )}
                  {/* Multi-tab warning icon */}
                  {this.context && this.context.multiTabDetected && (
                    <IconButton
                      ref={(ref) => this.context && this.context.setIconRef && this.context.setIconRef(ref)}
                      onClick={this.context.showWarning}
                      sx={{ 
                        ml: 1,
                        backgroundColor: '#fff3cd',
                        border: '1px solid #ffc107',
                        '&:hover': {
                          backgroundColor: '#ffe69c',
                        }
                      }}
                      title={t("MultiTab.WarningTitle")}
                      size="small"
                    >
                      <WarningAmberIcon sx={{ color: '#856404', fontSize: '1.2rem' }} />
                    </IconButton>
                  )}
                </React.Fragment>
              ) : (
                ""
              )}

              { /* help drawer menu - Mitesh vaghela 4/15/2025 */}
              {/* <IconButton
                aria-owns={openNotification ? "menu-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleCustomerHelp}
                sx={{ mr: "10px" }}
              >
                <Badge 
                  color="success"
                  max={20}
                >
                  <HelpOutlineIcon sx={{ color: "white" }} />
                </Badge>
              </IconButton> */}
              { /* help drawer menu */}


              {/* Modified by Naresh | DI-461 | Date:16-04-2019  */}
              
              {[false, "false", undefined, "undefined", null, "null", "",].includes(_isRetail) ?
                <IconButton
                  aria-owns={openNotification ? "menu-appbar" : null}
                  aria-haspopup="true"
                  onClick={(e) => {
                    this.handleOpenNotificationMenu(e);
                    this.getFailedMessages();
                  }}
                  sx={{ mr: "10px" }}
                >
                  <Badge
                    badgeContent={badgeContent}
                    color="success"
                    max={20}
                  >
                    <BellIcon sx={{ color: "white" }} />
                  </Badge>
                </IconButton> : ""}
              {typeof notificationData === "object" &&
                notificationData !== null && (
                  <NotificationWrapperComponent
                    anchorEl={anchorElNotification}
                    openMenu={openNotification}
                    closeMenu={this.handleCloseNotificationMenu}
                    notificationData={notificationData}
                    failedMessageData={failedMessageData}
                    handleResendMessage={this.handleResendMessage}
                    resendingMessageId={resendingMessageId}
                  />
                )}
              {/* End Naresh | DI-461 */}
              <IconButton
                aria-owns={open ? "menu-appbar" : null}
                aria-haspopup="true"
                onClick={this.handleMenu}
              >
                {/* <AccountCircle /> */}
                {/* { !this.state.userData && <Avatar alt="UserAvatar" src={avatarProfile} className={classes.avatar} />} */}
                {this.state.userData && (
                  <Avatar
                    alt="UserAvatar"
                    src={
                      this.state.userData &&
                        this.state.userData.length &&
                        this.state.userData.length > 0 &&
                        this.state.userData[0] &&
                        this.state.userData[0].picture_url
                        ? this.state.userData[0].picture_url
                        : this.state.ilocalboxAvatarprofile
                    }
                    className={classes.avatar}
                  />
                )}
              </IconButton>
              <Typography
                variant="subheading"
                className={classes.userName}
                onClick={this.handleMenu}
                sx={{ pr: "6px" }}
              >
                {JSON.parse(sessionStorage.getItem("user")) &&
                  JSON.parse(sessionStorage.getItem("user")).signInUserSession ? (
                  <span>
                    <span>
                      {
                        (sessionStorage.getItem('user.firstname') || sessionStorage.getItem('user.lastname')) ?
                          `${sessionStorage.getItem('user.firstname')} ${sessionStorage.getItem('user.lastname')}` :
                          JSON.parse(sessionStorage.getItem("user"))
                            .signInUserSession.idToken.payload.name
                      }
                    </span>
                    <p style={{ marginTop: "-32px" }}>
                      {sessionStorage.getItem("parentAccountName")}
                    </p>
                  </span>
                ) : (
                  setTimeout(
                    () => this.props.navigate("/", { replace: true }),
                    0
                  )
                )}
              </Typography>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                open={Boolean(open)}
                onClose={this.handleClose_menu}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 7.3,
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
              >
                <MenuItem onClick={this.handleChangePasswored}>
                  {t("Navbar.ChangePassword")}
                </MenuItem>
                <MenuItem onClick={this.handleSubmitCreateSecureBadge}>
                  {t("Navbar.SecureBadge")}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    const pathname = window.location.pathname || '';
                    if (pathname.endsWith('/manage/users/1')) {
                      navigate('/home/manage/users');
                      setTimeout(() => navigate('/home/manage/users/1'), 0);
                    } else {
                      navigate('/home/manage/users/1');
                    }
                  }}
                >
                  {t("Navbar.Preferences")}
                </MenuItem>
                {this.renderBillingMenuItem()}
                <MenuItem onClick={this.signOut}>
                  {t("Navbar.SignOut")}
                </MenuItem>
              </Menu>
            </div>
            <IconButton
              className={classes.signOutButton}
              onClick={this.signOut}
            >
              <SignOutIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div id="react-no-print">
          {(
            <Drawer
              variant="permanent"
              classes={{
                paper: classNames(
                  classes.drawerPaper,
                  !this.state.open && classes.drawerPaperClose
                ),
              }}
              open={this.state.open}
            >
            <div id="react-no-print" className={classes.toolbar}>
              <IconButton onClick={this.handleDrawerClose}>
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </div>
            <Divider />
            <List style={{ paddingBottom: "0px" }}>{mailFolderListItems}</List>
            <List style={{ paddingTop: "10px", paddingBottom: "0px" }}>
              <ReportLink isVisible={this.state.isUnplugged} />
            </List>
            <Divider />
            <List style={{ paddingTop: "0px" }}>
              {otherMailFolderListItems}
            </List>
            <List style={{ paddingTop: "0px" }}>
              <ManagemenuLink
                onStartTour={this.handleStartTour}
                hasCounterLocations={this.state.hasCounterLocations}
              />
            </List>
          </Drawer>
          )}
        </div>
        <main
          className={
            !this.state.open
              ? classes.contentWithMiniLeftNav
              : classes.content
          }
        >
          <div className={classes.toolbar} />

          {children}

          {(
            <BottomNavigation
              id="react-no-print"
              value={value}
              onChange={this.handleBottomNavChange}
              showLabels
              className={classes.bottomNav}
            >
            <BottomNavigationAction
              label="Dashboard"
              icon={<DashboardIcon />}
            />
            <BottomNavigationAction
              label="Assign"
              icon={<AssignPrescriptionIcon />}
            />
            <BottomNavigationAction
              label="Review"
              icon={<ReviewPrescriptionIcon />}
            />
            <BottomNavigationAction
              label="Stock"
              icon={<StockPrescriptionIcon />}
            />
          </BottomNavigation>
          )}
        </main>

        {/*
          Added : By Belani jaimin
          Added Date : 01/16/2019
          Description : Open dialog for consult
        */}
        {!!!this.state.startConsult && (
          <Dialog
            open={this.state.consultOpen}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                this.handleConsultClose();
              }
            }}
            classes={{ paper: classes.consultDialogBox }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div>
              <DialogTitle
                className={classes.consultDialogTitle}
                id="alert-dialog-title"
              >
                {t("Home.StartConsultPopup.CallingFrom")}{" "}
                <span className={classes.consultLocationName}>
                  {this.state.Notifications.store_name}
                </span>
              </DialogTitle>
              <DialogContent>
                <div className={classes.consultDialogDataContainer}>
                  {this.state.Notifications &&
                    this.state.Notifications.picture_url &&
                    this.state.Notifications.picture_url !== "" &&
                    this.state.Notifications.picture_url !== null &&
                    this.state.Notifications.picture_url !== "null" &&
                    this.state.Notifications.picture_url !== undefined &&
                    this.state.Notifications.picture_url !== "undefined" ? (
                    <img
                      src={this.state.Notifications.picture_url}
                      alt={this.state.PatientName}
                      className={classes.consultDialogPatientImage}
                    />
                  ) : (
                    <img
                      src={this.state && this.state.ilocalboxAvatarprofile}
                      alt="ilocalboxAvatarlogo"
                      className={classes.consultDialogPatientImage}
                    />
                  )}
                  <DialogContentText className={classes.consultDialogText}>
                    {this.state.PatientName}{" "}
                    {t("Home.StartConsultPopup.RequestConsultPatientName")}
                  </DialogContentText>
                  {this.state.loader ? (
                    <div className={classes.loader}>
                      <img
                        className={classes.loaderImage}
                        src={wait}
                        alt="Processing"
                      />
                    </div>
                  ) : null}
                  {this.state.consultError && (
                    <Typography className={classes.errorText}>
                      {this.state.consultError}
                    </Typography>
                  )}
                </div>
              </DialogContent>
              <DialogActions className={classes.consultDialogButtons}>
                <Button onClick={this.declineConsultCall}>
                  <h2>{t("Home.StartConsultPopup.Decline")}</h2>
                </Button>
                <Button
                  disabled={this.state.isButtonDisabled || !!this.state.consultError}
                  onClick={this.acceptConsultCall}
                >
                  <h2>{t("Home.StartConsultPopup.Accept")}</h2>
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        )}


        {this.state.showConsultAudioPermissionDialog && (
          <Dialog
            open={this.state.showConsultAudioPermissionDialog}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                this.handleConsultAudioPermissionDisable();
              }
            }}
            classes={{ paper: classes.consultDialogBox }}
            aria-labelledby="audio-permission-dialog-title"
            aria-describedby="audio-permission-dialog-description"
          >
            <div>
              <DialogTitle
                className={classes.consultDialogTitle}
                id="audio-permission-dialog-title"
              >
                {t("Home.ConsultAudioPermission.Title", "Ready to Take Consultations?")}
              </DialogTitle>
              <DialogContent>
                <div className={classes.consultDialogDataContainer}>
                  <DialogContentText className={classes.consultDialogText} id="audio-permission-dialog-description">
                    {t(
                      "Home.ConsultAudioPermission.Body1",
                      "Click Enable Consultation to activate call alerts with sound."
                    )}
                  </DialogContentText>
                  <DialogContentText className={classes.consultDialogSecondaryText}>
                    {t(
                      "Home.ConsultAudioPermission.Body2",
                      "Keep seeing this? Allow sound permission for this site in your browser settings."
                    )}
                  </DialogContentText>
                </div>
              </DialogContent>
              <DialogActions className={classes.consultDialogButtons}>
                <Button
                  onClick={this.handleConsultAudioPermissionDisable}
                  variant="outlined"
                  color="inherit"
                  size="medium"
                >
                  {t("Home.ConsultAudioPermission.TurnOff", "Turn Off Consultation")}
                </Button>
                <Button
                  onClick={this.handleConsultAudioPermissionEnable}
                  variant="contained"
                  size="medium"
                  sx={{ backgroundColor: 'dodgerblue', '&:hover': { backgroundColor: '#1a7fd4' } }}
                >
                  {t("Home.ConsultAudioPermission.Enable", "Enable Consultation")}
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        )}

        <Dialog
          open={this.state.startConsult}
          onClose={this.handleConsultClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: { borderRadius: "5px", maxWidth: "100%", width: "90%" },
          }}
        >
          <div style={{ background: "transperent" }}>
            <div>
              <div
                style={{
                  height: "70px",
                  textAlign: "left",
                  padding: "20px",
                  fontSize: "1.5em",
                  fontWeight: 500,
                  backgroundColor: "#00a7e1 !important",
                  boxShadow:
                    "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
                  color: "#fff !important",
                  position: "relative",
                }}

              >
                <div id="alert-dialog-title" style={{ display: "flex" }}>
                  <Typography variant="title" noWrap className={classes.flex}>
                    {t("Home.StartConsultPopup.ConsultRoom")}{" "}
                    {this.state.Pickupcode} - {this.state.PatientName}
                  </Typography>
                  <Typography variant="subtitle2" noWrap className={classes.flex}>
                  {t("Accounts.Account")}: {this.state.accountName}
                  </Typography>
                  <Typography variant="subtitle2" noWrap className={classes.flex}>
                  {t("Assign.Location")}: {this.state.boxName}
                  </Typography>
                </div>
                {/* Close button in top-right corner */}
                <IconButton
                  aria-label="close"
                  onClick={
                    this.state.ReleaseOrder || this.state.isNormalConsult
                      ? this.endConsultationSession
                      : () => this.setState({ orderNotReleasedOpen: true })
                  }
                  style={{
                    position: "absolute",
                    right: 12,
                    top: 12,
                    padding: "4px",
                    width: "28px",
                    height: "28px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                    e.currentTarget.style.borderRadius = "4px";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <CloseIcon style={{ fontSize: "20px" }} />
                </IconButton>
              </div>
              <div style={{ display: "flex", flexDirection: "row", marginTop: "1rem" }}>
                <div style={{ width: "40%", borderRight: "2px solid grey", overflow: "auto" }}>
                  <DialogContent style={{ height: "40%" }}>
                    {/* DI-5364: Multi pick-up - show all orders in accordion on left side */}
                    {(this.state.consultationOrdersByPucode && this.state.consultationOrdersByPucode.length > 1) ? (
                      this.state.consultationOrdersByPucode.map((orderGroup, accIdx) => (
                        <Accordion key={orderGroup.pucode || accIdx} defaultExpanded={accIdx === 0} disableGutters elevation={0} sx={{ border: "1px solid #e0e0e0", "&:before": { display: "none" } }}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 40, "&.Mui-expanded": { minHeight: 40 } }}>
                            <Typography variant="subtitle2" fontWeight={600}>Order: {orderGroup.pucode}</Typography>
                          </AccordionSummary>
                          <AccordionDetails sx={{ padding: 0 }}>
                            <Table className={classes.table} size="small">
                              <TableHead className={classNames(classes.TableHead)}>
                                <TableRow>
                                  <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0 }}><b>{t("Home.StartConsultPopup.RxHash")}</b></TableCell>
                                  <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0, width: "170px" }}><b>{t("Home.StartConsultPopup.DrugName")}</b></TableCell>
                                  <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}><b>{t("Home.StartConsultPopup.Dose")}</b></TableCell>
                                  <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}><b>{t("Home.StartConsultPopup.Qty")}</b></TableCell>
                                  <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}><b>{t("Unplugged.SearchPopup.Bin")}</b></TableCell>
                                  <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}><b>{t("Report.Stocked.StockDate")}</b></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>{this.createRow(orderGroup.items)}</TableBody>
                            </Table>
                          </AccordionDetails>
                        </Accordion>
                      ))
                    ) : (
                      <Table className={classes.table}>
                        <TableHead className={classNames(classes.TableHead)}>
                          <TableRow>
                            <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0 }}>
                              <b>{t("Home.StartConsultPopup.RxHash")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.NameCellWidth)} style={{ padding: 0, width: "170px" }}>
                              <b>{t("Home.StartConsultPopup.DrugName")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}>
                              <b>{t("Home.StartConsultPopup.Dose")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}>
                              <b>{t("Home.StartConsultPopup.Qty")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}>
                              <b>{t("Unplugged.SearchPopup.Bin")}</b>
                            </TableCell>
                            <TableCell className={classNames(classes.AmountCell)} style={{ padding: 0 }}>
                              <b>{t("Report.Stocked.StockDate")}</b>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.createRow()}</TableBody>
                      </Table>
                    )}
                    {Array.isArray(this.state.PatietPrescriptionData) &&
                      this.state.PatietPrescriptionData.some(row => row.is_controlled_substance === true) && (
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            bgcolor: '#FFF7ED',
                            border: '1px solid #FDBA74',
                            mr: 0.75,
                          }}
                        />
                        <Tooltip title={t("Home.StartConsultPopup.ControlledSubstanceLegend")}>
                          <Typography variant="caption" color="textSecondary">
                            {t("Home.StartConsultPopup.ControlledSubstanceLegend")}
                          </Typography>
                        </Tooltip>
                      </Box>
                    )}
                  </DialogContent>
                  <DialogContent>
                    {/* <Typography variant="subtitle2" noWrap className={classes.flex}>
                      Stocked on: {this.convertToTimeZone(this.state.stockDate)}
                    </Typography> */}
                    <Typography variant="title" noWrap className={classes.flex}>
                      {" "}
                      {t("Home.StartConsultPopup.ConsultNotes")}
                    </Typography>
                    <TextareaAutosize
                      style={{
                        minHeight: 130,
                        maxHeight: 130,
                        width: "100%",
                        boxSizing: "border-box",
                        border: "1px solid rgba(224, 224, 224, 1)",
                        fontSize: "0.8125rem",
                        fontWeight: "400",
                        padding: "10px",
                        fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                        color: "rgba(0, 0, 0, 0.87)",
                      }}
                      //placeholder="Consultaion Notes"
                      onBlur={this.handleChangeConsultNotes}
                      onChange={this.handleChangeConsultNotes}
                      label="Consultation Notes"
                      value={this.state.consultnotes}
                    />
                  </DialogContent>
                  {!!!this.state.isNormalConsult && (
                    <DialogContent style={{ padding: '0px 10px' }}>
                      <div>
                        <FormControlLabel
                          label={t("Home.StartConsultPopup.ReleaseOrder")}
                          control={
                            <Checkbox
                              disabled={this.state.ReleaseOrder}
                              checked={this.state.ReleaseOrder}
                              onChange={() => this.handleReleaseOrder("")}
                              value={this.state.ReleaseOrder}
                            />
                          }
                          style={{ marginLeft: "0px", marginRight: "0px" }}
                        />
                      </div>
                    </DialogContent>
                  )}
                </div>
                <div style={{ width: "40%" }}>
                  <DialogContent style={{ marginTop: "-30px" }}>
                    <div
                      id="renderer"
                      className={classes.DialogText}
                      style={{ height: "auto", maxWidth: "100%" }}
                    >
                      {this.state.Pickupcode ? (
                        <TwilioVideo
                          key={`twilio-${this.state.Pickupcode}`}
                          identity={this.state.PatientName || this.state.Pickupcode}
                          prescriptionMasterId={this.state.prescriptionMasterId}
                          roomName={this.state.Pickupcode}
                          existingTwilioRef={this.twilio}
                          onRef={(ref) => (this.twilio = ref)}
                          onRoomDisconnected={this.handleTwilioRoomDisconnected}
                          onRemoteAudioStream={(stream) => this.setState({ remoteAudioStreamForVisualizer: stream })}
                          t={t}
                          submitSelectedRejection={this.submitSelectedRejection}
                          setSelectedReasonText={this.setSelectedReasonText}
                          selectedReasonId={selectedReasonId}
                          selectedReasonText={selectedReasonText}
                          setIdCaptureType={this.setIdCaptureType}
                          isAudioOnlyConsult={this.state.isAudioOnlyConsult}
                        />
                      ) : (
                        <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                          Waiting for consultation room...
                        </div>
                      )}
                      {this.state.isAudioOnlyConsult && this.state.remoteAudioStreamForVisualizer && (
                        <div style={{ marginTop: 12, width: "100%", height: 60 }}>
                          <AudioVisualizer remoteMediaStream={this.state.remoteAudioStreamForVisualizer} />
                        </div>
                      )}
                    </div>
                  </DialogContent>
                </div>
                <div style={{ width: "20%", borderLeft: "2px solid grey", padding: "15px" }}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <DialogContent style={{ display: "flex", flexDirection: "column", padding: 0 }}>
                      <Typography variant="title" noWrap className={classes.flex}>
                        {t("Consult.IdRawData")}
                      </Typography>
                      <TextareaAutosize
                        style={{
                          minHeight: 150,
                          maxHeight: 150,
                          width: "100%",
                          boxSizing: "border-box",
                          border: "1px solid rgba(224, 224, 224, 1)",
                          fontSize: "0.8125rem",
                          fontWeight: "400",
                          padding: "10px",
                          fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                          color: "rgba(0, 0, 0, 0.87)",
                        }}
                        label="Consultation Notes"
                        defaultValue={this.state.IdRawData}
                      />
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={this.state.firstName}
                        id='firstName'
                        name='firstName'
                        label={t('Report.Payroll.PatientDetail.FirstName')}
                        variant='standard'
                        onChange={(e) => this.setState({ firstName: e.target.value })}
                      />
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={this.state.lastName}
                        id='lastName'
                        name='lastName'
                        label={t('Report.Payroll.PatientDetail.LastName')}
                        variant='standard'
                        onChange={(e) => this.setState({ lastName: e.target.value })}
                      />
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={this.state.DLNo}
                        id='DLNo'
                        name='DLNo'
                        label={t('Report.Picked.PatientDetail.IDNo')}
                        placeholder=''
                        variant='standard'
                        onChange={(e) => this.setState({ DLNo: e.target.value })}
                      />
                      <TextField
                        margin="dense"
                        className={classes.halfTextField}
                        value={this.state.dob}
                        id="DOB"
                        name="DOB"
                        label={t('Report.Patient.DOB')}
                        variant="standard"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={(e) => this.setState({ dob: e.target.value })}
                        InputProps={{
                          inputComponent: TextMaskCustom
                        }}
                      />
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={this.state.stateCode}
                        id='StateCode'
                        name='StateCode'
                        label={t('Consult.StateCode')}
                        variant='standard'
                        onChange={(e) => this.setState({ stateCode: e.target.value })}
                      />
                      <TextField
                        margin='dense'
                        className={classes.halfTextField}
                        value={this.state.expDate}
                        id='ExpDate'
                        name='ExpDate'
                        label={t('Consult.ExpDate')}
                        variant='standard'
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={(e) => this.setState({ expDate: e.target.value })}
                        InputProps={{
                          inputComponent: TextMaskCustom
                        }}
                      />
                      <InputLabel htmlFor="type_id" style={{ marginTop: "1rem" }}>
                        {t("Consult.Relationship")}
                      </InputLabel>
                      <Select
                        value={this.state.relationship}
                        onChange={(e) => this.setState({ relationship: e.target.value })}
                        inputProps={{
                          name: "type_id",
                          id: "type_id",
                        }}
                        variant="standard"
                        style={{ marginTop: "4px" }}
                      >
                        {relationshipOpt &&
                          relationshipOpt.map((type, index) => (
                            <MenuItem
                              key={index}
                              value={type.value}
                              selected
                              className={classes.menuItem}
                              sx={{ height: "46px" }}
                            >
                              {type.label}
                            </MenuItem>
                          ))}
                      </Select>
                      <InputLabel htmlFor="type_id" style={{ marginTop: "1rem" }}>
                        {t("Consult.CardType")}
                      </InputLabel>
                      <Select
                        value={this.state.cardType}
                        onChange={(e) => this.setState({ cardType: e.target.value })}
                        inputProps={{
                          name: "type_id",
                          id: "type_id",
                        }}
                        variant="standard"
                        style={{ marginTop: "4px" }}
                      >
                        {cardOpt &&
                          cardOpt.map((type, index) => (
                            <MenuItem
                              key={index}
                              value={type.value}
                              selected
                              className={classes.menuItem}
                              sx={{ height: "46px" }}
                            >
                              {type.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </DialogContent>
                  </div>
                </div>
              </div>
              {this.state.consultError && (
                <div style={{ display: "flex", flexDirection: "row", marginTop: "1rem" }}>
                  <div style={{ width: "100%", paddingLeft: "24px" }}>
                    <Typography className={classes.errorText}>
                      {this.state.consultError}
                    </Typography>
                  </div>
                </div>
              )}
              <DialogActions style={{ textAlign: "right" }}>
                <Button
                  onClick={
                    this.state.ReleaseOrder || this.state.isNormalConsult
                      ? this.endConsultationSession
                      : () => this.setState({ orderNotReleasedOpen: true })
                  }
                  className={classes.primaryButton}
                >
                  {t("Home.StartConsultPopup.CompleteConsult")}
                </Button>
              </DialogActions>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={this.state.ReleaseOrderOpen}
          onClose={this.handleCloseRleaseOrder}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.DialogContentWrap}>
            <DialogContentText className={classes.DialogText}>
              {t("Home.ReleaseOrderPopup.AreYouSureMessage")}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              className={classes.buttonFace}
              onClick={this.releaseorderaccept}
            >
              {t("Home.ReleaseOrderPopup.Yes")}
            </Button>
            <Button
              disabled={this.state.isButtonDisabled}
              className={classes.buttonFace}
              onClick={this.handleCloseRleaseOrder}
            >
              {t("Home.ReleaseOrderPopup.No")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.orderNotReleasedOpen}
          onClose={this.handleConsultClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className={classes.DialogContentWrap}>
            <DialogContentText className={classes.DialogText}>
              {t("Home.OrderNotReleasePopup.HaveNotReleaseMessage")}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              className={classes.primaryButton}
              onClick={this.releaseorderaccept}
            >
              {t("Home.OrderNotReleasePopup.ReleaseOrder")}
            </Button>
            <Button
              disabled={this.state.isButtonDisabled}
              className={classes.primaryButton}
              onClick={this.endConsultationSession}
            >
              {t("Home.OrderNotReleasePopup.CompleteConsult")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* handle missed call acknowledgement dialog */}
        <Dialog
          open={this.state.missedCallAckDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {t("Home.StartConsultPopup.missedCall", {
                patientName: this.state.missedCallPatientName
              })}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={this.handleMissedCallAcknowledgement}
              className={classes.buttonFace}
            >
              {t("Home.StartConsultPopup.missedCallConfirmation")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* handle other user accepted the call acknowledgement dialog */}
        <Dialog
          open={this.state.callAcceptedByOtherUser}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {
                // Note: [DI-4984] When multiple users have incoming video consultation call & if a user accepts the call then after changing
                // the code on Websocket side by passing the name of the user who accepted the call then we can include the name of the user 
                // who accepted the call in the dialog instead of 'another user'. 
              }
              {t("Home.StartConsultPopup.callAcceptedByOtherUser", {
                userName: 'another user'
              })}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={this.handleCallAcceptedByOtherUserAcknowledgement}
              className={classes.buttonFace}
            >
              {t("Home.StartConsultPopup.callAcceptedByOtherUserConfirmation")}
            </Button>
          </DialogActions>
        </Dialog>

        {([false, "false", undefined, 'undefined', null, 'null', ''].includes(_isRetail)) ?
          <Dialog
            open={this.state.checkedBDialog && showTestYourBrowserPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText className={classes.DialogText}>
                {t("Home.CheckBPopup.LetsTestBrowserMessage")}

                <FormControlLabel
                  label={t("Home.CheckBPopup.DoNotAskAgain")}
                  control={
                    <Checkbox
                      checked={this.state.browserTestDoNotAskMeAgain}
                      onChange={() => this.handleConsultDoNotAskMeAgain()}
                    />
                  }
                  style={{ marginLeft: "0px", marginRight: "0px" }}
                />

              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.ButtonAlign}>
              <Button
                onClick={() => {
                  this.setState({ checkedBDialog: false });
                  this.handleCloseBtn();
                }}
                className={classes.buttonFace}
              >
                {t("Home.CheckBPopup.NotNow")}
              </Button>
              <Button
                onClick={() =>
                  this.setState({ checkedBDialog: false }, () => {
                    this.handleConsultDiagnostics(true);
                    localStorage.setItem("consultDiagnosticsShowed", true);
                    this.handleCloseBtn();
                  })
                }
                className={classes.buttonFace}
              >
                {t("Home.CheckBPopup.Yes")}
              </Button>
            </DialogActions>
          </Dialog> : ""}

        <div id="react-no-print" className={classes.footer}>
          <div style={{ float: "left" }}>
            <span style={{ fontWeight: 500 }}>
              {" "}
              {t("Home.Footer.Copyright")}
            </span>{" "}
            &copy; 2018 - {new Date().getFullYear()}{" "}
            <a
              target="new"
              style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}
              href="https://ilocalbox.com/"
            >
              {t("Home.Footer.iLocalBox")}
            </a>
            . {t("Home.Footer.AllRightReserved")}
          </div>
          <div style={{ float: "right" }}>
            <label style={{ fontSize: "0.8rem" }}>
              <span style={{ fontWeight: 500 }}>
                {t("Home.Footer.Version")}
              </span>{" "}
              {packageJson.version}
            </label>
          </div>
        </div>
        <Dialog
          open={this.state.showWarning}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText className={classes.DialogText}>
              {t("Home.ServiceWorkerPopup.ErrorMessage_2")}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.ButtonAlign}>
            <Button
              onClick={() => this.handleVideoFaultRefreshAction(1)}
              className={classes.buttonFace}
            >
              {t("Home.ServiceWorkerPopup.Refresh")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={preferredLocation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div>
            <DialogTitle className={classes.preferrendLocationTitle}>
              <IconButton
                onClick={() => this.setState({ preferredLocation: false })}
                title={t("Home.UserPopup.Close")}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText className={classes.DialogText}>
                <div className={classes.preferrendLocationImageParent}>
                  <Box
                    component="img"
                    sx={{
                      width: 100,
                    }}
                    alt="locationBackground"
                    src={localtionImage}
                  />
                </div>
                <div className={classes.preferrendLocationContentTitle}>
                  {t("Home.Location.Title")}
                </div>
                <div className={classes.preferrendLocationContentSubTitle}>
                  {t("Home.Location.SubTitle")}
                </div>
                <div className={classes.preferrendLocationDialogAction}>
                  <SearchableSelect
                    label={t('Assign.Location')}
                    items={boxList.map(box => ({ id: box.id, name: box.value }))}
                    value={selectedBoxId || (boxList && boxList[0] && boxList[0].id)}
                    onChange={this.handleBoxChange}
                    placeholder="Search locations..."
                    id="box_ids"
                    fullWidth={true}
                    sx={{ marginTop: '5px' }}
                    variant="standard"
                  />
                  <Button
                    variant="contained"
                    color="info"
                    onClick={this.handleBoxSelect}
                    className={classes.preferrendLocationDialogActionButtonFace}
                    disabled={isInProgress}
                  >
                    {t("Home.Location.SelectButton")}
                  </Button>
                </div>
                {!hasPreferredLocationSelected ? (
                  <div className={classes.preferredLocationError}>
                    {t("Home.Location.Location.Error")}
                  </div>
                ) : null}
              </DialogContentText>
            </DialogContent>
          </div>
        </Dialog>

        {/* Audio Settings Modal */}
        <ConsultSettingsPopup
          anchorEl={consultSettingsAnchorEl}
          open={!window.location.host.includes(".ca") && consultSettingsIsPopupOpen}
          onClose={this.handleCloseConsultSettingsPopup}
          isAudioOnlyConsult={this.state.isAudioOnlyConsult}
          handleIsAudioOnlyChange={this.handleIsAudioOnlyChange}
          handleDeviceSelectionChange={this.handleDeviceSelectionChange}
        />

        {/* Test Consultation Popup */}
        <TestConsultationPopup
          openTestConsultationPopup={!window.location.host.includes(".ca") && this.state.openConsultDiagnostics}
          handleShowTestConsultation={this.handleConsultDiagnostics}
          loader={this.state.loader}
          handleCloseTestConsultationPopupLoader={this.handleCloseTestConsultationPopupLoader}
        />

        <Dialog
          open={this.state.errorCallAlreadyAcceptedDialog}
          onClose={() => this.setState({ errorCallAlreadyAcceptedDialog: false })}
          aria-labelledby="error-dialog-title"
          aria-describedby="error-dialog-description"
          PaperProps={{
            style: {
              zIndex: 9999
            }
          }}
        >
          <DialogTitle>Consultation Error</DialogTitle>
          <DialogContent>
            <DialogContentText>{this.state.errorCallAlreadyAcceptedMessage}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ errorCallAlreadyAcceptedDialog: false })} color="primary">OK</Button>
          </DialogActions>
        </Dialog>

        {/* Session Expiry Warning Dialog */}
        <Dialog
          open={this.state.showSessionExpiryWarning}
          onClose={() => this.setState({ showSessionExpiryWarning: false })}
          aria-labelledby="session-expiry-warning-title"
          aria-describedby="session-expiry-warning-description"
          PaperProps={{
            style: {
              zIndex: 9999
            }
          }}
        >
          <DialogTitle id="session-expiry-warning-title">Session Expiring Soon</DialogTitle>
          <DialogContent>
            <DialogContentText id="session-expiry-warning-description">
              Your session will expire in approximately 5 minutes. Please save any work in progress.
              You will be automatically logged out when your session expires.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ showSessionExpiryWarning: false })} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <DeviceStatusAlertDialog
          open={this.state.showDeviceStatusAlertDialog}
          title={this.state.showDeviceStatusAlertDialogTitle}
          message={this.state.showDeviceStatusAlertDialogMessage}
          onClose={this.handleDismissDeviceStatusAlert}
          showAudioOnlyButton={this.state.showDeviceStatusAlertDialogAudioOnlyButton}
          onSwitchToAudioOnly={this.handleSwitchToAudioOnlyConsult}
        />

        {/* Device Issues Dialog - shows list of accumulated device issues when warning icon is clicked */}
        <DeviceStatusAlertDialog
          open={this.state.showDeviceIssuesDialog}
          issues={this.state.deviceIssues}
          onClose={this.handleCloseDeviceIssuesDialog}
          onSwitchToAudioOnly={this.handleSwitchToAudioOnlyFromIssuesDialog}
        />
        {this.state.showCallerHungUpModal && (
          <Dialog
            open={this.state.showCallerHungUpModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText className={classes.DialogText}>
                Caller hung up.
              </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.ButtonAlign}>
              <Button
                onClick={(event, reason) => {
                  if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    this.setState({
                      showCallerHungUpModal: false
                    })
                  }
                }}
                className={classes.buttonFace}
              >
                {t("Home.StartConsultPopup.missedCallConfirmation")}
              </Button>
            </DialogActions>
          </Dialog>
        )}

        {/* Call Waiting: Incoming Call Notification - Shows when there are incoming calls */}
        {(() => {
          const hasIncomingCalls = this.state.incomingCalls && this.state.incomingCalls.length > 0;
          const hasActiveConsultation = this.state.startConsult;
          const shouldShow = hasIncomingCalls; // ✅ FIX: Show when there are incoming calls, regardless of startConsult
          
          console.log(`📞 [Call Waiting] Home.render: Checking if should show IncomingCallNotification`, {
            hasIncomingCalls: hasIncomingCalls,
            incomingCallsLength: this.state.incomingCalls ? this.state.incomingCalls.length : 0,
            hasActiveConsultation: hasActiveConsultation,
            startConsult: this.state.startConsult,
            shouldShow: shouldShow
          });
          
          if (shouldShow) {
            console.log(`📞 [Call Waiting] Home.render: ✅ RENDERING IncomingCallNotification`, {
              hasActiveConsultation: hasActiveConsultation,
              incomingCallsCount: this.state.incomingCalls.length,
              incomingCalls: this.state.incomingCalls.map(c => ({ pucode: c.pucode, patientName: c.patientName }))
            });
            return (
              <IncomingCallNotification
                incomingCalls={this.state.incomingCalls}
                hasActiveConsultation={hasActiveConsultation} // ✅ FIX: Pass flag to show conditional actions
                onAccept={this.acceptIncomingCall} // ✅ FIX: Add simple accept callback
                onAcceptAndEnd={this.acceptAndEndCurrentCall}
                onAcceptAndHold={this.acceptAndHoldCurrentCall}
                onSilence={this.silenceIncomingCall}
                onDecline={this.declineIncomingCall}
              />
            );
          } else {
            console.log(`📞 [Call Waiting] Home.render: ❌ NOT rendering - no incoming calls`, {
              hasIncomingCalls: hasIncomingCalls,
              incomingCallsLength: this.state.incomingCalls ? this.state.incomingCalls.length : 0
            });
            return null;
          }
        })()}

        {/* Phase 2: Held Calls Panel - Shows when there are calls on hold */}
        {(() => {
          const hasHeldCalls = this.state.heldCalls && this.state.heldCalls.length > 0;
          
          if (hasHeldCalls) {
            console.log(`📞 [Phase 2] Home.render: ✅ RENDERING HeldCallsPanel`, {
              heldCallsCount: this.state.heldCalls.length,
              heldCalls: this.state.heldCalls.map(c => ({ pucode: c.pucode, patientName: c.patientName }))
            });
            return (
              <HeldCallsPanel
                heldCalls={this.state.heldCalls}
                onResume={this.resumeHeldCall}
                onEnd={this.endHeldCall}
              />
            );
          }
          return null;
        })()}

        {/* Tour Guide Component */}
        <TourGuide
          onRef={(ref) => {
            console.log('[Home] TourGuide onRef callback', {
              timestamp: new Date().toISOString(),
              hasRef: !!ref,
              refType: ref ? ref.constructor.name : 'null'
            });
            this.tourGuideRef.current = ref;
          }}
          navigate={navigate}
          userId={(this.state.loggedInUser && this.state.loggedInUser.username) || (sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).username)}
          tourWelcomeHidden={this.state.tourWelcomeHidden}
          onTourWelcomeHiddenSaved={() => this.setState({ tourWelcomeHidden: true })}
        />
      </div>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(withTranslation()(Home));



// WEBPACK FOOTER //
// ./src/components/home/index.js